
import { knowFromList as T20KnowFromList } from "@/static/T20";
import { knowFromList as T21KnowFromList } from "@/static/T21";
import Formatter from "@/prototype/src/formatter";
import Validate from "@/prototype/src/validate";

// cms: backend
const STAFF_MODEL = { // staff_data
    "name": "name",
    "user_type": "staff_role",
    "schools": "center",
    "gender": "gender",
    "username": "username",
    "password": "password_data",
    "phone": "phone",
    "remark": "remark",
    "salary_level": "salary_level",
    "salary_per_hour": "salary_per_hour",
    "login_block": "login_block",
    "address": "address",
    "birthday": "birthday",
    "hkid": "hkid",
    "marital_status": "marital_status",
    "paying_bank": "paying_bank",
    "bank_account": "bank_account",
    "employment_date": "employment_date",
    "position": "position"
};

const TUTOR_CALENDAR_MODEL = { // staff_extra_time_data
    "school_id": "center_id",
    "tutor_id": "staff_id",
    "date": "date",
    "start_time": "start_time",
    "end_time": "end_time",
}

const SCHOOL_MODEL = { // center_data
    "name": "name",
    "address": "address",
    "logo": "logo",
    "school_code": "center_code",
    "website_and_app": "website_and_app",
    "payment_method": "payment_method",
    "phone": "phone",
    "email": "email",
    "whatsapp_message": "whatsapp_message",
    "member_terms_field": "terms",
    "custom_text": "custom_text",
    "whatsapp_number": "whatsapp_number",
    "month_period": "month_period",
    "admin_notification_email": "notification_email",
    "payment_terms": "payment_terms"
};

const STUDENT_MODEL = { // student_data
    "status": "status",
    "school_id": "center_id",
    "schools": "multi_center",
    "student_name": "student_name",
    "student_eng_name": "student_name_en",
    "student_zh_name": "student_name_zh",
    "nickname": "nickname_en",
    "address": "address",
    "gender": "gender",
    "phone": "phone",
    "birthday": "birthday",
    "username": "username",
    "password": "password_data",
    "contact_person_1_name": "contact_1_name",
    "contact_person_1_phone": "contact_1_phone",
    "contact_person_1_relationship": "contact_1_relationship",
    "contact_person_1_email": "contact_1_email",
    "contact_person_2_name": "contact_2_name",
    "contact_person_2_phone": "contact_2_phone",
    "contact_person_2_relationship": "contact_2_relationship",
    "contact_person_2_email": "contact_2_email",
    "contact_person_3_name": "contact_3_name",
    "contact_person_3_phone": "contact_3_phone",
    "contact_person_3_email": "contact_3_email",
    "student_school_name": "school",
    "member_level": "level",
    "grade": "grade",
    "remark": "remark",
    "student_code": "student_code",
    "apply_date": "apply_date",
    "trial_date": "trial_date",
    "special": "special",
    "grade_soon": "grade_soon",
    "location": "location",
    "school_time": "school_time",
    "enroll_reason": "enrollment_reason",
    "enroll_reason_other": "enrollment_reason_custom",
    "school_type": "school_type",
    "nation": "country",
    "is_membership": "sportify_women_empower_women",
    "have_football_shirt": "football_shirt",
    "have_participate_competition": "competition_participate",
    "admission_source": "admission",
    "special_remind": "special_remind",
    "special_remind_des": "special_remind_des",
    "sign": "sign",
    "agree_video": "agree_video",
    "credit_remark": "credit_remark",
    "avatar": "student_photo",
    "textbook": "textbook",
    "know_from": "know_from",
    "wish_lesson": "wish_lesson",
    "agree_promo": "agreement",
    "student_news": "student_news", // Array<{ date: '', content: '' }>
    "ever_enrolled": "ever_enrolled",
    "siblings": "siblings", // Array<{ student_id: -1, relationship: 'elder_brother' | 'younger_brother' | 'elder_sister' | 'younger_sister' }>
    "class_format": "class_format",
    "hkid": "hkid",
    "email": "email",
    "belong": "region",
    "job_class": "position",
    "join_newbie_passion": "newbie_passion",
    "team_member": "team_member",
    "parent_name": "parent_name",
    "child_1": "child_1",
    "child_1_birth": "child_1_birth",
    "child_2": "child_2",
    "child_2_birth": "child_2_birth",
    "child_3": "child_3",
    "child_3_birth": "child_3_birth",
    "login_block": "login_block",
    "upline_student_code": "top_student_code",
    "id_card_full_name": "top_hkid_name",
    "referee_name": "referee_name",
    "referee_phone": "referee_phone",
    "dap": "dap",
    "dob": "dob",
    "preferred_school": "favorite_school",
    "join_group": "join_group",
    "join_course": "join_course",
    "send_leave_notify": "send_leave_notify", // 不用發送/已發送/請假通知
    "enrollment_date": "enrollment_date",
    "email_2": "email_2",
    "award": "award",
    "belong_family_member": "belong_family_member",
    "weapon_hand": "handle",
    "join_date": "join_date",
};

const STUDENT_SCORE_MODEL = { // score_data
    "student_id": "student_id",
    "exam_name": "name",
    "grade": "grade",
    "semester": "semester",
    "subject": "subject",
    "score": "score",
    "update_date": "update_date",
    "show_public": "show_public",
    "file": "file",
}

const CLASSROOM_MODEL = { // facility_data
    "name": "name",
    "school_id": "center_id",
};

const COURSE_CATEGORY_MODEL = { // course_category_data
    "name": "name",
    "category_code": "category_code",
    "schools": "center",
    "color": "color_hex"
};

const COURSE_MODEL = { // course_data
    "course_code": "course_code",
    "grade": "grade",
    "name": "name",
    "category_id": "course_category_id",
    "schools": "center"
};

// for create lesson
const CLASS_MODEL = { // regular_data
    "course_id": "course_id",
    "course_code": "course_code",
    "course_name": "name",
    "tutor_id": "staff_id",
    "tutor_id_list": "staff_list",
    "classroom_id": "facility_id",
    "color": "color",
    "salary_method": "salary_method", // 'by_lesson' | 'by_student_num'
    "salary_level": "salary_level",
    "multi_salary_level": "multi_salary_level",
    "max_student": "capacity",
    "school_id": "center_id",
    "price": "price",
    "grade": "grade",
    "lesson_type": "lesson_type",
    "thumbnail_image": "thumbnail_image",
    "course_description": "course_description",
    "show_website": "show_website",
    "salary_type": "salary_type",
    "salary_per_hour": "salary_per_hour",
    "salary_percentage": "salary_percentage",

    // For single date lesson
    "single_date": "date",
    "start_time": "start_time",
    "end_time": "end_time",

    // For general date lesson
    "regular_period": "generate_period", //  'weekly' | 'bi-weekly'
    "regular_weekdays": "weekday",
    "start_date": "start_date",
    "end_date": "end_date",
    "weekday_start_time": "weekday_start_time",
    "weekday_end_time": "weekday_end_time",

    // T04
    "school_type": "school_type",

    // T16
    "t16_salary": "fix_salary",
    "t16_salary_percentage": "t16_share",
    "t16_salary_per_hour": "t16_salary_per_hour",
    "t16_salary_type": "t16_salary_type",

    // T21
    "salary_bonus": "bonus"
};

// for edit lesson
const LESSON_MODEL = { // lesson_data
    "date": "date",
    "start_time": "start_time",
    "end_time": "end_time",
    "course_id": "course_id",
    "course_code": "course_code",
    "course_name": "name",
    "tutor_id": "staff_id",
    "tutor_id_list": "staff_list",
    "tutor_attendance": "staff_attendance", // Array<{ staff_id: -1, status: pending | attend | absent, attend_time: "[YYYY-MM-DD]T[HH:MM:SS]Z", confirm_time: "[YYYY-MM-DD]T[HH:MM:SS]Z" }>
    "classroom_id": "facility_id",
    "color": "color",
    "salary_method": "salary_method",
    "salary_level": "salary_level",
    "salary_type": "salary_type", // Array<{ staff_id: -1, type: level | hour | percentage}>
    "multi_salary_level": "multi_salary_level", // Array<{staff_id: -1, level: '' }>
    "salary_per_hour": "salary_per_hour", // 時薪 Array<{ staff: -1, value: 0, min: 0 }>
    "salary_percentage": "salary_percentage", // 導師分成 Array<{ staff: -1, value: 0, min: 0 }>
    "max_student": "capacity",
    "school_id": "center_id",
    "price": "price",
    "grade": "grade",
    "attachment_list": "attachment", // Array<{ name: '', file: '' }>
    "attendance_list": "attendance", // Array<{ student_id: -1, status: 'pending' | 'attend' | 'absent' | 'await' }>
    "thumbnail_image": "thumbnail_image",
    "course_description": "course_description",
    "show_website": "show_website",
    "remark": "remark",

    "dropped_student_ids": "exit",
    "paid_student_ids": "paid",
    "package_used_student_id_list": "package_quote",
    "monthly_used_student_id_list": "monthly_used",

    // T04
    "school_type": "school_type", // all | A | B
    "video_attachment_id": "video_attachment_id",
    "video_attachment_name": "video_attachment_name",
    "video_attachment_url": "video_attachment_url",

    // T16
    "t16_salary": "fix_salary",
    "t16_salary_percentage": "t16_share",
    "t16_salary_per_hour": "t16_salary_per_hour",
    "t16_salary_type": "t16_salary_type",

    // T21
    "salary_bonus": "bonus", // bonus Array<{ staff_id: -1, rnd: 0, performance: 0, attendance: 0 }>
}

const PRODUCT_CATEGORY_MODEL = { // category_data
    "name": "name",
};

const PRODUCT_MODEL = { // product_data
    "name": "name",
    "product_code": "product_code",
    "status": "status",
    "category_id": "category",
    "inventory": "inventory",
    "price": "price",
    "cost": "cost",
    "schools": "center_id",
    "remark": "remark",
    "points": "points"
};

const ONLINE_COURSE_MODEL = { // online_course_data
    "schools": "center",
    "category_id": "course_category_id",
    "name": "title",
    "short_description": "short_description",
    "thumbnail": "thumbnail",
    "price": "price",
    "discount_price": "discount_price",
    "description_content": "description_content",
    "chapter_category_list": "chapter_category_list", // Array<{"title":"", "chapter_id_list":[]]}>
    "tutor_information": "tutor_information", // Array<{"name":"", "description":"", "icon":""}>
    "faq_list": "faq_list", // Array<{"question":"", "answer":""}>
    "status": "status"
};

const ONLINE_COURSE_VIDEO_MODEL = { // online_course_chapter_data
    "schools": "center",
    "title": "chapter_title",
    "online_course_id": "online_course_id",
    "thumbnail": "thumbnail",
    "video_id": "video_id",
    "duration": "duration",
    "description_content": "description_content",
    "homework": "homework",  // Array<{"file":"", "title":""}>
}

const ORDER_MODEL = { // order_data
    "student_id": "student_id",
    "school_id": "center_id",
    "remark": "remark",
    "payment_method": "payment_method",
    "lesson_id_list": "lesson_id_list", // Array<{id: -1, discount_type: '', discount_value: 0}>
    "product_id_list": "product_id_list", // Array<{id: -1, discount_type: '', discount_value: 0, amount: 0}>
    "subtotal": "subtotal",
    "status": "status",
    "discount_type": "discount_type",
    "discount_value": "discount_value",
    "payment_image": "payment_image",
    "payment_image_list": "payment_image_arr",
    "package_id": "package_id",
    "custom_items": "custom_items", // Array<{name: "", description: "", price: 0, amount: 0}>
    "online_course_id": "online_course_id",
    "package_id_list": "package_id_list", // Array<{id: -1, discount_type: '', discount_value: 0}>
    "monthly_id_list": "monthly_id_list", // Array<{id: -1, discount_type: '', discount_value: 0}>
    "pdf_remark": "pdf_remark",
    "order_date": "order_date",
    "pay_date": "pay_date",
    "upload_payment_date": "upload_payment_date",
    "staff_id": "staff_id",
    "approver_id": "approver_id",
    "void_remark": "void_remark",

    // T21
    "sign": "sign",
    "custom_invoice_number": "custom_invoice_number",
};

const PACKAGE_MODEL = { // package_data
    "name": "package_name",
    "lesson_count": "count",
    "price": "price",
    "schools": "center"
};

const MONTH_PASS_MODEL = { // monthly_data
    "name": "name",
    "price": "price",
    "type": "type", // 'months' | 'days'
    "days": "days",
    "schools": "center"
}

const COUPON_MODEL = {
    "code": "code",
    "name": "name",
    "discount_type": "type",
    "discount_value": "value",
    "students": "users",
    "limit_type": "limit_type", // per_user | total
    "usage_limit": "usage_limit",
};

const convertCMSKeyToBackendKey = (payload, model) => {
    if (payload && Object.keys(payload).length > 0) {
        let obj = {};

        for (const key in payload) {
            if (model[key] !== undefined && model[key] !== null && model[key] !== '') {
                obj[model[key]] = payload[key];
            } else {
                obj[key] = payload[key];
            }
        }

        return obj;
    }

    return {};
}

// backend: cms
const CMS_STUDENT_STATUS = {
    "active": "active",
    "quit": "inactive"
}

const CMS_ORDER_STATUS = {
    "pending": "pending",
    "paid": "paid",
    "expired": "expired",
    "cancelled": "cancelled",
    "null": "null",
    "processing": "processing",
    "debit": "debit", // refund
    "void": "void",
}

const CMS_ATTENDANCE_STATUS = {
    "pending": "pending",
    "attend": "attend",
    "absent": "absent",
    "reschedule": "reschedule",
    "drop": "drop",
    "swap": "swap",
    "skip": "skip",
    "await": "await",
    "sick_leave": "sick_leave",
    "reschedule cancel": "reschedule_cancel"
}

export default {
    install(Vue, option) {
        const DataValid = Validate.DataValid;
        const mapIds = (list = [], key = '') => {
            const ids = [];

            list.forEach(item => {
                if (key) {
                    if (item[key] !== undefined && item[key] !== null && item[key] !== '' && item[key] > -1 && !ids.includes(item[key])) {
                        ids.push(item[key]);
                    }
                } else {
                    if (!ids.includes(item)) {
                        ids.push(item);
                    }
                }

            });

            return ids;
        }
        const isAppMode = (modes = []) => {
            return Validate.isAppMode(option.config.VUE_APP_RUN_MODE, modes);
        }
        const displayError = (res) => {
            if (DataValid(res) && DataValid(res.data)) {
                if (typeof res.data === 'string') {
                    return res.data;
                }
                return JSON.stringify(res.data);
            }

            if (DataValid(res) && typeof res === 'string') {
                return res;
            }
            return JSON.stringify(res);
        }

        const handleParseError = (error) => {
            try {
                const parseError = JSON.parse(error);
                if (parseError !== undefined && parseError !== null && Array.isArray(parseError)) {
                    return Promise.resolve(parseError);
                } else {
                    return Promise.resolve(error);
                }
            } catch (err) {
                console.error(err);
                return Promise.resolve(error);
            }
        }

        const _getDisplayStudentName = (data, convert = true) => {
            if (!data) return ''
            if (!convert) {
                return isAppMode(['T47', 'T49']) ? (data.student_eng_name || data.student_name || '') : (data.student_name || '')
            }
            return isAppMode(['T47', 'T49']) ? (data[STUDENT_MODEL.student_eng_name] || data[STUDENT_MODEL.student_name] || '') : (data[STUDENT_MODEL.student_name] || '')
        }
        // -------------- Parse function --------------
        const parseStaffData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    create_date: data.create_date,
                    name: data[STAFF_MODEL.name],
                    user_type: data[STAFF_MODEL.user_type],
                    schools: (data[STAFF_MODEL.schools] || []).sort((a, b) => b - a),
                    gender: data[STAFF_MODEL.gender],
                    username: data[STAFF_MODEL.username],
                    phone: data[STAFF_MODEL.phone],
                    remark: data[STAFF_MODEL.remark],
                    login_block: data[STAFF_MODEL.login_block] || false,
                    salary_level: data[STAFF_MODEL.salary_level],
                    salary_per_hour: data[STAFF_MODEL.salary_per_hour] || 0,

                    // ---- Only T59 ----
                    birthday: data[STAFF_MODEL.birthday] || '',
                    marital_status: data[STAFF_MODEL.marital_status] || '',
                    paying_bank: data[STAFF_MODEL.paying_bank] || '',
                    bank_account: data[STAFF_MODEL.bank_account] || '',
                    employment_date: data[STAFF_MODEL.employment_date] || '',
                    position: data[STAFF_MODEL.position] || '',

                    // ---- Only T45 & T59 ----
                    hkid: data[STAFF_MODEL.hkid] || '',
                    address: data[STAFF_MODEL.address] || '',
                    quit: data.quit || false,
                };
            }

            return null;
        }

        const parseTutorCalendarData = (data, tutorData = []) => {
            if (data) {
                const foundTutor = tutorData.find(el => el.id === data[TUTOR_CALENDAR_MODEL.tutor_id]);
                return {
                    id: data.id,
                    active: data.active,
                    tutor_id: data[TUTOR_CALENDAR_MODEL.tutor_id],
                    date: data[TUTOR_CALENDAR_MODEL.date],
                    start_time: data[TUTOR_CALENDAR_MODEL.start_time],
                    end_time: data[TUTOR_CALENDAR_MODEL.end_time],

                    // extra
                    tutor_name: foundTutor ? foundTutor.name : '',
                };
            }

            return null;
        }

        const parseSchoolData = (data) => {
            if (data) {
                let basic_use_share = false;
                if (data[SCHOOL_MODEL.phone] === undefined
                    && data[SCHOOL_MODEL.email] === undefined
                    && data[SCHOOL_MODEL.custom_text] === undefined
                    && data[SCHOOL_MODEL.whatsapp_message] === undefined) {
                    basic_use_share = true;
                }

                let payment_use_share = false;
                if (data[SCHOOL_MODEL.payment_method] === undefined) {
                    payment_use_share = true;
                }

                const payment_info = {
                    payme: { number: '', code: { file: '', name: '' }, link: '' },
                    fps: { number: '', code: { file: '', name: '' }, phone_email: '' },
                    wechat_pay: { number: '', code: { file: '', name: '' } },
                    alipay: { number: '', code: { file: '', name: '' } },
                    bank_transfer: []
                }
                const accept_payment_methods = [];
                if (data[SCHOOL_MODEL.payment_method]) {
                    for (let i = 0; i < data[SCHOOL_MODEL.payment_method].length; i++) {
                        const item = data[SCHOOL_MODEL.payment_method][i];
                        if (item.active) {
                            accept_payment_methods.push(item.type);
                        }

                        if (payment_info[item.type]) {
                            if (item.type === 'bank_transfer') {
                                payment_info[item.type] = item.info_list || [];
                            } else {
                                payment_info[item.type] = JSON.parse(JSON.stringify(item));
                            }
                        }
                    }
                }

                return {
                    id: data.id,
                    active: data.active,
                    name: data[SCHOOL_MODEL.name],
                    address: data[SCHOOL_MODEL.address],
                    school_code: data[SCHOOL_MODEL.school_code],
                    // Center 基本設定
                    basic_use_share: basic_use_share,
                    logo: data[SCHOOL_MODEL.logo] || '',
                    custom_text: data[SCHOOL_MODEL.custom_text] || '',
                    phone: data[SCHOOL_MODEL.phone] || '',
                    email: data[SCHOOL_MODEL.email] || '',
                    whatsapp_message: data[SCHOOL_MODEL.whatsapp_message] || '',
                    member_terms_field: data[SCHOOL_MODEL.member_terms_field] || '',
                    website_and_app: data[SCHOOL_MODEL.website_and_app] || false,
                    whatsapp_number: data[SCHOOL_MODEL.whatsapp_number] || '',
                    month_period: data[SCHOOL_MODEL.month_period] || 1,
                    admin_notification_email: data[SCHOOL_MODEL.admin_notification_email] || [],
                    payment_terms: data[SCHOOL_MODEL.payment_terms] || '',
                    // Center 付款設定
                    payment_use_share: payment_use_share,
                    payment_method: data[SCHOOL_MODEL.payment_method] || [],
                    accept_payment_methods: accept_payment_methods,
                    payment_info_alipay: payment_info.alipay,
                    payment_info_bank_transfer: payment_info.bank_transfer,
                    payment_info_fps: payment_info.fps,
                    payment_info_payme: payment_info.payme,
                    payment_info_wechat_pay: payment_info.wechat_pay,
                };
            }

            return null;
        }

        const parsePayTuitionData = (data, siblingData = [], schoolData = []) => {
            if (data && DataValid(data.id)) {
                let status = [];
                let status_next = [];

                if (data.curr_unpaid !== undefined) {
                    // 本月訂單狀態
                    if (data.curr_unpaid.length > 0 || data.pass_unpaid.length > 0) {
                        status.push('pending');
                    }
                    if (data.curr_unpaid_lesson.length > 0) {
                        status.push('not_issued');
                    }
                    if (DataValid(data.all_orders, true)) {
                        const pendingOrders = data.all_orders.filter(el => el.status === 'pending' || el.status === 'processing');
                        if (pendingOrders.length) {
                            if (status.includes('pending')) {
                                const lessonOrders = pendingOrders.filter(el => DataValid(el.lessons_ids, true));
                                if (lessonOrders.length) {
                                    lessonOrders.sort((a, b) => Formatter.sortDate(a.create_date, b.create_date));

                                    const today = Formatter.convertDate();
                                    const createDate = Formatter.convertDate(lessonOrders[0].create_date.substring(0, 10));
                                    const diffDays = Math.floor((today.getTime() - createDate.getTime()) / (1000 * 3600 * 24));

                                    if (diffDays > 30) {
                                        status = status.filter(el => el !== 'pending');
                                        status.push('expired');
                                    }
                                }
                            } else {
                                const foundPending = pendingOrders.find(el => el.status === 'pending');
                                if (foundPending) {
                                    status.push('pending');
                                } else {
                                    status.push('processing');
                                }
                            }
                        }
                    }
                    if (status.length < 1 && data.curr_paid.length > 0) {
                        status.push('paid');
                    }

                    // 下月訂單狀態
                    if (data.next_unpaid.length > 0) {
                        status_next.push('pending');
                    }
                    if (data.next_unpaid_lesson.length > 0) {
                        status_next.push('not_issued');
                    }
                    if (status_next.length < 1 && data.next_paid.length > 0) {
                        status_next.push('paid');
                    }

                } else if (DataValid(data.order_datas, true)) {
                    const orders = [];
                    const today = Formatter.convertDate();
                    const nextMonth = Formatter.convertDate();
                    nextMonth.setMonth(nextMonth.getMonth() + 1);

                    const ignoreStatus = {
                        cancelled: true,
                        debit: true,
                        void: true,
                    };

                    // --- Filter走重覆嘅order & void order
                    data.order_datas.sort((a, b) => Formatter.sortDate(b.create_date, a.create_date));

                    for (let i = 0; i < data.order_datas.length; i++) {
                        if (data.order_datas[i].status !== 'void') {
                            const found = orders.find(el => el.id === data.order_datas[i].id);
                            if (!found && data.order_datas[i].lesson_datas) {
                                orders.push(data.order_datas[i]);
                            }
                        }
                    }

                    orders.sort((a, b) => Formatter.sortDate(a.create_date, b.create_date));
                    for (let i = 0; i < orders.length; i++) {
                        if (orders[i].lesson_datas && orders[i].lesson_datas.length) {
                            const datas = [];
                            orders[i].lesson_datas.forEach(elm => {
                                if (elm) {
                                    datas.push(elm);
                                }
                            })
                            orders[i].lesson_datas = datas;
                            orders[i].lesson_datas.sort((a, b) => Formatter.sortDate(a.date, b.date));
                        }
                    }

                    // 本月訂單狀態 (本月或之前未比錢/待審核嘅order)
                    for (let i = 0; i < orders.length; i++) {
                        if (!ignoreStatus[orders[i].status] && !status.includes('expired') && orders[i].lesson_datas && orders[i].lesson_datas.length) {
                            for (let j = 0; j < orders[i].lesson_datas.length; j++) {
                                if (!status.includes('expired')) {
                                    const date = Formatter.convertDate(orders[i].lesson_datas[j].date);
                                    if (date.getFullYear() < today.getFullYear() || date.getFullYear() === today.getFullYear() && date.getMonth() <= today.getMonth()) {
                                        let tempStatus = orders[i].status;
                                        if (tempStatus === 'pending' || tempStatus === 'processing') {
                                            const today = Formatter.convertDate();
                                            const createDate = Formatter.convertDate(orders[i].create_date.substring(0, 10));
                                            const diffDays = Math.floor((today.getTime() - createDate.getTime()) / (1000 * 3600 * 24));

                                            if (diffDays > 30) {
                                                tempStatus = 'expired';
                                                break;
                                            }
                                        }

                                        if (tempStatus && !status.includes(tempStatus)) {
                                            if (tempStatus === 'expired'
                                                || tempStatus === 'pending'
                                                || (tempStatus === 'processing' && !status.includes('pending'))
                                                || (!status.includes('pending') && !status.includes('processing'))) {
                                                status = [tempStatus];
                                            }
                                        }
                                    }
                                }

                                if (status.includes('expired')) break;
                            }
                        }

                        if (status.includes('expired')) break;
                    }

                    // 下月訂單狀態 (下月未比錢/待審核嘅order)
                    for (let i = 0; i < orders.length; i++) {
                        if (!ignoreStatus[orders[i].status] && !status_next.includes('pending') && orders[i].lesson_datas && orders[i].lesson_datas.length) {
                            for (let j = 0; j < orders[i].lesson_datas.length; j++) {
                                if (!status_next.includes('pending')) {
                                    const date = Formatter.convertDate(orders[i].lesson_datas[j].date);
                                    if (date.getFullYear() === nextMonth.getFullYear() && date.getMonth() === nextMonth.getMonth()) {
                                        let tempStatus = orders[i].status;
                                        if (tempStatus && !status.includes(tempStatus)) {
                                            if (tempStatus === 'pending' || tempStatus === 'processing' || !status_next.includes('processing')) {
                                                status_next = [tempStatus];
                                            }
                                        }
                                    }
                                }

                                if (status_next.includes('pending')) break;
                            }
                        }

                        if (status_next.includes('pending')) break;
                    }
                }

                for (let i = 0; i < status.length; i++) {
                    status[i] = CMS_ORDER_STATUS[status[i]] || status[i];
                }
                for (let i = 0; i < status_next.length; i++) {
                    status_next[i] = CMS_ORDER_STATUS[status_next[i]] || status_next[i];
                }

                status.sort((a, b) => {
                    if (a < b) return -1
                    if (a > b) return 1
                    return 0
                })
                status_next.sort((a, b) => {
                    if (a < b) return -1
                    if (a > b) return 1
                    return 0
                })

                // user center ids
                let schoolIds = [];
                if (DataValid(data[STUDENT_MODEL.schools], true)) {
                    schoolIds = data[STUDENT_MODEL.schools];
                } else if (DataValid(data[STUDENT_MODEL.school_id]) && data[STUDENT_MODEL.school_id] > -1) {
                    schoolIds.push(data[STUDENT_MODEL.school_id]);
                }
                if (schoolIds.length < 1) {
                    schoolIds = [-1];
                }
                let schoolNames = [];
                if (schoolIds.includes(-1)) {
                    schoolNames = ['allCenters'];
                } else {
                    let schoolCount = 0;
                    for (let i = 0; i < schoolData.length; i++) {
                        if (schoolIds.includes(schoolData[i].id)) {
                            schoolCount++;
                            schoolNames.push(schoolData[i].name);
                        }
                    }

                    if (schoolCount === schoolData.length) {
                        schoolNames = ['allCenters'];
                    }
                }

                return {
                    active: data.active,
                    student_id: data.id,
                    school_id: data[STUDENT_MODEL.school_id],
                    schools: schoolIds,
                    student_name: _getDisplayStudentName(data),
                    gender: data[STUDENT_MODEL.gender] || '',
                    phone: data[STUDENT_MODEL.phone] || '',
                    grade: data[STUDENT_MODEL.grade] || '',
                    student_school_name: data[STUDENT_MODEL.student_school_name] || '',
                    reg_date: data.create_date ? data.create_date.substring(0, 10) : '',
                    student_code: data[STUDENT_MODEL.student_code],
                    remark: data[STUDENT_MODEL.remark],
                    siblings: data[STUDENT_MODEL.siblings] ? data[STUDENT_MODEL.siblings].map(el => _parseStudentSiblingData(el, siblingData)) : [],
                    birthday: data[STUDENT_MODEL.birthday] || '', // YYYY-MM-DD
                    avatar: data[STUDENT_MODEL.avatar] || '',

                    // ---- Only T01 ----
                    belt: data.belt && data.belt.active ? data.belt.score : '',

                    student_field_2: data.student_field_2 || '',

                    // extra
                    center_name: schoolNames.join(', '),
                    order_status: status,
                    next_order_status: status_next,
                };
            }

            return null;
        }

        const parseStudentData = (data, siblingData = [], schoolData = []) => {
            if (data && DataValid(data.id)) {
                let know_from = '';
                let know_from_other = '';
                if (DataValid(data[STUDENT_MODEL.know_from], true)) {
                    know_from = data[STUDENT_MODEL.know_from][0];
                    let options = [];
                    if (isAppMode(['T20'])) {
                        if (T20KnowFromList !== undefined) {
                            options = T20KnowFromList;
                        }
                    } else if (isAppMode(['T21'])) {
                        if (T21KnowFromList !== undefined) {
                            options = T21KnowFromList;
                        }
                    }

                    if (!options.includes(know_from) || know_from === 'other') {
                        know_from_other = know_from;
                        know_from = 'other';
                    }
                }

                let student_zh_name = '';
                if (data[STUDENT_MODEL.student_zh_name]) {
                    student_zh_name = data[STUDENT_MODEL.student_zh_name];
                } else if (data.student_zh_name) {
                    student_zh_name = data.student_zh_name;
                }

                let schoolIds = [];
                if (DataValid(data[STUDENT_MODEL.schools], true)) {
                    schoolIds = data[STUDENT_MODEL.schools];
                } else if (DataValid(data[STUDENT_MODEL.school_id]) && data[STUDENT_MODEL.school_id] > -1) {
                    schoolIds.push(data[STUDENT_MODEL.school_id]);
                }
                if (schoolIds.length < 1) {
                    schoolIds = [-1];
                }
                let schoolNames = [];
                if (schoolIds.includes(-1)) {
                    schoolNames = ['allCenters'];
                } else {
                    let schoolCount = 0;
                    for (let i = 0; i < schoolData.length; i++) {
                        if (schoolIds.includes(schoolData[i].id)) {
                            schoolCount++;
                            schoolNames.push(schoolData[i].name);
                        }
                    }

                    if (schoolCount === schoolData.length) {
                        schoolNames = ['allCenters'];
                    }
                }

                const teamMemberIds = [];
                if (DataValid(data[STUDENT_MODEL.team_member], true)) {
                    for (let i = 0; i < data[STUDENT_MODEL.team_member].length; i++) {
                        if (!teamMemberIds.includes(data[STUDENT_MODEL.team_member][i])) {
                            teamMemberIds.push(data[STUDENT_MODEL.team_member][i]);
                        }
                    }
                }
                const teamMemberDatas = teamMemberIds.map(sid => {
                    const obj = {
                        id: sid,
                        student_code: '',
                        student_name: '',
                        active: false,
                    };
                    const found = siblingData.find(el => el.id === sid);
                    if (found) {
                        obj['student_code'] = found.student_code;
                        obj['student_name'] = _getDisplayStudentName(found, false);
                        obj['active'] = found.active;
                    }
                    return obj;
                })

                // 學生WhatsApp電話
                const contactPhones = [];
                if (DataValid(data[STUDENT_MODEL.phone])) {
                    contactPhones.push({
                        name: _getDisplayStudentName(data),
                        phone: data[STUDENT_MODEL.phone]
                    })
                }
                if (DataValid(data[STUDENT_MODEL.contact_person_1_phone])) {
                    contactPhones.push({
                        name: data[STUDENT_MODEL.contact_person_1_name],
                        phone: data[STUDENT_MODEL.contact_person_1_phone]
                    })
                }
                if (DataValid(data[STUDENT_MODEL.contact_person_2_phone])) {
                    contactPhones.push({
                        name: data[STUDENT_MODEL.contact_person_2_name],
                        phone: data[STUDENT_MODEL.contact_person_2_phone]
                    })
                }
                if (DataValid(data[STUDENT_MODEL.contact_person_3_phone])) {
                    contactPhones.push({
                        name: data[STUDENT_MODEL.contact_person_3_name],
                        phone: data[STUDENT_MODEL.contact_person_3_phone]
                    })
                }

                let returnData = {
                    id: data.id,
                    active: data.active,
                    status: CMS_STUDENT_STATUS[data.status] || 'active', // active | quit
                    school_id: data[STUDENT_MODEL.school_id],
                    schools: schoolIds,
                    display_student_name: _getDisplayStudentName(data),
                    student_name: data[STUDENT_MODEL.student_name] || '', // required
                    student_eng_name: data[STUDENT_MODEL.student_eng_name] || '',
                    address: data[STUDENT_MODEL.address] || '',
                    gender: data[STUDENT_MODEL.gender] || '',
                    phone: data[STUDENT_MODEL.phone] || '', // required
                    birthday: data[STUDENT_MODEL.birthday] || '', // YYYY-MM-DD
                    username: data[STUDENT_MODEL.username] || '',
                    contact_person_1_name: data[STUDENT_MODEL.contact_person_1_name],
                    contact_person_1_phone: data[STUDENT_MODEL.contact_person_1_phone],
                    contact_person_2_name: data[STUDENT_MODEL.contact_person_2_name],
                    contact_person_2_phone: data[STUDENT_MODEL.contact_person_2_phone],
                    student_school_name: data[STUDENT_MODEL.student_school_name] || '',
                    member_level: data[STUDENT_MODEL.member_level] || '',
                    grade: data[STUDENT_MODEL.grade] || '',
                    remark: data[STUDENT_MODEL.remark] || '',
                    student_field_2: data.student_field_2 || '',
                    student_code: data[STUDENT_MODEL.student_code] || '',
                    apply_date: data[STUDENT_MODEL.apply_date] || '',
                    trial_date: data[STUDENT_MODEL.trial_date] || '',
                    special: data[STUDENT_MODEL.special] || '',
                    admission_source: data[STUDENT_MODEL.admission_source] || '',
                    siblings: data[STUDENT_MODEL.siblings] ? data[STUDENT_MODEL.siblings].map(el => _parseStudentSiblingData(el, siblingData)) : [],
                    email: data[STUDENT_MODEL.email] || '',
                    login_block: data[STUDENT_MODEL.login_block] || false,
                    avatar: data[STUDENT_MODEL.avatar] || '',

                    // extra
                    center_name: schoolNames.join(', '),
                    reg_date: data.create_date ? data.create_date.substring(0, 10) : '',
                    last_lesson_id: data.lesson ? data.lesson.id : -1,
                    whatsapp_data: contactPhones,

                    // ---- Only T01 ----
                    belt: data.belt && data.belt.active ? data.belt.score : '',

                    // ---- Only T03 & T21 ----
                    sign: data[STUDENT_MODEL.sign] || '',

                    // ---- Only T03 ----
                    school_time: data[STUDENT_MODEL.school_time] || '',
                    contact_person_1_email: data[STUDENT_MODEL.contact_person_1_email] || '',
                    contact_person_2_email: data[STUDENT_MODEL.contact_person_2_email] || '',
                    contact_person_3_name: data[STUDENT_MODEL.contact_person_3_name] || '',
                    contact_person_3_phone: data[STUDENT_MODEL.contact_person_3_phone] || '',
                    contact_person_3_email: data[STUDENT_MODEL.contact_person_3_email] || '',
                    special_remind: data[STUDENT_MODEL.special_remind] || false,
                    special_remind_des: data[STUDENT_MODEL.special_remind_des] || '',
                    agree_video: data[STUDENT_MODEL.agree_video] || false,

                    // ---- Only T11 ----
                    enroll_reason: data[STUDENT_MODEL.enroll_reason] || '',
                    enroll_reason_other: data[STUDENT_MODEL.enroll_reason_other] || '',
                    school_type: data[STUDENT_MODEL.school_type] || '',
                    nation: data[STUDENT_MODEL.nation] || '',
                    is_membership: data[STUDENT_MODEL.is_membership] || false,
                    have_football_shirt: data[STUDENT_MODEL.have_football_shirt] || false,
                    have_participate_competition: data[STUDENT_MODEL.have_participate_competition] || false,

                    // ---- Only T17 ----
                    credit_remark: data[STUDENT_MODEL.credit_remark] || '',

                    // ---- Only T20 & T21 ----
                    know_from: know_from,
                    know_from_other: know_from_other,

                    // ---- Only T20 & T30 & T35 ----
                    student_zh_name: student_zh_name,

                    // ---- Only T20 ----
                    ever_enrolled: data[STUDENT_MODEL.ever_enrolled] || false,
                    location: data[STUDENT_MODEL.location] || '',

                    // ---- Only T21 ----
                    textbook: data[STUDENT_MODEL.textbook] || '',
                    wish_lesson: data[STUDENT_MODEL.wish_lesson] || -1,
                    agree_promo: data[STUDENT_MODEL.agree_promo] || false,
                    student_news: data[STUDENT_MODEL.student_news] || [],

                    // ---- Only T27 ----
                    belong: data[STUDENT_MODEL.belong] || '',
                    job_class: data[STUDENT_MODEL.job_class] || '',
                    join_newbie_passion: data[STUDENT_MODEL.join_newbie_passion] || false,
                    team_member: teamMemberIds,
                    upline_student_code: data[STUDENT_MODEL.upline_student_code] || '',
                    id_card_full_name: data[STUDENT_MODEL.id_card_full_name] || '',
                    // extra
                    team_member_datas: teamMemberDatas,

                    // ---- Only T30 ----
                    class_format: data[STUDENT_MODEL.class_format] || '',

                    // ---- Only T32 & T40 ----
                    hkid: data[STUDENT_MODEL.hkid] || '',

                    // ---- Only T40 ----
                    parent_name: data[STUDENT_MODEL.parent_name] || '',
                    child_1: data[STUDENT_MODEL.child_1] || '',
                    child_1_birth: data[STUDENT_MODEL.child_1_birth] || '',
                    child_2: data[STUDENT_MODEL.child_2] || '',
                    child_2_birth: data[STUDENT_MODEL.child_2_birth] || '',
                    child_3: data[STUDENT_MODEL.child_3] || '',
                    child_3_birth: data[STUDENT_MODEL.child_3_birth] || '',
                    dap: data[STUDENT_MODEL.dap] || '',
                    dob: data[STUDENT_MODEL.dob] || '',
                    join_group: data[STUDENT_MODEL.join_group] || '',
                    join_course: data[STUDENT_MODEL.join_course] || false,
                    send_leave_notify: data[STUDENT_MODEL.send_leave_notify] || '',
                    enrollment_date: data[STUDENT_MODEL.enrollment_date] || '',

                    //---- Only T46 ----
                    nickname: data[STUDENT_MODEL.nickname] || '',
                    contact_person_1_relationship: data[STUDENT_MODEL.contact_person_1_relationship] || '',
                    contact_person_2_relationship: data[STUDENT_MODEL.contact_person_2_relationship] || '',

                    //---- Only T40 & T49 ----
                    referee_name: data[STUDENT_MODEL.referee_name] || '',
                    //---- Only T49 ----
                    referee_phone: data[STUDENT_MODEL.referee_phone] || '',

                    //---- Only T51 ----
                    preferred_school: data[STUDENT_MODEL.preferred_school] || '',
                    email_2: data[STUDENT_MODEL.email_2] || '',
                    award: data[STUDENT_MODEL.award] || '',

                    //---- Only T57 ----
                    belong_family_member: data[STUDENT_MODEL.belong_family_member] || '',

                    //---- Only T59 ----
                    weapon_hand: data[STUDENT_MODEL.weapon_hand] || '',
                    join_date: data[STUDENT_MODEL.join_date] || '',

                    // ---- T75 ----
                    student_field_2: data.student_field_2 || '',
                };

                const keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i].startsWith('student_field_')) {
                        returnData[keys[i]] = data[keys[i]];
                    }
                }

                return returnData;
            }

            return null;
        }
        const _parseStudentSiblingData = (data, siblingData = []) => {
            if (data) {
                const found = siblingData ? siblingData.find(el => el.id === data.student_id) : null;
                return {
                    active: found ? found.active : false,
                    student_id: data.student_id,
                    relationship: data.relationship,
                    name: found ? _getDisplayStudentName(found, false) : '',
                    phone: found ? found.phone : '',
                    schools: found ? found.schools : [],
                }
            }
            return null;
        }

        const parseStudentScoreData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    active: data.active,
                    student_id: data[STUDENT_SCORE_MODEL.student_id],
                    exam_name: data[STUDENT_SCORE_MODEL.exam_name],
                    grade: data[STUDENT_SCORE_MODEL.grade],
                    semester: data[STUDENT_SCORE_MODEL.semester],
                    subject: data[STUDENT_SCORE_MODEL.subject],
                    score: data[STUDENT_SCORE_MODEL.score],
                    update_date: data[STUDENT_SCORE_MODEL.update_date] ? data[STUDENT_SCORE_MODEL.update_date] : data.create_date.substring(0, 10),
                    show_public: data[STUDENT_SCORE_MODEL.show_public] === false ? false : true,
                    file: data[STUDENT_SCORE_MODEL.file] || '',
                };
            }

            return null;
        }

        const parseStudentAttendanceData = (data, student_id) => {
            if (data) {
                let attendStatus = 'pending';
                let targetAttendance = null;
                for (let i = data[LESSON_MODEL.attendance_list].length - 1; i >= 0; i--) {
                    if (data[LESSON_MODEL.attendance_list][i].student_id === student_id) {
                        targetAttendance = data[LESSON_MODEL.attendance_list][i];
                        break;
                    }
                }

                if (!targetAttendance) {
                    attendStatus = 'drop';
                } else {
                    if (!data.students.includes(student_id) && targetAttendance.status !== 'reschedule' && targetAttendance.status !== 'skip' && targetAttendance.status !== 'swap') {
                        attendStatus = 'drop';
                    } else {
                        attendStatus = CMS_ATTENDANCE_STATUS[targetAttendance.status] || 'pending';
                    }
                }
                let staff_list = data.staff_list??[];
                staff_list.push(data.staff_id)

                return {
                    lesson_id: data.id,
                    student_id: student_id,
                    date: data[LESSON_MODEL.date],
                    course_code: data[CLASS_MODEL.course_code],
                    course_name: data[CLASS_MODEL.course_name],
                    attend_status: attendStatus,
                    start_time: data[LESSON_MODEL.start_time],
                    end_time: data[LESSON_MODEL.end_time],
                    related_order: data.order_data || null,
                    staff_list: staff_list,
                };
            }

            return null;
        }

        const parseClassroomData = (data, schoolData = []) => {
            if (data) {
                let targetSchoolData = null;
                if (schoolData.length > 0) {
                    targetSchoolData = schoolData.find(el => el.id === data[CLASSROOM_MODEL.school_id]);
                }
                return {
                    id: data.id,
                    active: data.active,
                    name: data[CLASSROOM_MODEL.name],
                    school_id: data[CLASSROOM_MODEL.school_id],
                    school_data: targetSchoolData
                };
            }

            return null;
        }

        const parseCourseCategoryData = (data, schoolData = []) => {
            if (data) {
                let schoolNames = [];
                if (data[COURSE_CATEGORY_MODEL.schools].includes(-1)) {
                    schoolNames = ['allCenters'];
                } else {
                    let schoolCount = 0;
                    for (let i = 0; i < schoolData.length; i++) {
                        if (data[COURSE_CATEGORY_MODEL.schools].includes(schoolData[i].id)) {
                            schoolCount++;
                            schoolNames.push(schoolData[i].name);
                        }
                    }

                    if (schoolCount === schoolData.length) {
                        schoolNames = ['allCenters'];
                    }
                }

                return {
                    id: data.id,
                    active: data.active,
                    name: data[COURSE_CATEGORY_MODEL.name],
                    category_code: data[COURSE_CATEGORY_MODEL.category_code] || '',
                    schools: data[COURSE_CATEGORY_MODEL.schools],
                    color: data[COURSE_CATEGORY_MODEL.color] || '',
                    // extra
                    center_name: schoolNames.join(', '),
                };
            }

            return null;
        }

        const parseCourseData = (data, schoolData = [], categoryData = []) => {
            if (data) {
                let targetCate = null;
                if (categoryData.length > 0) {
                    targetCate = categoryData.find(el => el.id === data[COURSE_MODEL.category_id]);
                }

                let schoolNames = [];
                if (data[COURSE_MODEL.schools].includes(-1)) {
                    schoolNames = ['allCenters'];
                } else {
                    let schoolCount = 0;
                    for (let i = 0; i < schoolData.length; i++) {
                        if (data[COURSE_MODEL.schools].includes(schoolData[i].id)) {
                            schoolCount++;
                            schoolNames.push(schoolData[i].name);
                        }
                    }

                    if (schoolCount === schoolData.length) {
                        schoolNames = ['allCenters'];
                    }
                }

                return {
                    id: data.id,
                    active: data.active,
                    grade: data[COURSE_MODEL.grade],
                    name: data[COURSE_MODEL.name] || '',
                    category_id: data[COURSE_MODEL.category_id],
                    schools: data[COURSE_MODEL.schools],

                    // extra
                    category_data: targetCate,
                    center_name: schoolNames.join(', '),
                }
            }

            return null;
        }

        const parseLessonData = (data, tutorData = [], studentData = [], attendanceLessonData = []) => {
            if (data) {
                const activeStudents = DataValid(data.students, true) ? data.students.filter(id => DataValid(id)) : [];
                let attendanceList = [];
                if (DataValid(data[LESSON_MODEL.attendance_list], true)) {
                    const uniqueAttendanceList = [];
                    for (let i = data[LESSON_MODEL.attendance_list].length - 1; i >= 0; i--) {
                        const found = uniqueAttendanceList.find(el => el.student_id === data[LESSON_MODEL.attendance_list][i].student_id);
                        if (!found) {
                            uniqueAttendanceList.push(data[LESSON_MODEL.attendance_list][i]);
                        }
                    }

                    attendanceList = uniqueAttendanceList.map(el => {
                        const targetStudent = studentData.find(student => student.id === el.student_id);

                        let attend_status = CMS_ATTENDANCE_STATUS[el.status] || 'pending';
                        if (!activeStudents.includes(el.student_id) && attend_status !== 'reschedule' && attend_status !== 'skip' && attend_status !== 'swap' && attend_status !== 'reschedule_cancel') {
                            attend_status = 'drop';
                        }

                        const isMonthlyAssign = (data[LESSON_MODEL.monthly_used_student_id_list] || []).includes(el.student_id);

                        // 學生未繳付學費
                        let unpaid = false;
                        if ((!data[LESSON_MODEL.paid_student_ids] || !data[LESSON_MODEL.paid_student_ids].includes(el.student_id))
                            && activeStudents.includes(el.student_id)
                            && (attend_status === 'pending' || attend_status === 'attend' || attend_status === 'absent' || attend_status === 'await' || attend_status === 'sick_leave')
                        ) {
                            unpaid = true;
                        }

                        // 此課堂是學生的最後一堂（只適用於購買套票的學生）
                        let last_lesson_id = targetStudent ? targetStudent.last_lesson_id : -1;
                        if (!data[LESSON_MODEL.package_used_student_id_list] || !data[LESSON_MODEL.package_used_student_id_list].includes(el.student_id)) {
                            last_lesson_id = -1;
                        }

                        // 轉堂記錄
                        let switch_from = null;
                        let targetFromLesson = null;
                        let from_lesson = null;
                        let from_course = null;
                        if (DataValid(el.from_lesson) && el.from_lesson > -1) {
                            targetFromLesson = attendanceLessonData.find(lesson => lesson.id === el.from_lesson);
                            from_lesson = el.from_lesson
                        }

                        if (DataValid(el.from_course) && el.from_course !== -1) {
                            const targetFromCourse = attendanceLessonData.find(lesson => lesson.course_code === el.from_course);
                            if (targetFromCourse) {
                                switch_from = `${targetFromCourse.course_name} (${el.from_course})`;
                            } else {
                                switch_from = el.from_course;
                            }
                            from_course = el.from_course
                        } else if (targetFromLesson) {
                            switch_from = `${targetFromLesson.course_name} (${targetFromLesson.date})`;
                            from_lesson = `${targetFromLesson.course_name} (${targetFromLesson.date})`;
                        } else if (DataValid(el.switch_from)) {
                            switch_from = el.switch_from;
                        }

                        // 回復轉堂動作
                        let allowUndo = false;
                        if (targetFromLesson) {
                            for (let i = targetFromLesson.raw_attendance_list.length - 1; i >= 0; i--) {
                                if (targetFromLesson.raw_attendance_list[i].student_id === el.student_id) {
                                    if (targetFromLesson.raw_attendance_list[i].status === 'reschedule' && targetFromLesson.raw_attendance_list[i].to_lesson === data.id) {
                                        allowUndo = true;
                                    }
                                    break;
                                }
                            }
                        }

                        // 轉堂
                        /**
                         * 如果用月票assign，不可轉堂
                         */
                        let allowSwitchCourse = false;
                        if (!isMonthlyAssign) { allowSwitchCourse = true; }

                        // 跳堂
                        /**
                         * 如果用月票assign，不可跳堂
                         * 如果未比錢，不可跳堂
                         * 如果attendance status不是"pending"，不可跳堂
                         * 如果lesson不是regular，不可跳堂
                         */
                        let allowSkipLesson = false;
                        if (DataValid(data.regular_id) && data.regular_id > -1 && !unpaid && !isMonthlyAssign && attend_status === 'pending') {
                            allowSkipLesson = true;
                        }

                        // 是否由另一堂skip過黎
                        let isSkippedToLesson = false;
                        if (DataValid(el.from_lesson) && el.from_lesson > -1
                            && (attend_status === 'pending' || attend_status === 'attend' || attend_status === 'absent' || attend_status === 'sick_leave' || attend_status === 'await')) {
                            if (el.from_lesson_status === 'skip') {
                                isSkippedToLesson = true;
                            } else {
                                const foundLesson = attendanceLessonData.find(elm => elm.id === el.from_lesson);
                                if (foundLesson) {
                                    for (let x = foundLesson.raw_attendance_list.length - 1; x >= 0; x--) {
                                        if (foundLesson.raw_attendance_list[x].student_id === el.student_id) {
                                            if (foundLesson.raw_attendance_list[x].status === 'skip') {
                                                isSkippedToLesson = true;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        // 回復跳堂動作
                        /**
                         * If skip to lesson/ skip from lesson
                         * If to_lesson & from_lesson match
                         */
                        let allowUndoSkip = false;
                        let skipUndoData = { curr_id: -1, back_id: -1, student_id: el.student_id, curr_lesson: '', back_lesson: '' };
                        if (isSkippedToLesson || (attend_status === 'skip' && DataValid(el.to_lesson) && el.to_lesson > -1)) {
                            if (isSkippedToLesson) {
                                skipUndoData['curr_id'] = data.id;
                                skipUndoData['back_id'] = el.from_lesson;
                                skipUndoData['curr_lesson'] = `${data[CLASS_MODEL.course_name]} ${data[LESSON_MODEL.date]} ${data[LESSON_MODEL.start_time]}`;
                                const foundLesson = attendanceLessonData.find(elm => elm.id === skipUndoData['back_id']);
                                if (foundLesson) {
                                    skipUndoData['back_lesson'] = `${foundLesson.course_name} ${foundLesson.date} ${foundLesson.start_time}`;
                                    for (let x = foundLesson.raw_attendance_list.length - 1; x >= 0; x--) {
                                        if (foundLesson.raw_attendance_list[x].student_id === el.student_id) {
                                            if (foundLesson.raw_attendance_list[x].to_lesson === data.id) {
                                                allowUndoSkip = true;
                                            }
                                            break;
                                        }
                                    }
                                }
                            } else {
                                skipUndoData['curr_id'] = el.to_lesson;
                                skipUndoData['back_id'] = data.id;
                                const foundLesson = attendanceLessonData.find(elm => elm.id === skipUndoData['curr_id']);
                                if (foundLesson) {
                                    skipUndoData['curr_lesson'] = `${foundLesson.course_name} ${foundLesson.date} ${foundLesson.start_time}`;
                                    for (let x = foundLesson.raw_attendance_list.length - 1; x >= 0; x--) {
                                        if (foundLesson.raw_attendance_list[x].student_id === el.student_id) {
                                            if (foundLesson.raw_attendance_list[x].from_lesson === data.id) {
                                                allowUndoSkip = true;
                                            }
                                            break;
                                        }
                                    }
                                }
                                skipUndoData['back_lesson'] = `${data[CLASS_MODEL.course_name]} ${data[LESSON_MODEL.date]} ${data[LESSON_MODEL.start_time]}`;
                            }
                        }

                        // 如果用套票買，會顯示 [packageSort]/[totalPackageCount]（套票第幾堂/套票堂數）
                        let packageSort = 0;
                        let totalPackageCount = 0;
                        if (DataValid(data.package_sort, true) && DataValid(data[LESSON_MODEL.package_used_student_id_list], true) && data[LESSON_MODEL.package_used_student_id_list].includes(el.student_id)) {
                            const found = data.package_sort.find(item => item.student_id === el.student_id);
                            if (found) {
                                if (DataValid(found.multiple_package_data, true)) {
                                    totalPackageCount = found.multiple_package_data.reduce((value, item) => value + item[PACKAGE_MODEL.lesson_count], 0);
                                } else if (DataValid(found.package_data)) {
                                    totalPackageCount = found.package_data[PACKAGE_MODEL.lesson_count];
                                }

                                if (DataValid(found.lesson_sort, true)) {
                                    const lessonPos = found.lesson_sort.findIndex(item => item.id === data.id);
                                    if (lessonPos > -1) {
                                        packageSort = lessonPos + 1;
                                    }
                                }
                            }
                        }

                        return {
                            student_id: el.student_id,
                            status: attend_status,
                            student_name: targetStudent ? targetStudent.display_student_name : '',
                            student_code: targetStudent ? targetStudent.student_code : '',
                            student_nickname: targetStudent ? targetStudent.nickname : '',
                            gender: targetStudent ? targetStudent.gender : '',
                            grade: targetStudent ? targetStudent.grade : '',
                            schools: targetStudent ? targetStudent.schools : [],
                            birthday: targetStudent ? targetStudent.birthday : '',
                            remark: targetStudent ? targetStudent.remark : '',
                            student_field_2: targetStudent? (targetStudent.student_field_2):"",
                            switch_from: switch_from,
                            targetFromLesson: targetFromLesson,
                            from_lesson: from_lesson,
                            from_course: from_course,
                            last_lesson_id: last_lesson_id,
                            unpaid: unpaid,
                            quit_student: !targetStudent || !targetStudent.active || targetStudent.status === 'inactive' ? true : false,
                            removed_student: !targetStudent || !targetStudent.active ? true : false,
                            attend_datetime: attend_status === 'attend' ? (el.attend_datetime || '') : '',
                            can_undo_switch: allowUndo,
                            can_undo_skip: allowUndoSkip,
                            can_switch_course: allowSwitchCourse,
                            can_skip: allowSkipLesson,
                            trial: (data.trial || []).includes(el.student_id),
                            is_skip_to_lesson: isSkippedToLesson,
                            is_switch_to_lesson: targetFromLesson,
                            whatsapp_data: targetStudent ? targetStudent.whatsapp_data : [],
                            feedback: '',
                            package_quota_count: totalPackageCount ? `${packageSort}/${totalPackageCount}` : '',
                            undo_skip_payload: skipUndoData
                        }
                    })
                }
                attendanceList.sort((a, b) => a.student_id - b.student_id);

                const currentAttendLessonStudents = activeStudents.filter(id => {
                    const found = attendanceList.find(elm => elm.student_id === id);
                    return !found || (found.status !== 'skip' && found.status !== 'drop') //found.status !== 'absent' && 
                })

                // find tutor data
                const tutorDataList = [];
                let tutorIdList = []; // 有啲single轉咗做multiple要handle
                let multiSalaryLevel = [];
                let salaryType = [];
                if (DataValid(data[LESSON_MODEL.salary_type], true)) {
                    salaryType = data[LESSON_MODEL.salary_type];
                }

                if (DataValid(data[LESSON_MODEL.tutor_id]) && data[LESSON_MODEL.tutor_id] > -1) {
                    tutorIdList = [data[LESSON_MODEL.tutor_id]];
                }
                if (DataValid(data[LESSON_MODEL.tutor_id_list], true)) {
                    tutorIdList = data[LESSON_MODEL.tutor_id_list];
                }

                if (DataValid(data[LESSON_MODEL.multi_salary_level], true)) {
                    multiSalaryLevel = data[LESSON_MODEL.multi_salary_level];
                } else {
                    const foundSalaryType = salaryType.find(el => el.staff_id === data[LESSON_MODEL.tutor_id]);
                    if (tutorIdList.includes(data[LESSON_MODEL.tutor_id]) && (data[LESSON_MODEL.salary_method] === 'by_lesson' || (foundSalaryType && foundSalaryType.type === 'level'))) {
                        multiSalaryLevel = [{ staff_id: data[LESSON_MODEL.tutor_id], level: data[CLASS_MODEL.salary_level] }];
                    }
                }

                if (salaryType.length < 1) {
                    if (tutorIdList.includes(data[LESSON_MODEL.tutor_id])) {
                        salaryType = [{ staff_id: data[LESSON_MODEL.tutor_id], type: typeof data[LESSON_MODEL.salary_type] === 'string' ? data[LESSON_MODEL.salary_type] : 'level' }]
                    }
                }

                console.log("parseLessonData")
                console.log(tutorData)
                console.log(tutorIdList)

                if (tutorData.length > 0 && tutorIdList.length > 0) {
                    for (let i = 0; i < tutorIdList.length; i++) {
                        const foundTutor = tutorData.find(el => el.id === tutorIdList[i]);
                        if (foundTutor) {
                            tutorDataList.push(foundTutor);
                        }
                    }
                }

                return {
                    id: data.id,
                    active: data.active,
                    date: data[LESSON_MODEL.date],
                    start_time: data[LESSON_MODEL.start_time],
                    end_time: data[LESSON_MODEL.end_time],
                    tutor_id: data[LESSON_MODEL.tutor_id],
                    tutor_id_list: tutorIdList,
                    tutor_data_list: tutorDataList,
                    tutor_attendance: data[LESSON_MODEL.tutor_attendance] || [],
                    classroom_id: data[LESSON_MODEL.classroom_id],
                    classroom_data: data.facility_data ? data.facility_data : null,
                    attachment_list: data[LESSON_MODEL.attachment_list], // { name: '', file: '' }
                    all_attendance_list: attendanceList, // included all students with any attend status
                    attendance_list: attendanceList.filter(el => activeStudents.includes(el.student_id)), // attendance with student in activeStudents
                    raw_attendance_list: data[LESSON_MODEL.attendance_list] || [],
                    course_id: data[CLASS_MODEL.course_id],
                    course_code: data[CLASS_MODEL.course_code] || '',
                    course_name: data[CLASS_MODEL.course_name],
                    color: data[CLASS_MODEL.color],
                    salary_method: data[CLASS_MODEL.salary_method],
                    salary_level: data[CLASS_MODEL.salary_level],
                    multi_salary_level: multiSalaryLevel,
                    max_student: data[CLASS_MODEL.max_student], // -1: no limit
                    school_id: data[CLASS_MODEL.school_id],
                    price: data[CLASS_MODEL.price],
                    grade: data[CLASS_MODEL.grade] ? data[CLASS_MODEL.grade] : (data.course_data ? data.course_data[COURSE_MODEL.grade] : ''),
                    lesson_type: !data[CLASS_MODEL.lesson_type] && data.regular_id > -1 ? 'regular' : (data[CLASS_MODEL.lesson_type] || ''),
                    thumbnail_image: data[CLASS_MODEL.thumbnail_image] || '',
                    course_description: data[CLASS_MODEL.course_description] || '',
                    dropped_student_ids: data[LESSON_MODEL.dropped_student_ids] || [],
                    paid_student_ids: data[LESSON_MODEL.paid_student_ids] || [],
                    package_used_student_id_list: data[LESSON_MODEL.package_used_student_id_list] || [],
                    monthly_used_student_id_list: data[LESSON_MODEL.monthly_used_student_id_list] || [],
                    regular_id: data.regular_id,
                    show_website: data[LESSON_MODEL.show_website] || false,
                    salary_type: salaryType,
                    salary_per_hour: data[LESSON_MODEL.salary_per_hour] || [],
                    salary_percentage: data[LESSON_MODEL.salary_percentage] || [],
                    school_type: data[LESSON_MODEL.school_type] || '',
                    remark: data[LESSON_MODEL.remark] || '',
                    student_field_2: data.student_field_2 || '',
                    salary_bonus: data[LESSON_MODEL.salary_bonus] || [],
                    t16_salary: data[LESSON_MODEL.t16_salary] || 0,
                    t16_salary_percentage: data[LESSON_MODEL.t16_salary_percentage] || 0,
                    t16_salary_per_hour: data[LESSON_MODEL.t16_salary_per_hour] || 0,
                    t16_salary_type: data[LESSON_MODEL.t16_salary_type] || 'percentage',
                    skip_list: data.skip_list || [],
                    trial: data.trial || [],
                    video_attachment_id: data[LESSON_MODEL.video_attachment_id] || null,
                    video_attachment_name: data[LESSON_MODEL.video_attachment_name] || '',
                    video_attachment_url: data[LESSON_MODEL.video_attachment_url] || '',

                    current_student_num: currentAttendLessonStudents.length, // students with status NOT equals to 'drop' | 'swap' | 'reschedule' | 'absent' | 'skip' | 'sick_leave' | 'await'
                    student_ids: activeStudents, // students with status NOT equals to 'drop' | 'swap' | 'reschedule'
                    course_category_id: data.course_data ? data.course_data[COURSE_MODEL.category_id] : -1,
                }
            }

            return null;
        }

        const parseProductCategoryData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    name: data[PRODUCT_CATEGORY_MODEL.name],
                };
            }

            return null;
        }

        const parseProductData = (data, categoryData = []) => {
            if (data) {
                let targetCate = null;
                if (categoryData.length > 0) {
                    targetCate = categoryData.find(el => el.id === data[PRODUCT_MODEL.category_id]);
                }

                let avgCost = data.cost;
                if (isAppMode(['DEV', 'UAT', 'T59', '64+']) && DataValid(data.stocks_cost, true)) {
                    const sum = data.stocks_cost.reduce((value, item) => {
                        const [cost, amount] = value;
                        return [
                            cost + item.cost * item.amount,
                            amount + item.amount
                        ]
                    }, [0, 0]); // [cost, amount]
                    avgCost = Formatter.formatMoney(sum[0] / sum[1]);
                }

                return {
                    id: data.id,
                    active: data.active,
                    status: data.status, // 'active' | 'inactive'
                    name: data[PRODUCT_MODEL.name],
                    product_code: data[PRODUCT_MODEL.product_code],
                    schools: data[PRODUCT_MODEL.schools],
                    category_id: data[PRODUCT_MODEL.category_id],
                    category_data: targetCate,
                    inventory: data[PRODUCT_MODEL.inventory] || 0,
                    price: data[PRODUCT_MODEL.price] || 0,
                    cost: data[PRODUCT_MODEL.cost] || 0,
                    // --- for T11
                    remark: data[PRODUCT_MODEL.remark] || '',
                    points: data[PRODUCT_MODEL.points] || 0,

                    // --- extra
                    avg_cost: avgCost,

                };
            }

            return null;
        }

        const parseOnlineCourseData = (data, categoryData = []) => {
            if (data) {
                const foundCategory = categoryData.find(el => el.id === data[ONLINE_COURSE_MODEL.category_id]);

                let videoCount = 0;
                let videoList = [];
                data[ONLINE_COURSE_MODEL.chapter_category_list].forEach(item => {
                    if (item.chapter_id_list) {
                        videoCount += item.chapter_id_list.length;

                        if (item.chapter_data) {
                            item.chapter_id_list.forEach(lectureId => {
                                const found = item.chapter_data.find(lecture => lecture.id === lectureId);
                                if (found) {
                                    videoList.push(parseOnlineCourseVideoData(found, item));
                                }
                            })
                        }
                    }
                });
                return {
                    id: data.id,
                    active: data.active,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    category_id: data[ONLINE_COURSE_MODEL.category_id],
                    course_category: foundCategory ? foundCategory.name : '',
                    name: data[ONLINE_COURSE_MODEL.name],
                    chapter_category_list: data[ONLINE_COURSE_MODEL.chapter_category_list] || [],
                    chapter_count: data[ONLINE_COURSE_MODEL.chapter_category_list].length,
                    video_count: videoCount,
                    price: data[ONLINE_COURSE_MODEL.price] || 0,
                    discount_price: data[ONLINE_COURSE_MODEL.discount_price] || 0,
                    sales: data.sales_count || 0,
                    status: data[ONLINE_COURSE_MODEL.status] || 'active',
                    thumbnail: data[ONLINE_COURSE_MODEL.thumbnail] || '',
                    lecture_video_list: videoList,
                    tutor_information: data[ONLINE_COURSE_MODEL.tutor_information] || [],
                    faq_list: data[ONLINE_COURSE_MODEL.faq_list] || [],
                    description_content: data[ONLINE_COURSE_MODEL.description_content] || '',
                    short_description: data[ONLINE_COURSE_MODEL.short_description] || '',
                };
            }

            return null;
        }

        const parseOnlineCourseVideoData = (data, chapter = null) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    thumbnail: data[ONLINE_COURSE_VIDEO_MODEL.thumbnail] || '',
                    title: data[ONLINE_COURSE_VIDEO_MODEL.title] || '',
                    description_content: data[ONLINE_COURSE_VIDEO_MODEL.description_content] || '',
                    homework: data[ONLINE_COURSE_VIDEO_MODEL.homework] || [],
                    online_course_id: data[ONLINE_COURSE_VIDEO_MODEL.online_course_id],
                    duration: data[ONLINE_COURSE_VIDEO_MODEL.duration] || 0,
                    video_id: data[ONLINE_COURSE_VIDEO_MODEL.video_id],
                    video_url: data.video_url,
                    video_title: data.video_title,
                    chapter_name: chapter ? chapter[ONLINE_COURSE_MODEL.name] : ''
                }
            }

            return null;
        }

        const parseOrderData = (data) => {
            if (data) {
                const order_type = [];
                let package_list = [];
                let package_datas = [];

                if (DataValid(data[ORDER_MODEL.package_id]) && data[ORDER_MODEL.package_id] > -1) {
                    order_type.push('package');
                    package_list = [{ id: data[ORDER_MODEL.package_id], discount_type: '', discount_value: 0 }];
                    if (data.package_data) {
                        package_datas = [data.package_data];
                    }
                } else if (DataValid(data[ORDER_MODEL.package_id_list], true)) {
                    order_type.push('package');
                    package_list = data[ORDER_MODEL.package_id_list];
                    package_datas = data.multiple_package_data ? data.multiple_package_data : [];
                } else if (DataValid(data[ORDER_MODEL.monthly_id_list], true)) {
                    order_type.push('month_pass');
                } else if (DataValid(data[ORDER_MODEL.online_course_id]) && data[ORDER_MODEL.online_course_id] > -1) {
                    order_type.push('online_course');
                } else if (DataValid(data[ORDER_MODEL.lesson_id_list], true)) {
                    order_type.push('course');
                }

                if (DataValid(data[ORDER_MODEL.product_id_list], true)) {
                    order_type.push('product');
                }
                if (DataValid(data[ORDER_MODEL.custom_items], true)) {
                    order_type.push('custom');
                }
                if (DataValid(data.skip_lessons, true)) {
                    order_type.push('skip');
                }

                let latest_subtotal = 0;
                if (data.status === 'pending' && !data.is_redeem) { // 待付款嘅course order subtotal要重新計
                    if (order_type.includes('package')) {
                        for (let i = 0; i < package_list.length; i++) {
                            const item = package_list[i];
                            const found = package_datas.find(el => el.id === item.id);
                            if (found) {
                                let unit_price = found[PACKAGE_MODEL.price];
                                if (item.discount_type === 'fix_amount') {
                                    unit_price -= item.discount_value;
                                } else if (item.discount_type === 'percentage') {
                                    unit_price = Formatter.formatMoney(unit_price * (item.discount_value / 100));
                                }
                                latest_subtotal += unit_price
                            }
                        }
                    } else if (order_type.includes('month_pass')) {
                        for (let i = 0; i < data[ORDER_MODEL.monthly_id_list].length; i++) {
                            const item = data[ORDER_MODEL.monthly_id_list][i];
                            if (data.multiple_monthly_data) {
                                const found = data.multiple_monthly_data.find(el => el.id === item.id);
                                if (found) {
                                    let unit_price = found[MONTH_PASS_MODEL.price];
                                    if (item.discount_type === 'fix_amount') {
                                        unit_price -= item.discount_value;
                                    } else if (item.discount_type === 'percentage') {
                                        unit_price = Formatter.formatMoney(unit_price * (item.discount_value / 100));
                                    }

                                    latest_subtotal += unit_price
                                }
                            }
                        }
                    } else if (order_type.includes('course')) { // course
                        for (let i = 0; i < data[ORDER_MODEL.lesson_id_list].length; i++) {
                            const item = data[ORDER_MODEL.lesson_id_list][i];
                            if (data.lesson_datas) {
                                const found = data.lesson_datas.find(el => el.id === item.id);
                                if (found) {
                                    let price = found[CLASS_MODEL.price];
                                    if (item.discount_type === 'fix_amount') {
                                        price -= item.discount_value;
                                    } else if (item.discount_type === 'percentage') {
                                        price = Formatter.formatMoney(price * (item.discount_value / 100));
                                    }

                                    latest_subtotal += price;
                                }
                            }
                        }
                    }

                    // product
                    if (order_type.includes('product')) {
                        for (let i = 0; i < data[ORDER_MODEL.product_id_list].length; i++) {
                            const item = data[ORDER_MODEL.product_id_list][i];
                            if (data.product_datas) {
                                const found = data.product_datas.find(el => el.id === item.id);
                                if (found) {
                                    let unit_price = found[PRODUCT_MODEL.price];
                                    if (item.discount_type === 'fix_amount') {
                                        unit_price -= item.discount_value;
                                    } else if (item.discount_type === 'percentage') {
                                        unit_price = Formatter.formatMoney(unit_price * (item.discount_value / 100));
                                    }

                                    latest_subtotal += (unit_price * item.amount)
                                }
                            }
                        }
                    }

                    // custom item
                    if (order_type.includes('custom')) {
                        for (let i = 0; i < data[ORDER_MODEL.custom_items].length; i++) {
                            const item = data[ORDER_MODEL.custom_items][i];
                            latest_subtotal += (item.price * item.amount);
                        }
                    }

                    // discount
                    if (data[ORDER_MODEL.discount_type] === 'fix_amount') {
                        latest_subtotal -= data[ORDER_MODEL.discount_value];
                    } else if (data[ORDER_MODEL.discount_type] === 'percentage') {
                        latest_subtotal = Formatter.formatMoney(latest_subtotal * (data[ORDER_MODEL.discount_value] / 100));
                    }

                    latest_subtotal = Formatter.formatMoney(latest_subtotal);

                    if (data.cal_subtotal !== undefined && Math.abs(data.cal_subtotal - data[ORDER_MODEL.subtotal]) > 0.01) {
                        latest_subtotal = data[ORDER_MODEL.subtotal];
                    }
                } else {
                    latest_subtotal = data[ORDER_MODEL.subtotal];
                }

                const order_date = data[ORDER_MODEL.order_date] || data.create_date || '';

                let payment_image_list = [];
                if (DataValid(data[ORDER_MODEL.payment_image_list], true)) {
                    payment_image_list = data[ORDER_MODEL.payment_image_list];
                } else if (DataValid(data[ORDER_MODEL.payment_image])) {
                    payment_image_list = [data[ORDER_MODEL.payment_image]];
                }

                let lessonDatas = []; // 清走duplicate嘅lesson
                if (DataValid(data.lesson_datas, true)) {
                    for (let i = 0; i < data.lesson_datas.length; i++) {
                        const found = lessonDatas.find(el => el.id === data.lesson_datas[i].id);
                        if (!found) {
                            lessonDatas.push(data.lesson_datas[i]);
                        }
                    }
                }

                return {
                    id: data.id,
                    active: data.active,
                    create_date: `${order_date.substring(0, 10)} ${order_date.substring(11, 16)}`,
                    status: CMS_ORDER_STATUS[data.status] || 'pending',
                    student_id: data[ORDER_MODEL.student_id],
                    school_id: data[ORDER_MODEL.school_id],
                    remark: data[ORDER_MODEL.remark],
                    payment_method: data[ORDER_MODEL.payment_method],
                    // subtotal: latest_subtotal,
                    subtotal: data[ORDER_MODEL.subtotal],
                    real_subtotal: data[ORDER_MODEL.subtotal],
                    discount_type: data[ORDER_MODEL.discount_type],
                    discount_value: data[ORDER_MODEL.discount_value],
                    payment_image: data[ORDER_MODEL.payment_image],
                    pdf_remark: data[ORDER_MODEL.pdf_remark] || '',
                    pay_date: data[ORDER_MODEL.pay_date] || '',
                    approver_id: data.status === 'paid' && DataValid(data[ORDER_MODEL.approver_id]) ? data[ORDER_MODEL.approver_id] : -1,
                    staff_id: data[ORDER_MODEL.staff_id] || -1,

                    order_type: order_type,
                    lesson_list: data[ORDER_MODEL.lesson_id_list],
                    lesson_datas: lessonDatas.map(el => parseLessonData(el)),
                    product_list: data[ORDER_MODEL.product_id_list],
                    product_datas: data.product_datas ? data.product_datas.map(el => parseProductData(el)) : [],
                    package_list: package_list,
                    package_datas: package_datas.map(parsePackageData),
                    month_pass_list: data[ORDER_MODEL.monthly_id_list] || [],
                    month_pass_datas: data.multiple_monthly_data ? data.multiple_monthly_data.map(parseMonthPassData) : [],
                    month_pass_selected_months: data.selected_months || [],
                    month: data.create_date ? data.create_date.substring(5, 7) : '',

                    student_name: data.student_data ? _getDisplayStudentName(data.student_data) : '',
                    student_code: data.student_data ? data.student_data[STUDENT_MODEL.student_code] || '' : '',
                    grade: data.student_data ? data.student_data[STUDENT_MODEL.grade] : '',
                    student_active: data.student_data ? data.student_data.active : false,

                    custom_items: data[ORDER_MODEL.custom_items] ? data[ORDER_MODEL.custom_items] : [],
                    is_redeem: data.is_redeem || false,
                    order_date: order_date,
                    payment_image_list: payment_image_list,
                    skip_lessons: data.skip_lessons || [],
                    skip_lessons_data: data.skip_lessons_data ? data.skip_lessons_data.map(el => parseLessonData(el)) : [],
                    upload_payment_date: data[ORDER_MODEL.upload_payment_date] ? `${data[ORDER_MODEL.upload_payment_date].substring(0, 10)} ${data[ORDER_MODEL.upload_payment_date].substring(11, 16)}` : '',
                    trial_lesson: data.trial_lesson || [],
                    pdf_order_data: data.pdf_order_data ? parseOrderData(data.pdf_order_data) : null, // paid咗之後先有，paid咗啲receipt lesson唔可以改
                    coupon_data: data.coupon_data ? parseCouponData(data.coupon_data) : null,
                    invoice_pdf: data.invoice_pdf || '',
                    receipt_pdf: data.receipt_pdf || '',
                    void_remark: data.void_remark || '',

                    subtotal_raw: data[ORDER_MODEL.subtotal],
                    unpaid_lesson_datas: data.unpaid_lesson ? data.unpaid_lesson.map(el => parseLessonData(el)) : [],
                    except_lesson_id_list: data.except_lesson_id_list || [],

                    // -- 退款
                    debit_package_count: data.debit_package_count || 0,
                    debit_lesson_ids: data.debit_lesson_ids || [],
                    debit_product_ids: data.debit_product_ids || [],
                    debit_amount: data.debit_amount || 0,
                    debit_remark: data.debit_remark || '',
                    debit_pdf_file: data.debit_pdf_file || '',
                    debit_payment_method: data.debit_payment_method || '',

                    // -- Online Course
                    online_course_id: order_type.includes('online_course') ? data[ORDER_MODEL.online_course_id] : -1,
                    online_course_data: data.online_course_data ? parseOnlineCourseData(data.online_course_data) : null,

                    // ---- Only T21 ----
                    sign: data[ORDER_MODEL.sign] || '',
                    custom_invoice_number: data[ORDER_MODEL.custom_invoice_number] || '',
                };
            }

            return null;
        }

        const parsePackageData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    name: data[PACKAGE_MODEL.name],
                    lesson_count: data[PACKAGE_MODEL.lesson_count],
                    price: data[PACKAGE_MODEL.price],
                    schools: data[PACKAGE_MODEL.schools],
                };
            }

            return null;
        }

        const parseMonthPassData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    name: data[MONTH_PASS_MODEL.name],
                    price: data[MONTH_PASS_MODEL.price],
                    type: data[MONTH_PASS_MODEL.type],
                    days: data[MONTH_PASS_MODEL.days],
                    schools: data[MONTH_PASS_MODEL.schools] || [],
                };
            }

            return null;
        }

        const parseRequirementData = (data, studentData = [], lessonData = []) => {
            if (data) {
                const foundStudent = studentData.find(el => el.id === data.student_id);
                const foundToLesson = lessonData.find(el => el.id === data.to_lesson);
                const foundFromLesson = lessonData.find(el => el.id === data.from_lesson);
                return {
                    ...data,
                    create_date: data.create_date ? `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}` : '',
                    status: data.approve_status,
                    student_name: _getDisplayStudentName(foundStudent, false),
                    to_lesson_data: foundToLesson,
                    from_lesson_data: foundFromLesson,
                };
            }

            return null;
        }

        const parsePointsRecordData = (data) => {
            if (data) {
                let type = 'order';
                if (data.data_type === 'points_usage_data') {
                    if (DataValid(data.staff_id) && data.staff_id > -1) {
                        type = 'admin';
                    } else {
                        type = 'redeem';
                    }
                } else if (data.type) {
                    type = data.type;
                }
                return {
                    id: data.id,
                    active: data.active,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    type: type,
                    points: data.data_type === 'points_usage_data' ? (data.value * -1) : data.value,
                    remark: data.remark || '',
                    order_id: DataValid(data.order_id) ? data.order_id : -1,
                };
            }

            return null;
        }

        const parseNotifyData = (data) => {
            if (data) {
                let send_date_date = '';
                let send_date_time = '';
                if (data.send_date) {
                    send_date_date = data.send_date.substring(0, 10);
                    send_date_time = data.send_date.substring(11, 16);
                }
                return {
                    ...data,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    send_date_date,
                    send_date_time
                };
            }

            return null;
        }

        const parseBlogData = (data, categoryData = []) => {
            if (data && DataValid(data['id'])) {
                let publish_date = '';
                let publish_time = '';
                if (data.publish) {
                    publish_date = data.publish.substring(0, 10);
                    publish_time = data.publish.substring(11, 16);
                }

                const foundCategory = categoryData.find(el => el.id === data.category);
                return {
                    ...data,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    publish_date,
                    publish_time,
                    category_name: foundCategory ? foundCategory.name : ''
                };
            }

            return null;
        }

        const parseVideoData = (data, categoryData = []) => {
            if (data) {
                const foundCategory = categoryData.find(el => el.id === data.category);
                return {
                    ...data,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    category_name: foundCategory ? foundCategory.name : ''
                };
            }

            return null;
        }

        const parseLeaveData = (data, tutorData = []) => {
            if (data) {
                const found = tutorData.find(el => el.id === data.staff_id);
                return {
                    ...data,
                    create_date: data.create_date ? `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}` : '',
                    name: found ? found.name : '',
                };
            }

            return null;
        }

        const parseLogData = (data, accountData = null) => {
            if (data) {
                let actionType = data.action;
                switch (data.action) {
                    case 'edit':
                    case 'drop':
                    case 'approve':
                    case 'renew':
                    case 'upload':
                    case 'refund':
                    case 'void':
                    case 'renew':
                        actionType = 'edit';
                        break;
                    case 'remove':
                        actionType = 'remove';
                        break;
                    case 'add':
                        actionType = 'add';
                        break;
                }
                return {
                    ...data,
                    create_date: `${data.create_date.substring(0, 10)} ${data.create_date.substring(11, 16)}`,
                    action_type: actionType,
                    user_type: accountData ? accountData.user_type : data.account_type,
                    account_username: accountData ? accountData.name : data.account_id,
                }
            }

            return null;
        }

        const parseCouponData = (data) => {
            if (data) {
                return {
                    id: data.id,
                    active: data.active,
                    code: data[COUPON_MODEL.code],
                    name: data[COUPON_MODEL.name],
                    discount_type: data[COUPON_MODEL.discount_type],
                    discount_value: data[COUPON_MODEL.discount_value],
                    students: data[COUPON_MODEL.students] || [],
                    limit_type: data[COUPON_MODEL.limit_type],
                    usage_limit: data[COUPON_MODEL.usage_limit] || -1,
                };
            }

            return null;
        }

        const parseCacheCheck = (data) => {
          console.log("parseCacheCheck");
          console.log(data);
            if (data) {
                let date = '';
                let time = '';
                if (data.time) {
                    date = data.time.substring(0, 10);
                    time = data.time.substring(11, 19);
                }
                return {
                    ...data,
                    datetime: `${data.time.substring(0, 10)} ${data.time.substring(11, 19)}`
                };
            }

            return null;
        }

        Vue.prototype.$Fetcher = new (function () {
            const devLog = Vue.prototype.$common.log;
            const vm = this;

            const parseFilePayload = function (file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onload = event => {
                        const payload = {
                            upload_data: event.target.result,
                            upload_file_type: file.type.split('/')[1],
                        }
                        resolve(payload);
                    }
                    reader.onerror = () => {
                        reject('message.errorOccur');
                    }
                    reader.readAsDataURL(file)
                })
            }
            /**
             * @param {File | Object<{upload_data: string(base64), upload_file_type: string}>} file
             */
            this.UploadFile = async function (file) {
                try {
                    let payload = null;
                    if (DataValid(file) && typeof file === 'object' && DataValid(file['upload_data'])) {
                        payload = file;
                    } else {
                        payload = await parseFilePayload(file);
                    }
                    if (DataValid(payload)) {
                        const data = await Vue.prototype.$XHR.api('upload_file', payload);
                        if (typeof data === 'string') {
                            devLog('----------> XHR [SUCCESS]: UploadFile');
                            devLog(data)
                            return Promise.resolve(data);
                        }
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UploadFile');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * @param {File} file
             */
            this.UploadFileNew = async function (file) {
                try {
                    let uploaded = {
                        key: (option.config.VUE_APP_RUN_MODE).toLowerCase(),
                        file: file,
                    }
                    let useOld = false;
                    const format = file.type.split('/')[1];
                    if (['png', 'jpeg', 'jpg'].includes(format)) {
                        uploaded['upload_image'] = '';
                    } else if (['mp4', 'webm'].includes(format)) {
                        uploaded['upload_video'] = '';
                    } else if (format === 'pdf') {
                        useOld = true;
                    } else {
                        throw 'message.fileFormatNotSupport'
                    }

                    let data = null;
                    if (useOld) {
                        data = await vm.UploadFile(file);
                    } else {
                        data = await Vue.prototype.$XHR.upload(uploaded);
                    }
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UploadFileNew');
                        devLog(data)
                        return Promise.resolve(data);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UploadFileNew');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.ZipFiles = async function (pdfs) {
                try {
                    const data = await Vue.prototype.$XHR.api('zip_pdfs', { pdfs });
                    devLog('----------> XHR [SUCCESS]: ZipFiles');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ZipFiles');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            this.Login = async function (username, password) {
                try {
                    const uploaded = {
                        username,
                        password,
                        gen_jwt_token: true
                    }
                    const data = await Vue.prototype.$XHR.api('staff_login', uploaded);
                    if (data.active && !data[STAFF_MODEL.login_block]) {
                        const formattedData = parseStaffData(data);
                        if (DataValid(formattedData)) {
                            const d = {
                                ...formattedData,
                                access_token: data.access_token,
                                refresh_token: data.refresh_token,
                            };
                            devLog('----------> XHR [SUCCESS]: Login');
                            devLog(d)
                            return Promise.resolve(d);
                        }

                        throw 'message.errorOccur';
                    } else {
                        throw 'message.loginAccountInv';
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: Login');
                    devLog(res);
                    switch (res.data) {
                        case 'login fail':
                            return Promise.reject('message.loginAccountInv');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.StudentLogin = async function (username, password) {
                try {
                    const uploaded = {
                        username,
                        password
                    }
                    const data = await Vue.prototype.$XHR.api('student_login', uploaded);
                    if (data.active && !data[STUDENT_MODEL.login_block]) {
                        const formattedData = parseStudentData(data);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: StudentLogin');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }

                        throw 'message.errorOccur';
                    } else {
                        throw 'message.loginAccountInv';
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: StudentLogin');
                    devLog(res);
                    switch (res.data) {
                        case 'login fail':
                            return Promise.reject('message.loginAccountInv');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            this.GetSetting = async function () {
                try {
                    const data = await Vue.prototype.$XHR.api('get_general_setting', {});
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetSetting');
                        const formattedData = { ...data };
                        if (DataValid(formattedData.application_fields, true)) {
                            for (let i = 0; i < formattedData.application_fields.length; i++) {
                                for (let key in STUDENT_MODEL) {
                                    if (STUDENT_MODEL[key] === formattedData.application_fields[i].field_key) {
                                        formattedData.application_fields[i]['field_key'] = key;
                                        break;
                                    }
                                }
                            }
                        }
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * -- 基本設定
             * @param {String} logo - Required
             * @param {String} custom_text - Required
             * @param {String} phone
             * @param {String} email
             * @param {String} whatsapp_message
             * @param {String} member_terms_field - 學生註冊條款和細則 [used in register_link]
             * @param {String} whatsapp_number
             * @param {Number} month_period
             * @param {Array<string>} admin_notification_email - 接收通知電郵 (T02)
             * @param {String} payment_terms - 付款須知 (T36) [used in payment_link]
             * -- 付款設定
             * @param {Object<number: '', code: { file: '', name: '' }, link: ''>} payment_info_payme
             * @param {Object<number: '', code: { file: '', name: '' }, phone_email: ''>} payment_info_fps
             * @param {Object<number: '', code: { file: '', name: '' }>} payment_info_wechat_pay
             * @param {Object<number: '', code: { file: '', name: '' }>} payment_info_alipay
             * @param {Array<{bank_name: '', beneficiary_name: '', account_number: ''}>} payment_info_bank_transfer
             * @param {Array<string<'payme' | 'fps' | 'wechat_pay' | 'alipay' | 'bank_transfer' | 'cash'>>} accept_payment_methods
             * -- 積分設定
             * @param {Boolean} points_enable
             * @param {Number} points_per_lesson
             * @param {Number} points_expiry_days
             * @param {Number} points_welcome
             * @param {Number} points_full_attend
             * -- 學生調堂設定
             * @param {Boolean} switch_active
             * @param {Boolean} need_approve
             * @param {string<'all' | 'grade' | 'course'>} switch_limit
             * @param {Number} request_before_value
             * @param {string<'Hours' | 'Days'>} request_before_unit
             * -- 網頁設定
             * @param {Array<{image: '', link: ''}>} online_course_banner_list
             * @param {Object<付款設定object>} online_course_payment_data
             * -- 關於我們
             * @param {String} about_us
             * -- 組別管理
             * @param {Boolean} need_grade
             * @param {Boolean} upgrade_setting
             * -- 實用連結 (T11)
             * @param {String} useful_links_edit
             * -- 生日及節慶獎賞 (T11)
             * @param {String} promotions_edit
             * -- 常見問題 (T11)
             * @param {String} faq_edit
             * -- 商業合作和贊助 (T11)
             * @param {String} sponsor_edit
             * -- 學生表格
             * @param {Array<{ 
             *  field_name_zh: '',
             *  field_name_en: '', 
             *  field_key: '', 
             *  field_type: 'freetext' | 'dropdown', 
             *  is_multiple: false, 
             *  is_required: false, 
             *  options: Array<{ option_name_zh: '', option_name_en: '', option_value: ''}>
             * }>} student_field
             * @param {Number} latest_student_field_index
             * -- 學生報名表
             * @param {Array<{field_key: '', required: false}>} application_fields
             * @param {Boolean} application_sign_required
             * @param {String} application_terms_and_conditions_zh
             * @param {String} application_terms_and_conditions_en
             */
            this.UpdateSetting = async function (update = {}) {
                try {
                    let get_setting = await vm.GetSetting();
                    const keyLen = Object.keys(update).length;
                    if (keyLen === 1 && update['need_grade'] !== undefined && get_setting['need_grade'] === update['need_grade']) {
                        return Promise.resolve(get_setting);
                    }

                    for (const key in update) {
                        if (key === 'student_field') {
                            let index = get_setting['latest_student_field_index'] || 0;
                            const list = [...update[key]];
                            for (let i = 0; i < list.length; i++) {
                                if (!DataValid(list[i]['field_key'])) {
                                    index += 1;
                                    list[i]['field_key'] = `student_field_${index}`;
                                }
                            }
                            get_setting['student_field'] = list;
                            get_setting['latest_student_field_index'] = index;
                        } else {
                            get_setting[key] = update[key];
                        }
                    }
                    if (DataValid(get_setting['application_fields'], true)) {
                        const list = [...get_setting['application_fields']];
                        for (let i = 0; i < list.length; i++) {
                            if (STUDENT_MODEL[list[i]['field_key']]) {
                                list[i]['field_key'] = STUDENT_MODEL[list[i]['field_key']];
                            }
                        }
                        get_setting['application_fields'] = list;
                    }
                    const data = await Vue.prototype.$XHR.api('edit_general_setting', get_setting);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateSetting');
                        devLog(data)
                        return Promise.resolve(data);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增Account/Staff
             * ===== Required =====
             * @param {String} password_data
             * @param {String} username
             * 
             */
            this.NewAccount = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, STAFF_MODEL);
                    const uploaded = {
                        google_sync: false,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_staff', uploaded);
                    const formattedData = parseStaffData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewAccount');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewAccount');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                        case "email exist in student":
                            return Promise.reject('message.accountExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateStaff = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, STAFF_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_staff', payload);
                    const formattedData = parseStaffData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateStaff');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateStaff');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                        case "email exist in student":
                            return Promise.reject('message.accountExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.DeleteStaff = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_staff', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteStaff');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteStaff');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetStaffs = async function (filters = {}) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_staff', filters);
                    if (data['total'] && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseStaffData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStaffs');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffs');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetStaffsByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'staff_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            const formattedData = data.map(parseStaffData);
                            devLog('----------> XHR [SUCCESS]: GetStaffsByIdList');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffsByIdList');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.resolve([]);
                    }
                }
            }
            this.GetStaffById = async function (id) {
                try {
                    const payload = {
                        data_type: 'staff_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseStaffData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetStaffById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'noData';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStaffById');
                    devLog(res);
                    if (res && (res === 'abort' || res.data === 'abort')) {
                        return Promise.reject(displayError(res));
                    } else {
                        return Promise.reject('noData');
                    }
                }
            }
            this.StaffChangePassword = async function (id, newPassword) {
                try {
                    const payload = {
                        id: id,
                        password_data: newPassword
                    }
                    await Vue.prototype.$XHR.api('edit_staff', payload);
                    devLog('----------> XHR [SUCCESS]: StaffChangePassword');
                    return Promise.resolve(true);

                } catch (res) {
                    devLog('----------> XHR [FAIL]: StaffChangePassword');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.BlockStaff = async function (id) {
                try {
                    const payload = {
                        id: id,
                        login_block: true
                    }
                    const data = await Vue.prototype.$XHR.api('edit_staff', payload);
                    const formattedData = parseStaffData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: BlockStaff');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: BlockStaff');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.RemoveStaffBlock = async function (id) {
                try {
                    const payload = {
                        id: id,
                        login_block: false
                    }
                    const data = await Vue.prototype.$XHR.api('edit_staff', payload);
                    const formattedData = parseStaffData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: RemoveStaffBlock');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveStaffBlock');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
             * 薪酬報告
             * ===== Required =====
             * @param {Number} center
             * @param {String} year_month - YYYY-MM
             * ===== Optional =====
             * @param {Number} filter_page - start from 0
             * @param {Number} filter_limit
             */
            this.GetSalaryReports = async function (filters = {}) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_staff_salary_report_data', filters);
                    if (DataValid(data, true)) {
                        let filteredData = data;
                        if (filters['filter_page'] !== undefined && filters['filter_limit'] !== undefined) {
                            filteredData = data.slice(filters['filter_page'] * filters['filter_limit'], (filters['filter_page'] * filters['filter_limit'] + filters['filter_limit']));
                        }

                        const returnedData = {
                            data: filteredData,
                            total: data.length,
                        };
                        devLog('----------> XHR [SUCCESS]: GetSalaryReports');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSalaryReports');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            /**
            * 薪酬報告 - 本月Bonus
            * ==== Required ====
            * @param {Number} staff_id 
            * @param {String} month - YYYY-MM
            * @param {Number} value
            * ===== Optional =====
            * @param {Number} center_id
            */
            this.NewStaffBonus = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const uploaded = {
                        ...payload
                    }
                    const data = await Vue.prototype.$XHR.api('new_staff_bonus', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewStaffBonus');
                        devLog(data)
                        return Promise.resolve(data);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewStaffBonus');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateStaffBonus = async function (id, update) {
                try {
                    const payload = {
                        id: id,
                        ...update
                    }
                    const data = await Vue.prototype.$XHR.api('edit_staff_bonus', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateStaffBonus');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateStaffBonus');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * 薪金簽收單
             * ======== Required ========
             * @param {String} month - YYYY-MM
             * @param {Number} staff_id
             * ======== Optional ========
             * @param {Number} center_id
             */
            this.GenSalaryInvoice = async function (month, staff_id, center_id = -1) {
                try {
                    let payload = {
                        month,
                        staff_id
                    }
                    if (center_id > -1) {
                        payload['center_id'] = center_id;
                    }
                    const data = await Vue.prototype.$XHR.api('get_salary_pdf', payload);
                    const files = [];
                    if (DataValid(data) && data.pdf) {
                        devLog('----------> XHR [SUCCESS]: GenSalaryInvoice');
                        devLog(data)
                        if (data.pdf) {
                            files.push(data.pdf)
                        }
                        if (data.excel) {
                            files.push(data.excel)
                        }
                        if (files.length > 0) {
                            return Promise.resolve(files);
                        }
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenSalaryInvoice');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
             * 導師日曆
             * ===== Required =====
             * @param {Number} tutor_id
             * @param {String} date
             * @param {String} start_time
             * @param {String} end_time
             * ===== Optional =====
             * @param {Number} school_id
             */
            this.NewTutorCalendar = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, TUTOR_CALENDAR_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_staff_extra_time', uploaded);
                    const formattedData = parseTutorCalendarData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewTutorCalendar');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewTutorCalendar');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateTutorCalendar = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, TUTOR_CALENDAR_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_staff_extra_time', payload);
                    const formattedData = parseTutorCalendarData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateTutorCalendar');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateTutorCalendar');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteTutorCalendar = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('remove_staff_extra_time', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteTutorCalendar');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteTutorCalendar');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ===== Optional =====
             * @param {Number} center_id
             * @param {String} date
             * @param {String} year_month - YYYY-MM
             * @param {String} start_date
             * @param {String} end_date
             * @param {Array<number>} staff_id_list
             */
            this.GetTutorCalendars = async function (filters = {}) {
                try {
                    const joinTutorData = filters['join_tutor_data'] || false;
                    if (filters['join_tutor_data'] !== undefined) delete filters['join_tutor_data'];

                    const payload = {
                        ...filters
                    };
                    const data = await Vue.prototype.$XHR.api('get_staff_extra_time_summary', payload);
                    if (DataValid(data, true)) {
                        const dataList = [];
                        data.forEach(item => {
                            if (DataValid(item.date) && DataValid(item.time_list, true)) {
                                item.time_list.forEach(elm => {
                                    dataList.push({
                                        ...elm,
                                        active: true,
                                        date: item.date
                                    });
                                })
                            }
                        })

                        if (dataList.length) {
                            let tutorData = [];
                            if (joinTutorData) {
                                const idList = mapIds(dataList, TUTOR_CALENDAR_MODEL.tutor_id);
                                tutorData = await vm.GetStaffsByIdList(idList);
                            }

                            const formattedData = dataList.map(el => parseTutorCalendarData(el, tutorData));
                            devLog('----------> XHR [SUCCESS]: GetTutorCalendars');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetTutorCalendars');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject([]);
                    }
                }
            }

            /**
             * 請假申請
             * @param {String} date
             * @param {String} comment
             */
            this.ApplyLeave = async function (update, staff_id) {
                try {
                    const payload = {
                        ...update,
                        staff_id,
                        status: 'pending'
                    }
                    const data = await Vue.prototype.$XHR.api('new_tutor_leave', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewTutorCalendar');
                        devLog(data)
                        return Promise.resolve(data);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewTutorCalendar');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetLeaveApplications = async function (filters = {}) {
                try {
                    const joinTutorData = filters['join_tutor_data'] || false;
                    if (filters['join_tutor_data'] !== undefined) delete filters['join_tutor_data'];

                    const payload = {
                        data_type: 'tutor_leave_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && DataValid(data['data'], true)) {
                        let tutorData = [];
                        if (joinTutorData) {
                            const idList = mapIds(data['data'], 'staff_id');
                            tutorData = await vm.GetStaffsByIdList(idList);
                        }
                        const formattedData = data['data'].map(el => parseLeaveData(el, tutorData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetLeaveApplications');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLeaveApplications');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.ApproveLeaveApplication = async function (id) {
                try {
                    const uploaded = {
                        id,
                        status: 'accepted'
                    }

                    const data = await Vue.prototype.$XHR.api('edit_tutor_leave', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: ApproveLeaveApplication');
                        devLog(data)
                        return Promise.resolve(true);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ApproveLeaveApplication');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.RejectLeaveApplication = async function (id) {
                try {
                    const uploaded = {
                        id,
                        status: 'rejected'
                    }

                    const data = await Vue.prototype.$XHR.api('edit_tutor_leave', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: RejectLeaveApplication');
                        devLog(data)
                        return Promise.resolve(true);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RejectLeaveApplication');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增分校
             * ==== Required ====
             * @param {String} name 
             * @param {String} address
             * ===== Optional =====
             * @param {String} logo
             * @param {String} custom_text
             * @param {String} member_terms_field - terms
             * @param {Boolean} website_and_app
             * @param {Array<
             * { type: 'payme', active: false, number: '', code: { file: '', name: '' }, link: '' },
             * { type: 'fps', active: false, number: '', code: { file: '', name: '' }, phone_email: '' },
             * { type: 'wechat_pay', active: false, number: '', code: { file: '', name: '' } },
             * { type: 'alipay', active: false, number: '', code: { file: '', name: '' } },
             * { type: 'bank_transfer', active: false, info_list: Array<{bank_name: '', beneficiary_name: '', account_number: ''}> },
             * { type: 'cash', active: false }
             * >} payment_method
             * @param {String} phone
             * @param {String} email
             * @param {String} whatsapp_message
             * @param {Number} month_period
             */
            this.NewSchool = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, SCHOOL_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_center', uploaded);
                    const formattedData = parseSchoolData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewSchool');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewSchool');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateSchool = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, SCHOOL_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    let onlyMonthPeriod = false;
                    if (Object.keys(update).length === 1 && update['month_period'] !== undefined) {
                        onlyMonthPeriod = true;
                    }
                    let data = null;
                    if (!onlyMonthPeriod) {
                        data = await Vue.prototype.$XHR.api('edit_center', payload);
                    }
                    if (payload['month_period'] !== undefined) {
                        const result = await UpdateSchoolMonthPeriod(id, payload['month_period']);
                        if (result) {
                            if (onlyMonthPeriod) {
                                data = result;
                            }
                            if (data) {
                                data['month_period'] = payload['month_period'];
                            }
                        }
                    }

                    const formattedData = parseSchoolData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateSchool');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateSchool');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            const UpdateSchoolMonthPeriod = async function (id, month_period = 1) {
                try {
                    const payload = {
                        id: id,
                        month_period: month_period
                    }
                    const data = await Vue.prototype.$XHR.api('update_center_period', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateSchoolMonthPeriod');
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateSchoolMonthPeriod');
                    devLog(res);
                    return Promise.resolve(null);
                }
            }
            this.DeleteSchool = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_center', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteSchool');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteSchool');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetSchools = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'center_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseSchoolData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetSchools');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSchools');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            const GetAllSchools = async function () {
                try {
                    const data = await vm.GetSchools();
                    devLog('----------> XHR [SUCCESS]: GetAllSchools');
                    devLog(data.data)
                    return Promise.resolve(data.data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAllSchools');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetSchoolsByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'center_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            const formattedData = data.map(parseSchoolData);
                            devLog('----------> XHR [SUCCESS]: GetSchoolsByIdList');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSchoolsByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetSchoolById = async function (id) {
                try {
                    const payload = {
                        data_type: 'center_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data) && DataValid(data.id)) {
                        const formattedData = parseSchoolData(data);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: GetSchoolById');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }

                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSchoolById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }


            this.GetCacheTime = async function () {
                try {
                    const payload = {};
                    const data = await Vue.prototype.$XHR.api('check_cache_time', payload);
                    if (DataValid(data) && DataValid(data.time)) {
                      const formattedData = parseCacheCheck(data);
                      if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetCacheTime');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                      }
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCacheTime');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }



            /**
             * 新增學生
             * ===== Required =====
             * @param {String} password_data
             * @param {String} username
             * ===== Optional =====
             * @param {Boolean} generate_username - 如果冇入username，會自動gen
             */
            this.NewStudent = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, STUDENT_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_student', uploaded);
                    const formattedData = parseStudentData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewStudent');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewStudent');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                            return Promise.reject('message.accountExist');
                        case "email exist":
                            return Promise.reject('message.emailExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateStudent = async function (id, update) {
                try {
                    let joinSiblings = update['join_siblings'] || false;
                    if (update['join_siblings'] !== undefined) delete update['join_siblings'];

                    let joinTeamMember = update['join_team_member'] || false;
                    if (update['join_team_member'] !== undefined) delete update['join_team_member'];

                    const formattedPayload = convertCMSKeyToBackendKey(update, STUDENT_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_student', payload);
                    let siblingData = [];
                    let studentIds = [];
                    if (joinSiblings) {
                        if (DataValid(data[STUDENT_MODEL.siblings], true)) {
                            studentIds = data[STUDENT_MODEL.siblings].map(el => el.student_id);
                        }
                    }
                    if (joinTeamMember) {
                        if (DataValid(data[STUDENT_MODEL.team_member], true)) {
                            for (let i = 0; i < data[STUDENT_MODEL.team_member].length; i++) {
                                if (!studentIds.includes(data[STUDENT_MODEL.team_member][i])) {
                                    studentIds.push(data[STUDENT_MODEL.team_member][i]);
                                }
                            }
                        }
                    }
                    if (studentIds.length > 0) {
                        siblingData = await vm.GetStudentsByIdList(studentIds);
                    }
                    const formattedData = parseStudentData(data, siblingData);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateStudent');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateStudent');
                    devLog(res);
                    switch (res.data) {
                        case "username exist":
                            return Promise.reject('message.accountExist');
                        case "email exist":
                            return Promise.reject('message.emailExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            const RemoveInactiveStudentLessons = async function (student_id) {
                try {
                    if (!isAppMode(['T01'])) {
                        await Vue.prototype.$XHR.api('student_quit', { student_id });
                        devLog('----------> XHR [SUCCESS]: RemoveInactiveStudentLessons');
                    }
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveInactiveStudentLessons');
                    devLog(res);
                    if (res.data === 'fail') {
                        return Promise.resolve(true);
                    } else {
                        return Promise.resolve('message.quitUserRemoveLessonError');
                    }
                }
            }
            this.DeleteStudent = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_student', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteStudent');

                    // 退學將會移除該學生已報名但尚未開始的所有課堂
                    const removed = await RemoveInactiveStudentLessons(id);
                    if (removed === true) {
                        return Promise.resolve(true);
                    } else {
                        return Promise.reject(removed);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteStudent');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * @param {Number} filter_page - used with `filter_limit`
             * @param {Number} filter_limit - used with `filter_page`
             * @param {String} sort_dir - 'desc' | 'asc'
             * @param {String} order_by
             * @param {String} search - search name/student code/phone
             * @param {Number} center_id
             * @param {Array<key: string, value: any>} filter_item
             */
            this.GetStudents = async function (filters = {}) {
                try {
                    const joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const payload = {
                        data_type: 'student_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && DataValid(data['data'], true)) {
                        const schoolData = joinSchoolData ? await GetAllSchools() : [];
                        const formattedData = data['data'].map(el => parseStudentData(el, [], schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStudents');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudents');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetStudentsByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'student_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            const formattedData = data.map(el => parseStudentData(el));
                            devLog('----------> XHR [SUCCESS]: GetStudentsByIdList');
                            devLog(formattedData);
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentsByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            const GetStudentsWithLastLessonByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'student_data',
                            id_list: id_list,
                            ...filters
                        };

                        const data = await Vue.prototype.$XHR.api('get_student_and_lesson', payload);
                        if (DataValid(data, true)) {
                            const formattedData = data.map(el => parseStudentData(el));
                            devLog('----------> XHR [SUCCESS]: GetStudentsWithLastLessonByIdList');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentsWithLastLessonByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetStudentById = async function (id, filters = {}) {
                try {
                    const payload = {
                        data_type: 'student_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    let siblingData = [];
                    let studentIds = [];
                    if (filters['join_siblings']) {
                        if (DataValid(data[STUDENT_MODEL.siblings], true)) {
                            studentIds = data[STUDENT_MODEL.siblings].map(el => el.student_id);
                        }
                    }
                    if (filters['join_team_member']) {
                        if (DataValid(data[STUDENT_MODEL.team_member], true)) {
                            for (let i = 0; i < data[STUDENT_MODEL.team_member].length; i++) {
                                if (!studentIds.includes(data[STUDENT_MODEL.team_member][i])) {
                                    studentIds.push(data[STUDENT_MODEL.team_member][i]);
                                }
                            }
                        }
                    }
                    if (studentIds.length > 0) {
                        siblingData = await vm.GetStudentsByIdList(studentIds);
                    }

                    const formattedData = parseStudentData(data, siblingData);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetStudentById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'noData';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentById');
                    devLog(res);
                    if (res && (res === 'abort' || res.data === 'abort')) {
                        return Promise.reject(displayError(res));
                    } else {
                        return Promise.reject('noData');
                    }
                }
            }
            this.StudentQuit = async function (id) {
                try {
                    const payload = {
                        id: id,
                        status: 'quit',
                    }

                    await Vue.prototype.$XHR.api('edit_student', payload);
                    devLog('----------> XHR [SUCCESS]: StudentQuit');

                    // 退學將會移除該學生已報名但尚未開始的所有課堂
                    const removed = await RemoveInactiveStudentLessons(id);
                    if (removed === true) {
                        return Promise.resolve(true);
                    } else {
                        return Promise.reject(removed);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: StudentQuit');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.StudentRemission = async function (id) {
                try {
                    const payload = {
                        id: id,
                        status: 'active',
                    }
                    const data = await Vue.prototype.$XHR.api('edit_student', payload);
                    const formattedData = parseStudentData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: StudentRemission');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: StudentRemission');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.BlockStudent = async function (id) {
                try {
                    const payload = {
                        id: id,
                        login_block: true
                    }
                    const data = await Vue.prototype.$XHR.api('edit_student', payload);
                    const formattedData = parseStudentData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: BlockStudent');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: BlockStudent');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.RemoveStudentBlock = async function (id) {
                try {
                    const payload = {
                        id: id,
                        login_block: false
                    }
                    const data = await Vue.prototype.$XHR.api('edit_student', payload);
                    const formattedData = parseStudentData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: RemoveStudentBlock');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveStudentBlock');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.StudentChangePassword = async function (id, newPassword) {
                try {
                    const payload = {
                        id: id,
                        password_data: newPassword
                    }
                    await Vue.prototype.$XHR.api('edit_student', payload);
                    devLog('----------> XHR [SUCCESS]: StudentChangePassword');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: StudentChangePassword');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpgradeStudents = async function () {
                try {
                    await Vue.prototype.$XHR.api('upgrade_student', {});
                    devLog('----------> XHR [SUCCESS]: UpgradeStudents');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpgradeStudents');
                    devLog(res);
                    switch (res.data) {
                        case 'already upgrade in 30day':
                            return Promise.reject('message.cannotUpgradeWithinDays');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpgradeStudentsWithCustomGrade = async function () {
                try {
                    await Vue.prototype.$XHR.api('custom_upgrade_student', {});
                    devLog('----------> XHR [SUCCESS]: UpgradeStudents');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpgradeStudents');
                    devLog(res);
                    switch (res.data) {
                        case 'already upgrade in 30day':
                            return Promise.reject('message.cannotUpgradeWithinDays');
                        case 'grade missing':
                            return Promise.reject('message.gradeMissing');
                        case 'nothing upgrade':
                            return Promise.resolve(true);
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.ImportStudent = async function (students = []) {
                try {
                    let formattedStudents = JSON.parse(JSON.stringify(students));
                    for (let i = 0; i < formattedStudents.length; i++) {
                        formattedStudents[i] = convertCMSKeyToBackendKey(formattedStudents[i], STUDENT_MODEL);
                    }
                    const data = await Vue.prototype.$XHR.api('import_student', {
                        students: formattedStudents
                    });
                    const invStudents = [];
                    const importeds = [];
                    for (let i = 0; i < data.length; i++) {
                        if (typeof data[i] === 'string') {
                            invStudents.push(`${students[i].student_name} (${students[i].username}): ${data[i].toUpperCase()}`);
                        } else if (typeof data[i] === 'object' && !data[i].id) {
                            invStudents.push(`${students[i].student_name} (${students[i].username}): ERROR`);
                        } else {
                            const formattedData = parseStudentData(data[i]);
                            if (formattedData) {
                                importeds.push(formattedData);
                            } else {
                                invStudents.push(`${students[i].student_name} (${students[i].username}): ERROR`);
                            }
                        }
                    }

                    if (invStudents.length > 0) {
                        devLog(invStudents);
                        return Promise.resolve({ result: 'fail', data: invStudents });
                    } else {
                        devLog('----------> XHR [SUCCESS]: ImportStudent');
                        devLog(importeds);
                        return Promise.resolve({ result: 'success', data: importeds });
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ImportStudent');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
             * 學業成績
             * ====== required =====
             * @param {Number} student_id
             */
            this.NewStudentScore = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, STUDENT_SCORE_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_score', uploaded);
                    const formattedData = parseStudentScoreData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewStudentScore');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewStudentScore');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateStudentScore = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, STUDENT_SCORE_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_score', payload);
                    const formattedData = parseStudentScoreData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateStudentScore');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateStudentScore');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteStudentScore = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_score', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteStudentScore');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteStudentScore');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetStudentScores = async function (filters) {
                try {
                    const payload = {
                        data_type: 'score_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(parseStudentScoreData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStudentScores');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentScores');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }

            /**
            * 上堂紀錄
            * ===== Optional =====
            * @param {Number} filter_page - start from 0
            * @param {Number} filter_limit
            * @param {Array<{key: string, value: any}>} filter_item
            * filter_item key:
            * - 'date': string
            */
            this.GetStudentAttendances = async function (student_id, filters) {
                try {
                    const filterItems = [
                        ...filters['filter_item'],
                        { key: 'student_id', value: student_id }
                    ];
                    delete filters['filter_item'];

                    const payload = {
                        data_type: 'lesson_data',
                        filter_item: filterItems,
                        order_by: 'date',
                        sort_dir: 'desc',
                        ...filters
                    };
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(el => parseStudentAttendanceData(el, student_id));
                        console.log("formattedData : ")
                        console.log(formattedData)
                        let tutor_id_list = [];
                        for(let i=0; i<formattedData.length; i++){
                          if(formattedData[i].staff_list != undefined && formattedData[i].staff_list != null && formattedData[i].staff_list != "" && formattedData[i].staff_list.length > 0){
                            for(let j=0; j<formattedData[i].staff_list.length; j++){
                              if(!tutor_id_list.includes(formattedData[i].staff_list[j])){
                                tutor_id_list.push(formattedData[i].staff_list[j])
                              }
                            }
                          }
                        }
                        const tutor_payload = {
                            data_type: 'staff_data',
                            id_list: tutor_id_list,
                        };
                        const tutor_data = await Vue.prototype.$XHR.api('get_data_by_id_list', tutor_payload);
                        const staffById = new Map(tutor_data.map(s => [s.id, s]));

                        const formattedDataWithTutors = formattedData.map(item => {
                          // if staff_list empty, fallback to staff_id
                          const ids = item.staff_list.length ? item.staff_list : [item.staff_id];

                          return {
                            ...item,
                            tutor_name: (ids
                              .map(id => staffById.get(id))
                              .filter(Boolean) || [])
                              .map(s => s.name)
                              .filter(Boolean)
                              .join(', '),
                            staff_datas: ids
                              .map(id => staffById.get(id))
                              .filter(Boolean)
                          };
                        });

                        const returnedData = {
                            data: formattedDataWithTutors,
                            total: data['total'],
                            attend: formattedData.filter(el => el.attend_status === 'attend').length,
                            absent: formattedData.filter(el => el.attend_status === 'absent' || el.attend_status === 'sick_leave' || el.attend_status === 'await').length,
                            pending: formattedData.filter(el => el.attend_status === 'pending').length,
                        };
                        devLog('----------> XHR [SUCCESS]: GetStudentAttendances');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentAttendances');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }

            /**
            * 積分紀錄
            */
            this.GetUserPoints = async function (student_id) {
                try {
                    const payload = {
                        student_id
                    };
                    const data = await Vue.prototype.$XHR.api('get_user_points', payload);
                    const canUse = data['total'] - data['used'] - data['hold'];
                    return Promise.resolve(canUse);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserPoints');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }
            this.GetUserPointsRecords = async function (student_id, filters = {}) {
                try {
                    const payload = {
                        student_id,
                        order_by: 'create_date',
                        ...filters
                    };
                    const data = await Vue.prototype.$XHR.api('point_record', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parsePointsRecordData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetUserPointsRecords');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserPointsRecords');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetUserPointsRecordWithinDays = async function (student_id) {
                try {
                    const payload = {
                        student_id
                    };
                    const data = await Vue.prototype.$XHR.api('point_sixty', payload);
                    if (DataValid(data, true)) {
                        devLog('----------> XHR [SUCCESS]: GetUserPointsRecordWithinDays');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetUserPointsRecordWithinDays');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            /**
             * ==== Required ====
             * @param {Number} value
             * @param {Number} staff_id
             * ==== Optional ====
             * @param {String} remark
             */
            this.AddPoints = async function (student_id, payload) {
                try {
                    const uploaded = {
                        student_id,
                        type: 'admin',
                        order_id: -1,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('new_points', uploaded);
                    devLog('----------> XHR [SUCCESS]: AddPoints');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddPoints');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Required ====
             * @param {Number} value
             * @param {Number} staff_id
             * ==== Optional ====
             * @param {String} remark
             */
            this.DeductPoints = async function (student_id, payload) {
                try {
                    const uploaded = {
                        student_id,
                        type: 'admin',
                        order_id: -1,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('use_points', uploaded);
                    devLog('----------> XHR [SUCCESS]: DeductPoints');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeductPoints');
                    devLog(res);
                    switch (res.data) {
                        case 'not enough points':
                            return Promise.reject('message.userPointsNotEnough');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            /**
             * 新增課室
             * ==== Required ====
             * @param {String} name 
             * @param {Number} center - center id
             */
            this.NewClassroom = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, CLASSROOM_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_facility', uploaded);
                    const formattedData = parseClassroomData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewClassroom');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewClassroom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateClassroom = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, CLASSROOM_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_facility', payload);
                    const formattedData = parseClassroomData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateClassroom');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateClassroom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteClassroom = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_facility', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteClassroom');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteClassroom');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetClassrooms = async function (filters = {}) {
                try {
                    const joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const payload = {
                        data_type: 'facility_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let schoolData = [];
                        if (joinSchoolData) {
                            const idList = mapIds(data['data'], CLASSROOM_MODEL.school_id);
                            schoolData = await vm.GetSchoolsByIdList(idList);
                        }

                        const formattedData = data['data'].map(el => parseClassroomData(el, schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetClassrooms');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetClassrooms');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetClassroomById = async function (id) {
                try {
                    const payload = {
                        data_type: 'facility_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseClassroomData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetClassroomById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'noData';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetClassroomById');
                    devLog(res);
                    if (res && (res === 'abort' || res.data === 'abort')) {
                        return Promise.reject(displayError(res));
                    } else {
                        return Promise.reject('noData');
                    }
                }
            }





            /**
             * 新增課程分類
             * ==== Required ====
             * @param {String} name 
             */
            this.NewCourseCategory = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, COURSE_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_course_category', uploaded);
                    const formattedData = parseCourseCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewCourseCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCourseCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'category_code exist':
                            return Promise.reject('message.courseCategoryCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateCourseCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, COURSE_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_course_category', payload);
                    const formattedData = parseCourseCategoryData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCourseCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCourseCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteCourseCategory = async function (id, gEnableAutoGenCourse = false) {
                let result = ''
                let relatedCourseIds = [];
                try {
                    if (gEnableAutoGenCourse) {
                        const { data: courses } = await vm.GetCourses({
                            filter_item: [{ key: 'course_category_id', value: id }]
                        })
                        // avoid backend no function
                        const filteredCourses = courses.filter(el => el.category_id === id);
                        relatedCourseIds = filteredCourses.map(el => el.id);
                    }
                } catch { }

                try {
                    if (gEnableAutoGenCourse) { // reject if category has lessons
                        if (relatedCourseIds.length > 0) {
                            const { data: lessons } = await vm.GetLessons({
                                filter_page: 0,
                                filter_limit: 1,
                                filter_item: [{ key: 'course_id_list', value: relatedCourseIds }],
                            })
                            if (relatedCourseIds.includes(lessons[0].course_id)) {
                                result = 'message.courseDeleteNotAllowed';
                            }
                        }
                    } else { // reject if category has course
                        const { data: courses } = await vm.GetCourses({
                            filter_page: 0,
                            filter_limit: 1,
                            filter_item: [{ key: 'course_category_id', value: id }]
                        })
                        if (courses[0].category_id === id) {
                            result = 'message.categoryDeleteNotAllowed';
                        }
                    }
                } catch { }

                try {
                    if (DataValid(result)) throw result;

                    await Vue.prototype.$XHR.api('delete_course_category', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteCourseCategory');
                    devLog(relatedCourseIds);
                    return Promise.resolve(relatedCourseIds);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteCourseCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetCourseCategories = async function (filters = {}) {
                try {
                    let joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const payload = {
                        data_type: 'course_category_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const schoolData = joinSchoolData ? await GetAllSchools() : [];
                        const formattedData = data['data'].map(el => parseCourseCategoryData(el, schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetCourseCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseCategories');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetCourseCategoriesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'course_category_data',
                            id_list: id_list,
                            ...filters
                        };

                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            const formattedData = data.map(el => parseCourseCategoryData(el));
                            devLog('----------> XHR [SUCCESS]: GetCourseCategoriesByIdList');
                            devLog(formattedData);
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseCategoriesByIdList');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject(res);
                    } else {
                        return Promise.resolve([]);
                    }
                }
            }
            this.GetCourseCategoryById = async function (id) {
                try {
                    const payload = {
                        data_type: 'course_category_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseCourseCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetCourseCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增課程
             * ==== Required ====
             * @param {String} name 
             */
            this.NewCourse = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, COURSE_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_course', uploaded);
                    const formattedData = parseCourseData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewCourse');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCourse');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateCourse = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, COURSE_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_course', payload);
                    const formattedData = parseCourseData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCourse');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCourse');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteCourse = async function (id, check = false) {
                let pass = true;
                if (check) { // reject if course has lesson
                    try {
                        const { data: lessons } = await vm.GetLessons({
                            filter_page: 0,
                            filter_limit: 1,
                            filter_item: [{ key: 'course_id', value: id }],
                        });
                        if (lessons[0].course_id === id) {
                            pass = false;
                        }
                    } catch { }
                }

                try {
                    if (!pass) throw 'message.courseDeleteNotAllowed';

                    await Vue.prototype.$XHR.api('delete_course', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteCourse');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteCourse');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetCourses = async function (filters = {}) {
                try {
                    const joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const joinCategoryData = filters['join_category_data'] || false;
                    if (filters['join_category_data'] !== undefined) delete filters['join_category_data'];

                    const payload = {
                        data_type: 'course_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let categoryData = [];
                        if (joinCategoryData) {
                            const idList = mapIds(data['data'], COURSE_MODEL.category_id);
                            categoryData = await vm.GetCourseCategoriesByIdList(idList);
                        }

                        const schoolData = joinSchoolData ? await GetAllSchools() : [];
                        const formattedData = data['data'].map(el => parseCourseData(el, schoolData, categoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetCourses');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourses');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            const GetCourseByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'course_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data)) {
                            const formattedData = data.map(el => parseCourseData(el));
                            devLog('----------> XHR [SUCCESS]: GetCourseByIdList');
                            devLog(formattedData);
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetCourseById = async function (id) {
                try {
                    const payload = {
                        data_type: 'course_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseCourseData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetCourseById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetAllCourseNames = async function (center_id = -1, regular_only = false) {
                try {
                    let payload = {};
                    if (center_id > -1) {
                        payload['center_id'] = center_id
                    }
                    const options = [];
                    const regulars = await GetActiveRegulars(payload);
                    for (let i = 0; i < regulars.length; i++) {
                        const name = regulars[i].course_name.trim();
                        const found = options.find(el => el.value === name);
                        if (!found) {
                            options.push({ value: name, text: name, lesson_type: ['regular'] });
                        }
                    }

                    if (!regular_only) {
                        const lessons = await GetSingleLessons(payload);
                        for (let i = 0; i < lessons.length; i++) {
                            const name = lessons[i].course_name.trim();
                            const found = options.find(el => el.value === name);
                            if (!found) {
                                options.push({ value: name, text: name, lesson_type: ['single'] });
                            } else {
                                found.lesson_type.push('single');
                            }
                        }
                    }

                    options.sort((a, b) => {
                        if (a.text < b.text) return -1
                        if (a.text > b.text) return 1
                        return 0
                    })

                    devLog('----------> XHR [SUCCESS]: GetAllCourseNames');
                    devLog(options)
                    return Promise.resolve(options);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetAllCourseNames');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            const GetActiveRegulars = async function (filters = {}) {
                try {
                    const payload = {
                        ...filters
                    };
                    const data = await Vue.prototype.$XHR.api('regular_options', payload);
                    if (DataValid(data, true)) {
                        const formattedData = [];
                        for (let i = 0; i < data.length; i++) {
                            const item = data[i];
                            formattedData.push({
                                id: item.id,
                                course_name: item[CLASS_MODEL.course_name],
                            });
                        }

                        devLog('----------> XHR [SUCCESS]: GetActiveRegulars');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    } else {
                        return Promise.resolve([]);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetActiveRegulars');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject(res);
                    }
                }

                try {
                    const data = await GetRegularCourses(filters);
                    return Promise.resolve(data);
                } catch (res) {
                    return Promise.reject(res);
                }
            }
            const GetRegularCourses = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'regular_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let formattedData = [];
                        if (isAppMode(['T01'])) {
                            formattedData = await CheckRegularCourseLessonByCourseCodes(data['data']);
                        } else {
                            for (let i = 0; i < data['data'].length; i++) {
                                const item = data['data'][i];
                                const hasLesson = await CheckRegularCourseLesson(item[CLASS_MODEL.course_code]);
                                if (hasLesson) {
                                    formattedData.push({
                                        id: item.id,
                                        course_name: item[CLASS_MODEL.course_name],
                                    });
                                }
                            }
                        }

                        devLog('----------> XHR [SUCCESS]: GetRegularCourses');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetRegularCourses');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject(res);
                    } else {
                        return Promise.resolve([]);
                    }
                }
            }
            const CheckRegularCourseLesson = async function (course_code) {
                try {
                    const payload = {
                        data_type: 'lesson_data',
                        filter_page: 0,
                        filter_limit: 1,
                        filter_item: [{ key: 'course_code', value: course_code }]
                    };
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: CheckRegularCourseLesson');
                        devLog(data);
                        if (data['data'][0].course_data && data['data'][0].course_data.active) {
                            return Promise.resolve(true);
                        }
                    }
                    throw false;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CheckRegularCourseLesson');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject(res);
                    } else {
                        return Promise.resolve(false);
                    }

                }
            }
            const CheckRegularCourseLessonByCourseCodes = async function (regular_data) {
                try {
                    const courseCodes = regular_data.map(el => el[CLASS_MODEL.course_code]);
                    const payload = {
                        data_type: 'lesson_data',
                        filter_item: [{ key: 'course_code_list', value: courseCodes }]
                    };
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: CheckRegularCourseLessonByCourseCodes');
                        devLog(data);
                        const formattedData = [];
                        for (let i = 0; i < regular_data.length; i++) {
                            const found = data['data'].find(el => el[LESSON_MODEL.course_code] === regular_data[i][CLASS_MODEL.course_code]);
                            if (found && found.course_data && found.course_data.active) {
                                formattedData.push({
                                    id: regular_data[i].id,
                                    course_name: regular_data[i][CLASS_MODEL.course_name]
                                })
                            }
                        }

                        if (formattedData.length > 0) {
                            return Promise.resolve(formattedData);
                        }
                    }
                    throw false;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CheckRegularCourseLessonByCourseCodes');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject(res);
                    } else {
                        return Promise.resolve(false);
                    }

                }
            }
            const GetSingleLessons = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'lesson_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    if (!payload['filter_item']) {
                        payload['filter_item'] = []
                    }
                    payload['filter_item'].push({ key: 'lesson_type', value: 'single' });
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const formattedData = [];
                        data['data'].forEach(item => {
                            if (item.course_data && item.course_data.active) {
                                formattedData.push({
                                    id: item.id,
                                    course_name: item[LESSON_MODEL.course_name],
                                });
                            }
                        });
                        devLog('----------> XHR [SUCCESS]: GetSingleLessons');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSingleLessons');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }





            /**
             * 新增商品分類
             * ==== Required ====
             * @param {String} name 
             */
            this.NewProductCategory = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PRODUCT_CATEGORY_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_category', uploaded);
                    const formattedData = parseProductCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewProductCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateProductCategory = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PRODUCT_CATEGORY_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_category', payload);
                    const formattedData = parseProductCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateProductCategory');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteProductCategory = async function (id, check = false) {
                try {
                    await Vue.prototype.$XHR.api('delete_category', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteProductCategory');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteProductCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetProductCategories = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'category_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(parseProductCategoryData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetProductCategories');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategories');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetProductCategoriesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'category_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data)) {
                            const formattedData = data.map(parseProductCategoryData);
                            devLog('----------> XHR [SUCCESS]: GetProductCategoriesByIdList');
                            devLog(formattedData);
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetProductCategoryById = async function (id) {
                try {
                    const payload = {
                        data_type: 'category_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseProductCategoryData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetProductCategoryById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 新增商品
             * ==== Required ====
             * @param {String} name 
             */
            this.NewProduct = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PRODUCT_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_product', uploaded);
                    const formattedData = parseProductData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewProduct');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateProduct = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PRODUCT_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('edit_product', payload);
                    const formattedData = parseProductData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateProduct');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteProduct = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_product', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteProduct');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteProduct');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetProducts = async function (filters = {}) {
                try {
                    const joinCategoryData = filters['join_category_data'] || false;
                    if (filters['join_category_data'] !== undefined) delete filters['join_category_data'];

                    const payload = {
                        data_type: 'product_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let categoryData = [];
                        if (joinCategoryData) {
                            const idList = mapIds(data['data'], PRODUCT_MODEL.category_id);
                            categoryData = await this.GetProductCategoriesByIdList(idList);
                        }

                        const formattedData = data['data'].map(el => parseProductData(el, categoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetProducts');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProducts');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetProductById = async function (id, filters = {}) {
                try {
                    const payload = {
                        ...filters,
                        data_type: 'product_data',
                        id,
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseProductData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetProductById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetProductSale = async function (id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_product_sales', { product_id: id });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetProductSale');
                        let count = 0;
                        data.forEach(order => {
                            const found = order.product_id_list.find(el => el.id === id);
                            if (found) {
                                count += found.amount
                                if (order.status === 'debit') {
                                    const refund = order.debit_product_ids ? order.debit_product_ids.find(el => el.id === id) : null;
                                    if (refund) {
                                        count -= refund.amount;
                                    }
                                } else if (order.status === 'void') {
                                    count -= found.amount;
                                }
                            }
                        })
                        return Promise.resolve(count);
                    }

                    throw 0;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductSale');
                    devLog(res);
                    return Promise.resolve(0);
                }
            }

            /**
             * ==== Required ====
             * @param {Number} product_id 
             * @param {Number} cost 
             * @param {Number} amount 
             * @param {String} date - [YYYY-MM-DD]T[HH:MM:SS]Z 
             */
            this.AddProductStock = async function (payload) {
                try {
                    const uploaded = {
                        ...payload,
                        type: 'add_stock'
                    }
                    const data = await Vue.prototype.$XHR.api('add_product_stock', uploaded);
                    devLog('----------> XHR [SUCCESS]: AddProductStock');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddProductStock');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ReduceProductStock = async function (payload) {
                try {
                    const uploaded = {
                        ...payload,
                        type: 'export_stock'
                    }
                    const data = await Vue.prototype.$XHR.api('reduce_product_stock', uploaded);
                    devLog('----------> XHR [SUCCESS]: ReduceProductStock');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ReduceProductStock');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetProductStocks = async function (filters = {}) {
                const joinStaffData = filters['join_staff_data'] || false;
                if (filters['join_staff_data'] !== undefined) delete filters['join_staff_data'];
                try {
                    const payload = {
                        data_type: 'stock_data',
                        order_by: 'date',
                        sort_dir: 'desc',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let formattedData = [...data['data']];
                        let staffData = [];
                        if (joinStaffData) {
                            const d = formattedData.filter(el => el.type === 'add_stock' || el.type === 'export_stock');
                            const staffIds = mapIds(d, 'curr_staff');
                            if (staffIds.length) {
                                staffData = await vm.GetStaffsByIdList(staffIds);
                                for (let i = 0; i < formattedData.length; i++) {
                                    if (DataValid(formattedData[i].curr_staff) && (formattedData[i].type === 'add_stock' || formattedData[i].type === 'export_stock')) {
                                        const found = staffData.find(el => el.id === formattedData[i].curr_staff);
                                        if (found) formattedData[i].staff_name = found.username;
                                    }
                                }
                            }
                        }
                        devLog('----------> XHR [SUCCESS]: GetProductStocks');
                        devLog(data)
                        return Promise.resolve(data);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetProductStocks');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }





            /**
             * 新增課程時間表 (New Lesson)
             * Single
             */
            this.NewSingleDateLesson = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, CLASS_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_lesson', uploaded);
                    const formattedData = parseLessonData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewSingleDateLesson');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewSingleDateLesson');
                    devLog(res);
                    switch (res.data) {
                        case 'course_code exist':
                            return Promise.reject('message.courseCodeExist');
                        case 'cannot create lesson on holiday':
                            return Promise.reject('message.isHolidayLesson');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
            * 新增課程時間表 (New Lesson)
            * Regular
            */
            this.NewRegularLesson = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, CLASS_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_regular', uploaded);
                    devLog('----------> XHR [SUCCESS]: NewRegularLesson');
                    devLog(data);
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewRegularLesson');
                    devLog(res);
                    switch (res.data) {
                        case 'course_code exist':
                            return Promise.reject('message.courseCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateLesson = async function (id, update) {
                try {
                    let temp_payload = JSON.parse(JSON.stringify(update));
                    if (temp_payload['dropped_student_ids'] !== undefined) {
                        delete temp_payload['dropped_student_ids'];
                    }
                    if (temp_payload['attendance_list'] !== undefined || temp_payload['tutor_attendance'] !== undefined) {
                        const get_lesson = await vm.GetLessonById(id);
                        if (temp_payload['attendance_list'] !== undefined) {
                            const attendanceList = JSON.parse(JSON.stringify(get_lesson['raw_attendance_list']));
                            const updatedStudentIds = [];
                            for (let i = (attendanceList.length - 1); i >= 0; i--) {
                                if (!updatedStudentIds.includes(attendanceList[i].student_id)) {
                                    const found = temp_payload['attendance_list'].find(el => el.student_id === attendanceList[i].student_id);
                                    if (found && found.status !== attendanceList[i].status) {
                                        attendanceList[i].status = found.status;
                                        // 出席時間
                                        if (found.status === 'attend') {
                                            attendanceList[i].attend_datetime = await Vue.prototype.$XHR.serverTime();
                                        }
                                    }
                                    updatedStudentIds.push(attendanceList[i].student_id);
                                }
                            }
                            temp_payload['attendance_list'] = attendanceList;
                        }

                        if (temp_payload['tutor_attendance'] !== undefined) {
                            const tutorAttendanceList = JSON.parse(JSON.stringify(get_lesson['tutor_attendance']));
                            const updatedTutorIds = [];
                            for (let i = (tutorAttendanceList.length - 1); i >= 0; i--) {
                                if (!updatedTutorIds.includes(tutorAttendanceList[i].staff_id)) {
                                    const found = temp_payload['tutor_attendance'].find(el => el.staff_id === tutorAttendanceList[i].staff_id);
                                    if (found && found.status !== tutorAttendanceList[i].status) {
                                        tutorAttendanceList[i].status = found.status;
                                        // 出席時間
                                        if (found.status === 'attend') {
                                            if (!found.attend_time) {
                                                tutorAttendanceList[i].attend_time = await Vue.prototype.$XHR.serverTime();
                                            } else {
                                                tutorAttendanceList[i].attend_time = found.attend_time
                                            }
                                        } else {
                                            tutorAttendanceList[i].attend_time = '';
                                        }
                                    }

                                    updatedTutorIds.push(tutorAttendanceList[i].staff_id);
                                }
                            }
                            const newTutors = temp_payload['tutor_attendance'].filter(el => !updatedTutorIds.includes(el.staff_id));
                            for (let i = 0; i < newTutors.length; i++) {
                                let obj = {
                                    staff_id: newTutors[i].staff_id,
                                    status: newTutors[i].status,
                                }
                                if (obj.status === 'attend') {
                                    if (newTutors[i].attend_time) {
                                        obj['attend_time'] = newTutors[i].attend_time
                                    } else {
                                        obj['attend_time'] = await Vue.prototype.$XHR.serverTime();
                                    }
                                }
                                tutorAttendanceList.push(obj)
                            }
                            temp_payload['tutor_attendance'] = tutorAttendanceList;
                        }
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(temp_payload, LESSON_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    // console.log("UpdateLesson")
                    // console.log(payload)
                    // return Promise.reject(displayError(res));

                    const data = await Vue.prototype.$XHR.api('edit_lesson', payload);
                    const formattedData = parseLessonData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateLesson');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateLesson');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * 會update曬所有相關lesson嘅setting
             * ===== Required =====
             * @param {String} course_code
             * @param {String} date - update all lessons after this date
             */
            this.UpdateLessonSetting = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, CLASS_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    await Vue.prototype.$XHR.api('edit_lesson_after', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateLessonSetting');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateLessonSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateRegularSetting = async function (id, update) {
                try {
                    const u = JSON.parse(JSON.stringify(update));
                    const formattedPayload = convertCMSKeyToBackendKey(u, CLASS_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }
                    await Vue.prototype.$XHR.api('edit_regular', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateRegularSetting');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateRegularSetting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteLesson = async function (id_list) {
                try {
                    const data = await Vue.prototype.$XHR.api('bulk_delete_lesson', { id_list });
                    if (DataValid(data)) {
                        let isError = false;
                        if (Array.isArray(data)) {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].info === 'not all pending' || data[i].info === 'paid lesson') {
                                    isError = true;
                                    break;
                                }
                            }
                        }

                        if (isError) {
                            devLog('----------> XHR [CHECK FAIL]: DeleteLesson');
                            return Promise.reject(data);
                        } else {
                            devLog('----------> XHR [SUCCESS]: DeleteLesson');
                            return Promise.resolve(data);
                        }
                    } else {
                        devLog('----------> XHR [NULL]: DeleteLesson');
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteLesson');
                    devLog(res);

                    const error = await handleParseError(res.data);
                    if (DataValid(error) && Array.isArray(error)) {
                        return Promise.reject(error);
                    } else {
                        return Promise.reject(displayError(res));
                    }
                }
            }
            /**
            * @param {Number} filter_page - used with `filter_limit`
            * @param {Number} filter_limit - used with `filter_page`
            * @param {String} sort_dir - 'desc' | 'asc'
            * @param {String} order_by
            * @param {Number} center_id
            * @param {Array<key: string, value: any>} filter_item
            * @param {String} get_from - return `from_lesson_status` check 是否由另一堂skip過黎
            * @param {String} get_order - used with filter_item (student_id) return `order_data` get lesson order id
            * @param {String} get_package_sort - 攞student該堂用package第幾個quota
            */
            this.GetLessons = async function (filters = {}) {
                const joinTutorData = filters['join_tutor_data'] || false;
                if (filters['join_tutor_data'] !== undefined) delete filters['join_tutor_data'];

                const joinStudentData = filters['join_student_data'] || false;
                if (filters['join_student_data'] !== undefined) delete filters['join_student_data'];

                const joinStudentLastLesson = filters['join_student_last_lesson'] || false;
                if (filters['join_student_last_lesson'] !== undefined) delete filters['join_student_last_lesson'];

                const localSorting = filters['local_sort'] || false;
                if (filters['local_sort'] !== undefined) delete filters['local_sort'];

                const payload = {
                    data_type: 'lesson_data',
                    ...filters
                };

                console.log("joinTutorData : ",joinTutorData);
                if (!localSorting) {
                    payload['order_by'] = 'date';
                    payload['sort_dir'] = 'asc';
                }
                if (payload['filter_item'] && payload['filter_item'].length < 1) {
                    delete payload['filter_item'];
                }

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let sortedData = data['data'];
                        if (localSorting) {
                            sortedData = data['data'].sort((a, b) => Formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`));
                        }
                        let tutorData = [];
                        console.log("joinTutorData : ",joinTutorData);
                        if (joinTutorData === true) {
                            let idList = [];
                            for (let i = 0; i < sortedData.length; i++) {
                                if (!isAppMode(['T01']) && DataValid(sortedData[i][LESSON_MODEL.tutor_id_list], true)) {
                                    idList = idList.concat(sortedData[i][LESSON_MODEL.tutor_id_list]);
                                } else if (DataValid(sortedData[i][LESSON_MODEL.tutor_id]) && sortedData[i][LESSON_MODEL.tutor_id] > -1) {
                                    idList.push(sortedData[i][LESSON_MODEL.tutor_id]);
                                }
                            }
                            idList = mapIds(idList);
                            tutorData = await vm.GetStaffsByIdList(idList);
                        }
                        console.log(tutorData);

                        let studentData = [];
                        if (joinStudentData === true) {
                            const idList = [];
                            sortedData.forEach(el => {
                                if (DataValid(el.students)) {
                                    el.students.forEach(student_id => {
                                        if (!idList.includes(student_id)) {
                                            idList.push(student_id);
                                        }
                                    })
                                }
                            })

                            if (joinStudentLastLesson) {
                                studentData = await GetStudentsWithLastLessonByIdList(idList);
                            } else {
                                studentData = await vm.GetStudentsByIdList(idList);
                            }
                        }

                        const formattedData = sortedData.map(el => parseLessonData(el, tutorData, studentData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetLessons');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessons');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetLessonsByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const joinTutorData = filters['join_tutor_data'] || false;
                        if (filters['join_tutor_data'] !== undefined) delete filters['join_tutor_data'];

                        const joinStudentData = filters['join_student_data'] || false;
                        if (filters['join_student_data'] !== undefined) delete filters['join_student_data'];

                        const joinStudentLastLesson = filters['join_student_last_lesson'] || false;
                        if (filters['join_student_last_lesson'] !== undefined) delete filters['join_student_last_lesson'];

                        const payload = {
                            data_type: 'lesson_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            let tutorData = [];
                            if (joinTutorData === true) {
                                let idList = [];
                                for (let i = 0; i < data.length; i++) {
                                    if (!isAppMode(['T01']) && DataValid(data[i][LESSON_MODEL.tutor_id_list], true)) {
                                        idList = idList.concat(data[i][LESSON_MODEL.tutor_id_list]);
                                    } else if (DataValid(data[i][LESSON_MODEL.tutor_id]) && data[i][LESSON_MODEL.tutor_id] > -1) {
                                        idList.push(data[i][LESSON_MODEL.tutor_id]);
                                    }
                                }
                                idList = mapIds(idList);
                                tutorData = await vm.GetStaffsByIdList(idList);
                            }

                            let studentData = [];
                            if (joinStudentData === true) {
                                const idList = [];
                                data.forEach(el => {
                                    if (DataValid(el.students)) {
                                        el.students.forEach(student_id => {
                                            if (!idList.includes(student_id)) {
                                                idList.push(student_id);
                                            }
                                        })
                                    }
                                })

                                if (joinStudentLastLesson) {
                                    studentData = await GetStudentsWithLastLessonByIdList(idList);
                                } else {
                                    studentData = await vm.GetStudentsByIdList(idList);
                                }
                            }

                            const formattedData = data.map(el => parseLessonData(el, tutorData, studentData));
                            devLog('----------> XHR [SUCCESS]: GetLessonsByIdList');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessonsByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            const GetLessonByCourseCode = async function (code) {
                const payload = {
                    data_type: 'lesson_data',
                    filter_page: 0,
                    filter_limit: 1,
                    filter_item: [{ key: 'course_code', value: code }]
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = parseLessonData(data['data'][0]);
                        devLog('----------> XHR [SUCCESS]: GetLessonByCourseCode: ' + code);
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessonByCourseCode: ' + code);
                    devLog(res);
                    return Promise.resolve(null);
                }
            }
            this.GetLessonById = async function (id, filters = {}) {
                try {
                    const joinStudentData = filters['join_student_data'] || false;
                    if (filters['join_student_data'] !== undefined) delete filters['join_student_data'];

                    const joinAttendanceData = filters['join_attendance_data'] || false;
                    if (filters['join_attendance_data'] !== undefined) delete filters['join_attendance_data'];

                    const joinStudentLastLesson = filters['join_student_last_lesson'] || false;
                    if (filters['join_student_last_lesson'] !== undefined) delete filters['join_student_last_lesson'];

                    const payload = {
                        data_type: 'lesson_data',
                        id: id
                    };

                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        let studentData = [];
                        if (joinStudentData && DataValid(data.students, true)) {
                            if (joinStudentLastLesson) {
                                studentData = await GetStudentsWithLastLessonByIdList(data.students);
                            } else {
                                studentData = await vm.GetStudentsByIdList(data.students);
                            }
                        }

                        let lessonData = [];
                        if (joinAttendanceData && DataValid(data.attendance, true)) {
                            const lessonIds = [];
                            const lessonCodes = [];
                            data.attendance.forEach(el => {
                                if (DataValid(el.from_lesson) && el.from_lesson > -1) {
                                    lessonIds.push(el.from_lesson);
                                } else if (DataValid(el.from_course) && el.from_course !== -1 && !lessonCodes.includes(el.from_course)) {
                                    lessonCodes.push(el.from_course);
                                }

                                // for skip
                                if (DataValid(el.to_lesson) && el.to_lesson > -1) {
                                    lessonIds.push(el.to_lesson);
                                }
                            })
                            lessonData = await vm.GetLessonsByIdList(lessonIds);
                            if (lessonCodes.length) {
                                for (let i = 0; i < lessonCodes.length; i++) {
                                    const lesson = await GetLessonByCourseCode(lessonCodes[i]);
                                    if (lesson) {
                                        lessonData.push(lesson);
                                    }
                                }
                            }
                        }
                        const formattedData = parseLessonData(data, [], studentData, lessonData);
                        devLog('----------> XHR [SUCCESS]: GetLessonById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'noData';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessonById');
                    devLog(res);
                    if (res && (res === 'abort' || res.data === 'abort')) {
                        return Promise.reject(displayError(res));
                    } else {
                        return Promise.reject('noData');
                    }
                }
            }
            this.GetPackageSort = async function (lessons = [], controller_name = '') {
                try {
                    const data = await Vue.prototype.$XHR.api('new_package_sort', { lessons, controller_name });
                    if (DataValid(data, true)) {
                        const list = [];
                        data.forEach(item => {
                            const obj = {
                                id: item.id,
                                attendance_list: []
                            }

                            item.package_sort.forEach(el => {
                                let packageSort = 0;
                                let totalPackageCount = 0;
                                if (DataValid(el.multiple_package_data, true)) {
                                    totalPackageCount = el.multiple_package_data.reduce((value, itemNode) => value + itemNode[PACKAGE_MODEL.lesson_count], 0);
                                } else if (DataValid(el.package_data)) {
                                    totalPackageCount = el.package_data[PACKAGE_MODEL.lesson_count];
                                }

                                if (DataValid(el.lesson_sort, true)) {
                                    const lessonPos = el.lesson_sort.findIndex(elm => elm.id === item.id);
                                    if (lessonPos > -1) {
                                        packageSort = lessonPos + 1;
                                    }
                                }

                                obj.attendance_list.push({
                                    student_id: el.student_id,
                                    package_quota_count: totalPackageCount ? `${packageSort}/${totalPackageCount}` : '',
                                })
                            })

                            list.push(obj);
                        })

                        devLog('----------> XHR [SUCCESS]: GetPackageSort');
                        devLog(list);
                        return Promise.resolve(list);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageSort');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject([]);
                    }
                }
            }
            /** 攞學生未paid又唔係用package assign嘅lessons */
            this.GetStudentUnpaidLessons = async function (student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('unpaid_lesson', { student_id });
                    if (DataValid(data, true)) {
                        // filter走skip咗嘅lesson
                        const filteredData = data.filter(el => !DataValid(el[LESSON_MODEL.dropped_student_ids]) || !el[LESSON_MODEL.dropped_student_ids].includes(student_id));
                        if (DataValid(filteredData)) {
                            const formattedData = filteredData.map(el => parseLessonData(el));
                            devLog('----------> XHR [SUCCESS]: GetStudentUnpaidLessons');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentUnpaidLessons');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            /**
             * ===== Required =====
             * @param {Number} student_id
             * @param {String} date - start date excluded
             * @param {Array<string>} course_codes
             * ===== Optional =====
             * @param {Array<lesson>} selected_first_lessons
             */
            this.GetPackageLessonsPreview = async function (filters = {}) {
                try {
                    const selectedFirstLessons = filters['selected_first_lessons'] || [];
                    if (filters['selected_first_lessons'] !== undefined) delete filters['selected_first_lessons'];

                    const maxCount = DataValid(filters['max_count']) ? filters['max_count'] : -1;

                    const data = await Vue.prototype.$XHR.api('get_package_lesson', filters);
                    if (DataValid(data, true)) {
                        let formattedData = data.map(el => parseLessonData(el));
                        let tempData = [];
                        devLog('----------> XHR [SUCCESS]: GetPackageLessonsPreview');
                        if (DataValid(selectedFirstLessons, true)) {
                            selectedFirstLessons.forEach(item => {
                                const aDate = Formatter.convertDate(item.date, item.start_time);
                                formattedData.forEach(el => {
                                    if (el.course_code === item.course_code) {
                                        const bDate = Formatter.convertDate(el.date, el.start_time);
                                        if (item.date === el.date && item.start_time === el.start_time || bDate.getTime() >= aDate.getTime()) {
                                            tempData.push(el);
                                        }
                                    }
                                })
                            })
                        } else {
                            tempData = formattedData;
                        }
                        tempData.sort((a, b) => Formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`));

                        if (maxCount === 0) {
                            tempData = [];
                        } else if (maxCount > -1) {
                            tempData = tempData.slice(0, maxCount);
                        }
                        devLog(tempData)
                        return Promise.resolve(tempData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageLessonsPreview');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.resolve([]);
                    }
                }
            }

            /**
             * ======== Required ========
             * Case 1: 新增堂數
             * @param {Number} days
             * Case 2: 課程結束日
             * @param {String} end_date
             * Case 3: 自選日期及時間
             * @param {String} date
             * @param {String} start_time
             * @param {String} end_time
             */
            this.ExtendRegularLesson = async function (regular_id, update = {}) {
                try {
                    let payload = {
                        regular_id,
                        ...update
                    };

                    if (payload["end_date"] !== undefined) {
                        payload["days"] = 0;
                    }
                    const data = await Vue.prototype.$XHR.api('extend_regular', payload);
                    devLog('----------> XHR [SUCCESS]: ExtendRegularLesson');
                    const formattedData = [];
                    data.forEach(item => {
                        if (item && typeof item !== 'string' && DataValid(item.id)) {
                            formattedData.push(parseLessonData(item));
                        }
                    })
                    devLog(formattedData);
                    return Promise.resolve(formattedData);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExtendRegularLesson');
                    devLog(res);
                    switch (res.data) {
                        case 'cannot create lesson on holiday':
                            return Promise.reject('message.isHolidayLesson');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.RemoveStudentFromDropList = async function (lesson_id, student_id) {
                try {
                    const get_lesson = await vm.GetLessonById(lesson_id);
                    let dropList = JSON.parse(JSON.stringify(get_lesson['dropped_student_ids']));
                    if (dropList.includes(student_id)) {
                        dropList = dropList.filter(el => el !== student_id);

                        const update = {
                            dropped_student_ids: dropList
                        };
                        const formattedPayload = convertCMSKeyToBackendKey(update, LESSON_MODEL);
                        const payload = {
                            id: lesson_id,
                            ...formattedPayload
                        }
                        console.log("RemoveStudentFromDropList")
                        console.log(payload)
                        return Promise.reject(displayError(res));
                        // await Vue.prototype.$XHR.api('edit_lesson', payload);
                        devLog('----------> XHR [SUCCESS]: RemoveStudentFromDropList');
                    } else {
                        devLog('----------> XHR [SUCCESS UNCHANGED]: RemoveStudentFromDropList');
                    }
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RemoveStudentFromDropList');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.AddStudentToLessonWithPackage = async function (lesson_ids, student_id) {
                try {
                    const payload = {
                        student_id,
                        lesson_id_list: lesson_ids
                    }
                    await Vue.prototype.$XHR.api('assign_lesson', payload);
                    devLog('----------> XHR [SUCCESS]: AddStudentToLessonWithPackage');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddStudentToLessonWithPackage');
                    devLog(res);
                    switch (res.data) {
                        case 'lesson not enough':
                            return Promise.reject('message.noMorePackageQuota');
                        case 'student in lesson':
                            return Promise.reject('message.studentInLesson');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.AddStudentToLesson = async function (lesson_id, student_id) {
                try {
                    const payload = {
                        student_id,
                        id: lesson_id
                    }
                    await Vue.prototype.$XHR.api('add_student_to_lesson', payload);
                    devLog('----------> XHR [SUCCESS]: AddStudentToLesson');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddStudentToLesson');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.AddStudentToLessonWithMonthPass = async function (student_id, lesson_ids) {
                try {
                    const payload = {
                        student_id,
                        lesson_id_list: lesson_ids
                    }

                    await Vue.prototype.$XHR.api('assign_multi_monthly_lesson', payload);
                    devLog('----------> XHR [SUCCESS]: AddStudentToLessonWithMonthPass');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: AddStudentToLessonWithMonthPass');
                    devLog(res);
                    switch (res.data) {
                        case 'lesson not enough':
                            return Promise.reject('message.noMorePackageQuota');
                        case 'student in lesson':
                            return Promise.reject('message.studentInLesson');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.PaidStudentLessonWithPackage = async function (lesson_id, student_id) {
                try {
                    const payload = {
                        student_id,
                        lesson_id
                    }
                    await Vue.prototype.$XHR.api('assign_lesson_to_package', payload);
                    devLog('----------> XHR [SUCCESS]: PaidStudentLessonWithPackage');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: PaidStudentLessonWithPackage');
                    devLog(res);
                    switch (res.data) {
                        case 'lesson get fail':
                            return Promise.reject('message.courseNotFound');
                        case 'student paid':
                            return Promise.reject('message.alreadyPaid');
                        case 'student already using package':
                            return Promise.reject('message.usedPackage');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.SkipLesson = async function (lesson_id, student_id) {
                try {
                    await Vue.prototype.$XHR.api('skip_lesson', {
                        from_id: lesson_id,
                        student_id
                    });
                    devLog('----------> XHR [SUCCESS]: SkipLesson');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: SkipLesson');
                    devLog(res);
                    switch (res.data) {
                        case 'from missing':
                            return Promise.reject('message.lessonNotFound');
                        case 'student not in lesson':
                            return Promise.reject('message.studentNotInLesson');
                        case 'student attendance not pending':
                            return Promise.reject('message.lessonCannotSkip');
                        case 'student not paid':
                            return Promise.reject('message.disableSkipIfUnpaid');
                        case 'target lesson already in order':
                            return Promise.reject('message.lessonInOrder');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.SkipLessonPre = async function (lesson_id, student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('pre_skip_lesson', {
                        from_id: lesson_id,
                        student_id
                    });

                    devLog('----------> XHR [SUCCESS]: SkipLessonPre');
                    if (DataValid(data)) {
                        const toLesson = parseLessonData(data);
                        return Promise.resolve(toLesson);
                    }
                    return Promise.resolve(null);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: SkipLessonPre');
                    devLog(res);
                    switch (res.data) {
                        case 'from missing':
                            return Promise.reject('message.lessonNotFound');
                        case 'student not in lesson':
                            return Promise.reject('message.studentNotInLesson');
                        case 'student attendance not pending':
                            return Promise.reject('message.lessonCannotSkip');
                        case 'student not paid':
                            return Promise.reject('message.disableSkipIfUnpaid');
                        case 'to missing':
                            return Promise.reject('to missing');
                        default:
                            return Promise.resolve(null);
                    }
                }
            }
            this.SkipLessonByStudentIdList = async function (lesson_id, student_list) {
                try {
                    const data = await Vue.prototype.$XHR.api('multi_skip_lesson', {
                        from_id: lesson_id,
                        student_list
                    });

                    if (DataValid(data, true)) {
                        devLog('----------> XHR [SOME FAIL]: SkipLessonByStudentIdList');
                        return Promise.reject(data);
                    } else {
                        devLog('----------> XHR [SUCCESS]: SkipLessonByStudentIdList');
                        return Promise.resolve(true);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: SkipLessonByStudentIdList');
                    devLog(res);
                    switch (res.data) {
                        case 'from missing':
                            return Promise.reject('message.lessonNotFound');
                        case 'some student attendance not pending':
                            return Promise.reject('message.someoneLessonCannotSkip');
                        case 'some student not paid':
                            return Promise.reject('message.someoneDisableSkipIfUnpaid');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetSkipToLessons = async function (student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('get_skip_lesson', {
                        student_id
                    });
                    if (DataValid(data, true)) {
                        devLog('----------> XHR [SUCCESS]: GetSkipToLessons');
                        let formattedData = data.map(el => parseLessonData(el));
                        formattedData = formattedData.filter(el => DataValid(el));
                        formattedData.sort((a, b) => Formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`));
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetSkipToLessons');
                    devLog(res);
                    return Promise.reject([]);
                }
            }
            this.UndoSkip = async function (curr_id, back_id, student_id) {
                try {
                    await Vue.prototype.$XHR.api('undo_skip_lesson', {
                        curr_id,
                        back_id,
                        student_id
                    });

                    devLog('----------> XHR [SUCCESS]: UndoSwitch');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UndoSwitch');
                    devLog(res);
                    switch (res.data) {
                        case 'curr lesson missing':
                            return Promise.reject('message.skipToLessonNotFound');
                        case 'student not in lesson':
                            return Promise.reject('message.studentNotInLesson');
                        case "current lesson student attendance not pending":
                            return Promise.reject('message.lessonCannotUndoSkip');
                        case 'back lesson missing':
                            return Promise.reject('message.skipFromLessonNotFound');
                        case 'back lesson student attendance not skip':
                            return Promise.reject('message.lessonCannotUndoSkipBack');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
             * 轉堂(單一課堂)
             * @param {Number} student_id 
             * @param {Number} from_id - lesson id
             * @param {Number} to_id - lesson id
             */
            this.SwitchLesson = async function (student_id, from_id, to_id, with_package = false) {
                try {
                    const payload = {
                        student_id,
                        from_id,
                        to_id
                    };
                    if (with_package) {
                        await Vue.prototype.$XHR.api('switch_lesson_package', payload);
                    } else {
                        await Vue.prototype.$XHR.api('switch_lesson', payload);
                    }
                    devLog('----------> XHR [SUCCESS]: SwitchLesson');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: SwitchLesson');
                    devLog(res);
                    switch (res.data) {
                        case "lesson date not in monthly":
                        case "lesson date exceed days":
                            return Promise.reject('message.lessonNotInMonthPassRange');
                        case "order status not allow switch":
                            return Promise.reject('message.lessonUnpaidDisableSwitch');
                        case 'target lesson already in order':
                            return Promise.reject('message.lessonInOrder');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
            * 轉堂(揀一堂後，將未上果N堂都轉去依個course到)
            * @param {Number} student_id 
            * @param {Number} from_course_code - course id
            * @param {Number} to_course_code - course id
            * @param {String} start_date - 幾時開始轉
            */
            this.SwitchCourse = async function (student_id, from_course_code, to_course_code, start_date, target_date, with_package = false) {
                const payload = {
                    id: student_id,
                    from_course_code: from_course_code,
                    to_course_code: to_course_code,
                    start_date: start_date,
                    target_date:target_date
                };

                try {
                    if (with_package) {
                        await Vue.prototype.$XHR.api('switch_course_package', payload);
                    } else {
                        await Vue.prototype.$XHR.api('switch_course', payload);
                    }

                    devLog('----------> XHR [SUCCESS]: SwitchCourse');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: SwitchCourse');
                    devLog(res);
                    switch (res.data) {
                        case 'target course not enough lesson':
                        case 'target course has no lesson':
                            return Promise.reject('message.targetCourseNotEnoughLesson');
                        case "order status not allow switch":
                            return Promise.reject('message.lessonUnpaidDisableSwitch');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UndoSwitch = async function (lesson_id, student_id) {
                try {
                    await Vue.prototype.$XHR.api('undo_switch_lesson', {
                        lesson: lesson_id,
                        student_id
                    });

                    devLog('----------> XHR [SUCCESS]: UndoSwitch');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UndoSwitch');
                    devLog(res);
                    switch (res.data) {
                        case 'no switch record':
                            return Promise.reject('message.switchRecordNotFound');
                        case 'switch course not support yet':
                            return Promise.reject('message.undoSwitchCourseNotSupport');
                        case "order status not allow switch":
                            return Promise.reject('message.lessonUnpaidDisableSwitch');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
            * 退課
            * @param {Number} student_id 
            * @param {Number} from_course_code - course id
            * @param {String} start_date - 幾時開始轉
            */
            this.DropCourse = async function (student_id, from_course_code, start_date) {
                try {
                    const payload = {
                        id: student_id,
                        student_id: student_id,
                        from_course_code: from_course_code,
                        start_date: start_date
                    };
                    await Vue.prototype.$XHR.api('drop_course', payload);
                    devLog('----------> XHR [SUCCESS]: DropCourse');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DropCourse');
                    devLog(res);
                    switch (res.data) {
                        case "order status not allow switch":
                            return Promise.reject('message.lessonUnpaidDisableDrop');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
            * 退堂（單一課堂）
            */
            this.DropLesson = async function (lesson_id, student_id) {
                const payload = {
                    id: lesson_id,
                    student_id
                }

                try {
                    await Vue.prototype.$XHR.api('drop_lesson', {
                        ...payload,
                        status: 'drop',
                        to_course: '',
                        to_lesson: -1,
                    });
                    devLog('----------> XHR [SUCCESS]: DropLesson 1');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog(res);
                    if (res.result === '404') {
                        devLog('----------> XHR [FAIL]: DropLesson 1: 404');
                    } else {
                        devLog('----------> XHR [FAIL]: DropLesson 1');
                        switch (res.data) {
                            case "order status not allow switch":
                                return Promise.reject('message.lessonUnpaidDisableDrop');
                            default:
                                return Promise.reject(displayError(res));
                        }
                    }
                }

                try {
                    await Vue.prototype.$XHR.api('remove_student', payload);
                    await Vue.prototype.$XHR.api('remove_student_from_lesson', payload);
                    devLog('----------> XHR [SUCCESS]: DropLesson 2');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DropLesson 2');
                    devLog(res);
                    switch (res.data) {
                        case "order status not allow switch":
                            return Promise.reject('message.lessonUnpaidDisableDrop');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
             * 課堂進度
             * ==== Required ====
             * @param {String} progress
             * @param {String} comment
             * ==== Optional ====
             * @param {String} video_id
             */
            this.NewLessonProgress = async function (student_id, lesson_id, payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const uploaded = {
                        student_id,
                        lesson_id,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('new_progress', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewLessonProgress');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewLessonProgress');
                    devLog(res);
                    switch (res.data) {
                        case 'please upload a video':
                            return Promise.reject('message.vimeoUploadNotDone');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateLessonProgress = async function (id, payload) {
                try {
                    const uploaded = {
                        id,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_progress', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateLessonProgress');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateLessonProgress');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetLessonProgresses = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'progress_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetLessonProgresses');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessonProgresses');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetLatestProgress = async function (student_id, lesson_id) {
                try {
                    const payload = {
                        student_id,
                        lesson_id
                    };
                    const data = await Vue.prototype.$XHR.api('latest_progress', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetLatestProgress');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLatestProgress');
                    devLog(res);
                    return Promise.resolve(null);
                }
            }
            this.DeleteLessonProgress = async function (id) {
                try {
                    const uploaded = {
                        id
                    }

                    // TODO: if need
                    await Vue.prototype.$XHR.api('', uploaded);
                    devLog('----------> XHR [SUCCESS]: DeleteLessonProgress');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteLessonProgress');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
             * 請假備註
             * ==== Required ====
             * @param {String} comment
             */
            this.NewLeaveRemark = async function (student_id, lesson_id, payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const uploaded = {
                        student_id,
                        lesson_id,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('new_leave', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewLeaveRemark');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewLeaveRemark');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateLeaveRemark = async function (id, payload) {
                try {
                    const uploaded = {
                        id,
                        ...payload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_leave', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateLeaveRemark');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateLeaveRemark');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetLeaveRemarks = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'leave_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetLeaveRemarks');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLeaveRemarks');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }

            /**
             * 學員回饋
             */
            this.GetLatestFeedback = async function (student_id, lesson_id) {
                try {
                    const payload = {
                        student_id,
                        lesson_id
                    };
                    const data = await Vue.prototype.$XHR.api('latest_feedback', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetLatestFeedback');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLatestFeedback');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject(null);
                    }
                }
            }

            this.ConfirmTutorAttendance = async function (lesson_id, staff_id, status) {
                try {
                    const get_lesson = await vm.GetLessonById(lesson_id);
                    const attendanceList = JSON.parse(JSON.stringify(get_lesson.tutor_attendance));
                    let updated = false;
                    for (let i = attendanceList.length - 1; i >= 0; i--) {
                        if (attendanceList[i].staff_id === staff_id) {
                            attendanceList[i].confirm_time = await Vue.prototype.$XHR.serverTime();
                            if (attendanceList[i].status !== status) {
                                attendanceList[i].status = status;
                                if (status === 'attend') {
                                    attendanceList[i].attend_time = await Vue.prototype.$XHR.serverTime();
                                } else {
                                    attendanceList[i].attend_time = '';
                                }
                            }
                            updated = true;
                            break;
                        }
                    }

                    if (updated) {
                        let payload = {
                            id: lesson_id,
                        }
                        payload[LESSON_MODEL.tutor_attendance] = attendanceList;

                        console.log("ConfirmTutorAttendance")
                        console.log(payload)
                        return Promise.reject(displayError(res));

                        const data = await Vue.prototype.$XHR.api('edit_lesson', payload);
                        const formattedData = parseLessonData(data);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: ConfirmTutorAttendance');

                            let targetAttendance = null;
                            for (let i = formattedData.tutor_attendance.length - 1; i >= 0; i--) {
                                if (formattedData.tutor_attendance[i].staff_id === staff_id) {
                                    targetAttendance = formattedData.tutor_attendance[i];
                                    break;
                                }
                            }
                            if (targetAttendance) {
                                devLog(targetAttendance)
                                return Promise.resolve(targetAttendance);
                            }
                        }
                        throw 'message.errorOccur';
                    } else {
                        throw 'attendance not found';
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ConfirmTutorAttendance');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject(displayError(res));
                    }
                }
            }






            /**
             * 繳交學費
             * @param {Array<key: string, value: any>} filter_item
             * - with_monthly: filter student with monthly package
             * @param {String} with_order
             * - '': get user's order
             * - 'extra'
             * - 'pending'
             * - 'missing': 本月未開學費單 filter student with lesson missing order (with lesson date <= this month)
             */
            this.GetPayTuitions = async function (filters = {}) {
                try {
                    const joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const payload = {
                        data_type: 'student_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const schoolData = joinSchoolData ? await GetAllSchools() : [];
                        const formattedData = data['data'].map(el => parsePayTuitionData(el, [], schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPayTuitions');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPayTuitions');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetPayTuitionsNew = async function (filters = {}) {
                try {
                    const joinSchoolData = filters['join_school_data'] || false;
                    if (filters['join_school_data'] !== undefined) delete filters['join_school_data'];

                    const payload = {
                        ...filters
                    }
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_student_quote', filters);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const schoolData = joinSchoolData ? await GetAllSchools() : [];
                        const formattedData = data['data'].map(el => parsePayTuitionData(el, [], schoolData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPayTuitionsNew');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPayTuitionsNew');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetPayTuitionById = async function (id, filters = {}) {
                try {
                    const payload = {
                        data_type: 'student_data',
                        id: id
                    };

                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    let siblingData = [];
                    if (filters['join_siblings']) {
                        if (DataValid(data[STUDENT_MODEL.siblings], true)) {
                            const studentIds = data[STUDENT_MODEL.siblings].map(el => el.student_id);
                            siblingData = await vm.GetStudentsByIdList(studentIds);
                        }
                    }
                    const formattedData = parsePayTuitionData(data, siblingData);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetPayTuitionById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'noData';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPayTuitionById');
                    devLog(res);
                    if (res && (res === 'abort' || res.data === 'abort')) {
                        return Promise.reject(displayError(res));
                    } else {
                        return Promise.reject('noData');
                    }
                }
            }





            /**
             * 繳交學費
             * ==== Required ====
             * discount_type: 'percentage' | 'fix_amount'
             * if discount_type = 'percentage' --> Math.ceil(price * (discount_value/100) * 10) / 10
             * @param {Array<{id: -1, discount_type: '', discount_value: 0}>} lesson_id_list - 會將lesson assign比student & mark paid
             * @param {Array<{id: -1, discount_type: '', discount_value: 0, amount: 0 (qty)}>} product_id_list
             * @param {String} payment_method
             * @param {Number} subtotal
             * @param {String} remark
             * @param {Number} school_id
             * @param {Number} student_id
             * @param {String} status
             * @param {Array<Number>} except_lesson_id_list - 如果regular lesson，不會將該lesson assign比student
             * @param {Array<{name: "", description: "", price: 0, amount: 0}>} custom_items
             * @param {Number} staff_id - 經手人 (who create order)
             * ==== Optional ====
             * @param {String} pdf_remark
             * @param {String} payment_image - for old CMS
             * @param {String} payment_image_list - for new CMS
             * @param {String} discount_type
             * @param {Number} discount_value
             * if use coupon
             * @param {String} coupon_code - if use coupon, ignore discount_type & discount_value
             * if status == 'paid'
             * @param {String} pay_date - [YYYY-MM-DD]T[HH:MM:SS]Z
             * @param {Number} approver_id - staff id (審核付款經手人)
             * if 買package
             * @param {Number} package_id - if have (for old cms)
             * @param {Array<{id: -1, discount_type: '', discount_value: 0}>} package_id_list - if have (for new cms)
             * @param {Boolean} use_remain - case 本身有堂數剩下，如果個學生再買多個套票，會出alert問佢：會否將學生餘下的堂課數都報名這課程？
             * if 買package時加入unpaid嘅lessons
             * @param {Array<Number>} unpaid_lesson_id_list
             * if 買product用積分
             * @param {Boolean} is_redeem
             * if 買月票
             * @param {Array<{id: -1, discount_type: '', discount_value: 0}>} monthly_id_list
             * @param {Array<YYYY-MM>} selected_months - required if 買月票
             * for T21
             * @param {String} sign
             * @param {String} custom_invoice_number
             * if 有揀skip to lesson
             * @param {Array<number(lesson id)>} skip_lessons
             * if 試堂
             * @param {Array<number(lesson id)>} trial_lesson
             * 
             */
            this.NewOrder = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, ORDER_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_order', uploaded);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'lesson get fail':
                        case 'lesson not found':
                            return Promise.reject('message.courseNotFound');
                        case 'product get fail':
                        case 'product not found':
                            return Promise.reject('message.productNotFound');
                        case 'product out of inventory':
                            return Promise.reject('message.outOfStock');
                        case 'not enough points':
                            return Promise.reject('message.userPointsNotEnough');
                        case 'student_exist':
                            return Promise.reject('message.studentInLesson');
                        case 'monthly type not match':
                            return Promise.reject('message.oneOrderOneMonthPassType');
                        case 'date range exceed limit':
                        case 'lesson date not in monthly':
                            return Promise.reject('message.lessonNotInMonthPassRange');
                        case 'invalid coupon':
                            return Promise.reject('message.couponNotFound');
                        case 'user not eligible for this coupon':
                            return Promise.reject('message.noCouponPermission');
                        case 'coupon not valid for this center':
                            return Promise.reject('message.noCouponCenter');
                        case 'usage limit reached for user':
                            return Promise.reject('message.couponReachUserLimit');
                        case 'usage limit reached':
                            return Promise.reject('message.couponUseLimit');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
             * ==== Optional ====
             * @param {String} payment_method
             * @param {String} payment_image - for old CMS
             * @param {String} payment_image_list - for new CMS
             * @param {String} status
             * @param {String} remark
             * @param {String} pdf_remark
             * @param {String} order_date - [YYYY-MM-DD]T[HH:MM:SS]Z
             * @param {String} pay_date - [YYYY-MM-DD]T[HH:MM:SS]Z
             * @param {Number} approver_id - staff id (審核付款經手人)
             * @param {Number} staff_id - 經手人 (who latest edit order)
             * @param {Boolean} whatsapp_sent
             * for T21
             * @param {String} sign
             * @param {String} custom_invoice_number
             */
            this.UpdateOrder = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, ORDER_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_order', payload);
                    const formattedData = parseOrderData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetOrders = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'order_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseOrderData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetOrders');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrders');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetOrderById = async function (id) {
                try {
                    const payload = {
                        data_type: 'order_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.orderNotFound';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderById');
                    devLog(res);
                    return Promise.reject('message.orderNotFound');
                }
            }
            /**
             * 繳交學費: 修改現有order lessons
             * 同new_order一樣，但冇 `is_redeem`
             */
            this.RenewOrder = async function (order_id, payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ORDER_MODEL);
                    const uploaded = {
                        id: order_id,
                        order_id: order_id,
                        unpaid_lesson_id_list: [],
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('renew_order', uploaded);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: RenewOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RenewOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'order get fail':
                            return Promise.reject('message.orderNotFound');
                        case 'order cannot be void':
                        case 'order status is not pending':
                            return Promise.reject('message.orderNotPending');
                        case 'lesson attendance exist':
                            return Promise.reject('message.orderAttendanceExist');
                        case 'lesson get fail':
                        case 'lesson not found':
                            return Promise.reject('message.courseNotFound');
                        case 'product get fail':
                        case 'product not found':
                            return Promise.reject('message.productNotFound');
                        case 'product out of inventory':
                            return Promise.reject('message.outOfStock');
                        case 'monthly type not match':
                            return Promise.reject('message.oneOrderOneMonthPassType');
                        case 'date range exceed limit':
                        case 'lesson date not in monthly':
                            return Promise.reject('message.lessonNotInMonthPassRange');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            /**
             * ==== Required ====
             * @param {Number} amount
             * @param {Number} package_count
             * @param {Array<number>} lesson_ids
             * @param {Array<{ id: -1, amount: 0 }>} product_ids
             * ==== Optional =====
             * @param {String} debit_remark
             * @param {String} debit_payment_method
             */
            this.RefundOrder = async function (order_id, update) {
                try {
                    const payload = {
                        order_id,
                        ...update
                    }

                    const data = await Vue.prototype.$XHR.api('debit_order', payload);
                    devLog('----------> XHR [SUCCESS]: RefundOrder');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RefundOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'order missing / order debited':
                            return Promise.reject('message.orderNotFoundOrRefunded');
                        case 'package quota not enough':
                            return Promise.reject('message.packageQuotaNotEnoughRefund');
                        case 'lesson cannot debit':
                            return Promise.reject('message.lessonCannotRefund');
                        case 'over amount':
                            return Promise.reject('message.refundAmountExceedOrderTotal');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.VoidOrder = async function (order_id, quit_after = false) {
                try {
                    const payload = {
                        order_id,
                        quit_after
                    }

                    const data = await Vue.prototype.$XHR.api('void_order', payload);
                    devLog('----------> XHR [SUCCESS]: VoidOrder');
                    devLog(payload)
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: VoidOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'order get fail':
                            return Promise.reject('message.orderNotFound');
                        case 'lesson attendance exist':
                            return Promise.reject('message.restoreBeforeVoid');
                        case 'order cannot be void':
                            return Promise.reject('message.orderNotPending');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.GetOrderPaymentLink = async function (center_id, order_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('generate_order_payment_link_list', {
                        center_id,
                        order_id_list: [order_id]
                    });
                    if (DataValid(data) && data[0] && data[0].link) {
                        devLog('----------> XHR [SUCCESS]: GetOrderPaymentLink');
                        devLog(data)
                        return Promise.resolve(data[0].link);
                    }

                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderPaymentLink');
                    devLog(res);
                    return Promise.reject(res);
                }
            }

            this.GenNextMonthPreviewOrder = async function (student_id, add = 1, center_id = -1) {
                try {
                    const nextMonth = Formatter.convertDate();
                    nextMonth.setMonth(nextMonth.getMonth() + add);

                    let payload = {
                        student_id,
                        month: `${nextMonth.getFullYear()}-${Formatter.pad(nextMonth.getMonth() + 1)}`
                    };
                    if (center_id > -1) {
                        payload['center_id'] = center_id;
                    }

                    const data = await Vue.prototype.$XHR.api('extend_order_pre', payload);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GenNextMonthPreviewOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenNextMonthPreviewOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GenNextMonthPreviewOrderByStudentIds = async function (student_ids, center_id = -1) {
                try {
                    const nextMonth = Formatter.convertDate();
                    nextMonth.setMonth(nextMonth.getMonth() + 1);

                    let payload = {
                        student_list: student_ids,
                        month: `${nextMonth.getFullYear()}-${Formatter.pad(nextMonth.getMonth() + 1)}`
                    };
                    if (center_id > -1) {
                        payload['center_id'] = center_id;
                    }

                    const data = await Vue.prototype.$XHR.api('extend_order_pre_group', payload);
                    if (DataValid(data, true)) {
                        const validList = [];
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].status === 'success') {
                                validList.push({
                                    student_id: data[i].student_id,
                                    order_data: parseOrderData(data[i].result)
                                })
                            }
                        }
                        if (validList.length > 0) {
                            devLog('----------> XHR [SUCCESS]: GenNextMonthPreviewOrderByStudentIds');
                            devLog(validList)
                            return Promise.resolve(validList);
                        }
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenNextMonthPreviewOrderByStudentIds');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Required ====
             * @param {Number} student_id
             * @param {Array<number>} except_lesson_id_list - 會remove attendance
             * @param {Array<{id: -1, discount_type: '', discount_value: 0}>} lesson_id_list
             * @param {Array<{id: -1, discount_type: '', discount_value: 0, amount: 0 (qty)}>} product_id_list
             * @param {Array<{name: "", description: "", price: 0, amount: 0}>} custom_items
             * @param {Number} staff_id - 經手人 (who create order)
             * ==== Optional ====
             * @param {Number} school_id
             * @param {String} discount_type
             * @param {Number} discount_value
             * @param {String} coupon_code - if use coupon, ignore discount_type & discount_value
             * @param {String} status
             * @param {String} remark
             * @param {String} payment_method
             * @param {String} payment_image - for old CMS
             * @param {String} payment_image_list - for new CMS
             * @param {String} pdf_remark
             * @param {Number} subtotal
             * @param {Boolean} exit_attendance - If true, drop student from except_lesson_id_list
             * @param {Number} approver_id - staff id (審核付款經手人)
             * for T21
             * @param {String} sign
             */
            this.GenNextMonthOrder = async function (payload, add = 1) {
                try {
                    const nextMonth = Formatter.convertDate();
                    nextMonth.setMonth(nextMonth.getMonth() + add);

                    const formattedPayload = convertCMSKeyToBackendKey(payload, ORDER_MODEL);
                    const final = {
                        ...formattedPayload,
                        month: `${nextMonth.getFullYear()}-${Formatter.pad(nextMonth.getMonth() + 1)}`
                    };

                    const data = await Vue.prototype.$XHR.api('extend_order', final);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GenNextMonthOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenNextMonthOrder');
                    devLog(res);
                    switch (res.data) {
                        case 'lesson get fail':
                        case 'lesson not found':
                            return Promise.reject('message.courseNotFound');
                        case 'product get fail':
                        case 'product not found':
                            return Promise.reject('message.productNotFound');
                        case 'product out of inventory':
                            return Promise.reject('message.outOfStock');
                        case 'lesson id list not all lesson found match':
                            return Promise.reject('message.shouldHandleUnpaidFirst');
                        case 'invalid coupon':
                            return Promise.reject('message.couponNotFound');
                        case 'user not eligible for this coupon':
                            return Promise.reject('message.noCouponPermission');
                        case 'coupon not valid for this center':
                            return Promise.reject('message.noCouponCenter');
                        case 'usage limit reached for user':
                            return Promise.reject('message.couponReachUserLimit');
                        case 'usage limit reached':
                            return Promise.reject('message.couponUseLimit');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            this.GenPrevUnpaidPreviewOrder = async function (student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('unpaid_lesson_pre', { student_id });
                    // -- filter走from lesson，keep to lesson
                    if (DataValid(data.lesson_datas, true)) {
                        data.lesson_datas = data.lesson_datas.filter(el => !el[LESSON_MODEL.dropped_student_ids] || !el[LESSON_MODEL.dropped_student_ids].includes(student_id));
                    }
                    if (DataValid(data.lesson_id_list, true)) {
                        data.lesson_id_list = data.lesson_id_list.filter(el => {
                            const found = data.lesson_datas.find(lesson => lesson.id === el.id);
                            return found;
                        })
                    }
                    if (DataValid(data.lesson_datas, true)) {
                        const formattedData = parseOrderData(data);
                        if (DataValid(formattedData)) {
                            devLog('----------> XHR [SUCCESS]: GenPrevUnpaidPreviewOrder');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenPrevUnpaidPreviewOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            /**
             * ==== Required ====
             * @param {Number} student_id
             * @param {Array<{id: -1, discount_type: '', discount_value: 0}>} lesson_id_list
             * @param {Number} staff_id - 經手人 (who create order)
             * ==== Optional ====
             * @param {String} discount_type
             * @param {Number} discount_value
             * @param {String} status
             * @param {String} remark
             * @param {String} payment_method
             * @param {String} payment_image - for old CMS
             * @param {String} payment_image_list - for new CMS
             * @param {String} pdf_remark
             * @param {Number} subtotal
             * @param {Number} approver_id - staff id (審核付款經手人)
             * for T21
             * @param {String} sign
             */
            this.GenPrevUnpaidOrder = async function (payload) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ORDER_MODEL);
                    const final = {
                        ...formattedPayload,
                        lesson_list: payload.lesson_id_list.map(el => el.id)
                    };
                    const data = await Vue.prototype.$XHR.api('unpaid_lesson_next', final);
                    const formattedData = parseOrderData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GenPrevUnpaidOrder');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GenPrevUnpaidOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.ExportOrderInvoice = async function (order_id, regen = true) {
                try {
                    const payload = {
                        id: order_id,
                        force: regen
                    };

                    const data = await Vue.prototype.$XHR.api('export_pre_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: ExportOrderInvoice');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportOrderInvoice');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.BulkExportOrderInvoice = async function (id_list) {
                const payload = {
                    id_list
                };

                try {
                    const data = await Vue.prototype.$XHR.api('multiple_export_pre_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: BulkExportOrderInvoice');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: BulkExportOrderInvoice');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ExportOrderReceipt = async function (order_id, regen = true) {
                try {
                    const payload = {
                        id: order_id,
                        force: regen
                    };
                    const data = await Vue.prototype.$XHR.api('export_pdf', payload);
                    devLog('----------> XHR [SUCCESS]: ExportOrderReceipt');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportOrderReceipt');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.ExportOrderReport = async function (filter = {}) {
                try {
                    const payload = {
                        ...filter
                    };
                    const data = await Vue.prototype.$XHR.api('order_report', payload);
                    devLog('----------> XHR [SUCCESS]: ExportOrderReport');
                    devLog(data);
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportOrderReport');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.UpdateVoidRemark = async function (id, remark) {
                try {
                    const payload = {
                        order_id: id,
                        void_remark: remark
                    }

                    const data = await Vue.prototype.$XHR.api('add_void_remark', payload);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateVoidRemark');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOrder');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }



            /**
             * 新增套票
             */
            this.NewPackage = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, PACKAGE_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_package', uploaded);
                    const formattedData = parsePackageData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewPackage');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewPackage');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdatePackage = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, PACKAGE_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_package', payload);
                    const formattedData = parsePackageData(data);

                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdatePackage');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdatePackage');
                    devLog(res);
                    switch (res) {
                        case 'package missing':
                            return Promise.reject('message.packageNotFound');
                        case 'package purchased cannot change count':
                            return Promise.reject('message.packageCountCannotChange');
                        default:
                            return Promise.reject(displayError(res));
                    }

                }
            }
            this.DeletePackage = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('delete_package', { id });
                    devLog('----------> XHR [SUCCESS]: DeletePackage');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeletePackage');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetPackages = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'package_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(parsePackageData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetPackages');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackages');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetPackagesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'package_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data)) {
                            const formattedData = data.map(parsePackageData);
                            devLog('----------> XHR [SUCCESS]: GetPackagesByIdList');
                            devLog(formattedData)
                            return Promise.resolve(formattedData);
                        }
                    }
                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackagesByIdList');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    }
                    return Promise.resolve([]);
                }
            }
            this.GetPackageById = async function (id) {
                try {
                    const payload = {
                        data_type: 'package_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parsePackageData(data);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetPackageById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetPackageById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            this.GetStudentPackageInfo = async function (student_id) {
                /**
                * attendance 已出席 (已派堂)
                * absent 已缺席 (已派堂)
                * pending 未上堂 (已派堂)
                * debit (已退款)
                * skip 跳堂 (for reference only)
                */
                let info = {
                    quota_total: 0, // 已購買總堂數
                    quota_used_attend: 0, // 已使用堂數 (出席)
                    quota_used_absent: 0, // 已使用堂數 (缺席)
                    quota_used_pending: 0, // 待出席
                    quota_available: 0, // 未指派課堂
                    quota_can_use: 0, // 可用堂數 = 未指派課堂 + 待出席
                    unpaid_quota_used_attend: 0, // 未付已使用堂數 (出席)
                    unpaid_quota_used_absent: 0, // 未付已使用堂數 (缺席)
                    unpaid_quota_used_pending: 0, // 未付待出席
                };

                const payload = { student_id };

                // 先用 new_check_package，fail就用舊
                try {
                    const data = await Vue.prototype.$XHR.api('new_check_package', payload);
                    devLog('----------> XHR [SUCCESS NEW]: GetStudentPackageInfo');
                    devLog(data)

                    if (DataValid(data, true)) {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i]['course_category_id'] === -1 && data[i]['course_id'] === -1) {
                                info.quota_total += data[i].total;
                                info.quota_used_attend += data[i].attendance;
                                info.quota_used_absent += data[i].absent;
                                info.quota_used_pending += data[i].pending;
                                info.quota_available += (data[i].total - data[i].attendance - data[i].absent - data[i].pending - data[i].debit);
                                info.unpaid_quota_used_attend += data[i].unpaid_attendance??0;
                                info.unpaid_quota_used_absent += data[i].unpaid_absent??0;
                                info.unpaid_quota_used_pending += data[i].unpaid_pending??0;
                            }
                        }
                    }

                    if (info.quota_available < 0) {
                        info.quota_available = 0;
                    }
                    info.quota_can_use = info.quota_available + info.quota_used_pending;

                    devLog(info);
                    return Promise.resolve(info);
                } catch (res) {
                    devLog('----------> XHR [FAIL NEW]: GetStudentPackageInfo');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    }
                }

                try {
                    const data = await Vue.prototype.$XHR.api('check_package', payload);
                    devLog('----------> XHR [SUCCESS OLD]: GetStudentPackageInfo');
                    devLog(data)

                    if (data) {
                        info.quota_total = data.total;
                        info.quota_used_attend = data.attendance;
                        info.quota_used_absent = data.absent;
                        info.quota_used_pending = data.pending;
                        info.quota_available = data.total - data.attendance - data.absent - data.pending - data.debit;
                    }

                    if (info.quota_available < 0) {
                        info.quota_available = 0;
                    }
                    info.quota_can_use = info.quota_available + info.quota_used_pending;

                    devLog(info);
                    return Promise.resolve(info);
                } catch (res) {
                    devLog('----------> XHR [FAIL OLD]: GetStudentPackageInfo');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    }
                }

                return Promise.resolve(info);
            }
            // 未派堂
            this.GetStudentPackageQuota = async function (student_id) {
                try {
                    const info = await vm.GetStudentPackageInfo(student_id);
                    devLog('----------> XHR [SUCCESS]: GetStudentPackageQuota: ' + info.quota_available);
                    return Promise.resolve(info.quota_available);
                } catch {
                    devLog('----------> XHR [FAIL]: GetStudentPackageQuota');
                    return Promise.resolve(0);
                }
            }





            /**
            * 報表
            */
            this.ExportReport = async function (key, payload) {
                try {
                    const data = await Vue.prototype.$XHR.api(key, payload);
                    devLog('----------> XHR [SUCCESS]: ExportReport');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ExportReport');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
            * 調堂要求
            */
            this.GetRequirements = async function (filters = {}) {
                try {
                    const joinStudentData = filters['join_student_data'] || false;
                    if (filters['join_student_data'] !== undefined) delete filters['join_student_data'];

                    const joinLessonData = filters['join_lesson_data'] || false;
                    if (filters['join_lesson_data'] !== undefined) delete filters['join_lesson_data'];

                    const payload = {
                        data_type: 'request_switch_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let studentData = [];
                        if (joinStudentData) {
                            const list = mapIds(data['data'], 'student_id');
                            studentData = await vm.GetStudentsByIdList(list);
                        }

                        let lessonData = [];
                        if (joinLessonData) {
                            const fromList = data['data'].map(el => el.from_lesson);
                            const toList = data['data'].map(el => el.to_lesson);
                            lessonData = await vm.GetLessonsByIdList([...fromList, ...toList]);
                        }
                        const formattedData = data['data'].map(el => parseRequirementData(el, studentData, lessonData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetRequirements');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetRequirements');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.ApproveRequirements = async function (id_list) {
                try {
                    const uploaded = {
                        id_list
                    }

                    const data = await Vue.prototype.$XHR.api('multiple_approve_switch_request', uploaded);
                    devLog('----------> XHR [SUCCESS]: ApproveRequirements');
                    devLog(data)
                    if (data.length) {
                        const errors = [];
                        data.forEach(item => {
                            if (item.result !== 'switch success') {
                                let msg = '';
                                switch (item.result) {
                                    case 'data missing':
                                        msg = 'message.switchRequestNotFound';
                                        break;
                                    case 'lesson already switch':
                                    case 'lesson already rejected':
                                        msg = 'message.switchRequestAlreadyHandle';
                                        break;
                                    default:
                                        msg = displayError(item.result);
                                        break;
                                }

                                errors.push({ ...item, error_msg: msg });
                            }

                        })

                        if (errors.length > 0) {
                            return Promise.resolve(errors);
                        } else {
                            return Promise.resolve(true);
                        }
                    } else {
                        return Promise.resolve(true);
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: ApproveRequirements');
                    devLog(res);
                    switch (res.data) {
                        case 'data missing':
                            return Promise.reject('message.switchRequestNotFound');
                        case 'lesson already switch':
                        case 'lesson already rejected':
                            return Promise.reject('message.switchRequestAlreadyHandle');
                        case 'target lesson already in order':
                            return Promise.reject('message.lessonInOrder');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.RejectRequirements = async function (id_list) {
                try {
                    const uploaded = {
                        id_list
                    }

                    const data = await Vue.prototype.$XHR.api('multiple_reject_switch_request', uploaded);
                    devLog('----------> XHR [SUCCESS]: RejectRequirements');
                    devLog(data)
                    if (data.length) {
                        const errors = [];
                        data.forEach(item => {
                            if (item.result !== 'switch success') {
                                let msg = '';
                                switch (item.result) {
                                    case 'data missing':
                                        msg = 'message.switchRequestNotFound';
                                        break;
                                    case 'lesson already switch':
                                    case 'lesson already rejected':
                                        msg = 'message.switchRequestAlreadyHandle';
                                        break;
                                    default:
                                        msg = displayError(item.result);
                                        break;
                                }

                                errors.push({ ...item, error_msg: msg });
                            }
                        })

                        if (errors.length > 0) {
                            return Promise.resolve(errors);
                        } else {
                            return Promise.resolve(true);
                        }
                    } else {
                        return Promise.resolve(true);
                    }
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: RejectRequirements');
                    devLog(res);
                    switch (res.data) {
                        case 'data missing':
                            return Promise.reject('message.switchRequestNotFound');
                        case 'lesson already switch':
                            return Promise.reject('message.switchRequestAlreadyHandle');
                        case 'target lesson already in order':
                            return Promise.reject('message.lessonInOrder');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            /**
             * 假期
             * ==== Required ====
             * @param {Array<{ date: "", summary: "", center_id: -1 }>} dates 
             * ==== Optional ====
             * @param {Number} center_id
             */
            this.NewHoliday = async function (dates, skip_check = false, center_id = -1) {
                const vevent = dates.map(el => {
                    return {
                        "dtstart": [el.date.replace(/-/g, "")],
                        "summary": el.summary || ""
                    };
                });

                const payload = {
                    import_data: {
                        vcalendar: [{
                            vevent: vevent
                        }]
                    },
                    skip_check,
                    center_id
                }

                try {
                    const data = await Vue.prototype.$XHR.api('import_holiday', payload);
                    if (DataValid(data.imported, true)) {
                        devLog('----------> XHR [SUCCESS]: NewHoliday');
                        devLog(data)
                        return Promise.resolve(data);
                    } else if (DataValid(data.fail, true)) {
                        devLog('----------> XHR [REPEAT]: NewHoliday');
                        devLog(data)
                        const dates = data.fail.map(el => el.date);
                        return Promise.reject({
                            error: 'date_exist',
                            data: dates
                        });
                    } else {
                        devLog('----------> XHR [NULL]: NewHoliday');
                        devLog(data)
                        return Promise.reject('message.errorOccur');
                    }
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewHoliday');
                    devLog(res);
                    let decode = null;
                    if (DataValid(res.data, true)) {
                        decode = res.data;
                    } else {
                        try {
                            const temp = JSON.parse(res.data);
                            if (DataValid(temp, true)) {
                                decode = temp;
                            }
                        } catch { }
                    }
                    if (DataValid(decode, true)) {
                        const list = [];
                        for (let i = 0; i < decode.length; i++) {
                            if (!list.includes(decode[i]) && /^\d{4}-\d{2}-\d{2}$/.test(decode[i])) {
                                list.push(decode[i]);
                            }
                        }

                        if (list.length) {
                            return Promise.reject({
                                error: 'lesson_exist',
                                data: list
                            });
                        }
                    }
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteHoliday = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('remove_holiday', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteHoliday');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteHoliday');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetHolidays = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'holiday_data',
                        order_by: 'date',
                        sort_dir: 'desc',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetHolidays');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetHolidays');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetHolidaysWithCenter = async function (center_id = -1) {
                try {
                    const { data } = await vm.GetHolidays({ center_id: center_id });
                    const list = [];
                    for (let i = 0; i < data.length; i++) {
                        let newAdd = true
                        for (let j = 0; j < list.length; j++) {
                            if (data[i].date === list[j].date) {
                                if (data[i].center_id === center_id) {
                                    list[j].name = data[i].name
                                }
                                newAdd = false
                                break
                            }
                        }

                        if (newAdd) {
                            list.push({
                                date: data[i].date,
                                name: data[i].name || '',
                            })
                        }
                    }
                    devLog('----------> XHR [SUCCESS]: GetHolidaysWithCenter');
                    devLog(list);
                    return Promise.resolve(list);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetHolidaysWithCenter');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.resolve([]);
                    }
                }
            }
            this.GetHolidayByDateAndCenter = async function (date, center_id) {
                const payload = {
                    date,
                    center_id
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_holiday', payload);
                    devLog('----------> XHR [SUCCESS]: GetHolidayByDateAndCenter');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetHolidayByDateAndCenter');
                    devLog(res);
                    return Promise.reject('message.holidayNotFound');
                }
            }





            /**
             * 推送通知
             * ==== Required ====
             * @param {String} title
             * @param {String} content
             * @param {String} send_date - [YYYY-MM-DD]T[HH:MM:SS]Z
             * @param {String} send_type - all | student | lesson
             * ==== Optional ====
             * @param {Array<number>} students - when type = 'student'
             * @param {Number} lesson - when type = 'lesson'
             */
            this.NewNotify = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_notification', payload);
                    const formattedData = parseNotifyData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewNotify');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewNotify');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateNotify = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('update_notification', payload);
                    const formattedData = parseNotifyData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateNotify');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateNotify');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteNotify = async function (id) {
                try {
                    const payload = {
                        id: id,
                        active: false
                    }

                    const data = await Vue.prototype.$XHR.api('update_notification', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteNotify');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteNotify');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetNotifies = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'notification_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'].map(parseNotifyData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetNotifies');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetNotifies');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetNotifyById = async function (id) {
                try {
                    const payload = {
                        data_type: 'notification_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseNotifyData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetNotifyById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetNotifyById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * Blog Category
             * ==== Required ====
             * @param {String} name
             */
            this.NewBlogCategory = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_blog_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewBlogCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewBlogCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateBlogCategory = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('update_blog_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateBlogCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBlogCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteBlogCategory = async function (id) {
                try {
                    const payload = {
                        id: id,
                        active: false
                    }

                    const data = await Vue.prototype.$XHR.api('update_blog_category', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteBlogCategory');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteBlogCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetBlogCategories = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'blog_category_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        devLog('----------> XHR [SUCCESS]: GetBlogCategories');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogCategories');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            const GetBlogCategoriesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'blog_category_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            devLog('----------> XHR [SUCCESS]: GetBlogCategoriesByIdList');
                            devLog(data)
                            return Promise.resolve(data);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetBlogCategoryById = async function (id) {
                try {
                    const payload = {
                        data_type: 'blog_category_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetBlogCategoryById');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * Blog
             * ==== Required ====
             * @param {String} title
             * @param {String} content
             * 
             */
            this.NewBlog = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_blog', payload);
                    const formattedData = parseBlogData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewBlog');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewBlog');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateBlog = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('update_blog', payload);
                    const formattedData = parseBlogData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateBlog');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateBlog');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteBlog = async function (id) {
                try {
                    const payload = {
                        id: id,
                        active: false
                    }

                    const data = await Vue.prototype.$XHR.api('update_blog', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteBlog');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteBlog');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetBlogs = async function (filters = {}) {
                try {
                    const joinCategoryData = filters['join_category_data'] || false;
                    if (filters['join_category_data'] !== undefined) delete filters['join_category_data'];

                    const payload = {
                        data_type: 'blog_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let categoryData = [];
                        if (joinCategoryData) {
                            const idList = mapIds(data['data'], 'category');
                            categoryData = await GetBlogCategoriesByIdList(idList);
                        }

                        const formattedData = data['data'].map(el => parseBlogData(el, categoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetBlogs');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogs');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetBlogById = async function (id) {
                try {
                    const payload = {
                        data_type: 'blog_data',
                        id: id
                    };

                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseBlogData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetBlogById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetBlogById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 教學影片 Category
             * ==== Required ====
             * @param {String} name
             */
            this.NewVideoCategory = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_tutorial_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewVideoCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewVideoCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateVideoCategory = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('update_tutorial_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateVideoCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateVideoCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteVideoCategory = async function (id) {
                try {
                    const payload = {
                        id: id,
                        active: false
                    }

                    const data = await Vue.prototype.$XHR.api('update_tutorial_category', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteVideoCategory');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteVideoCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetVideoCategories = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'tutorial_category_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetVideoCategories');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVideoCategories');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            const GetVideoCategoriesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'tutorial_category_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            devLog('----------> XHR [SUCCESS]: GetVideoCategoriesByIdList');
                            devLog(data)
                            return Promise.resolve(data);
                        }
                    }

                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVideoCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetVideoCategoryById = async function (id) {
                try {
                    const payload = {
                        data_type: 'tutorial_category_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetVideoCategoryById');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVideoCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 教學影片
             * ==== Required ====
             * @param {Number} category
             * @param {Number} video_id
             * ==== Optional ====
             * @param {String} custom_video_title
             * @param {String} thumbnail
             */
            this.NewVideo = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_tutorial', payload);
                    const formattedData = parseVideoData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewVideo');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewVideo');
                    devLog(res);
                    switch (res.data) {
                        case 'please upload a video':
                            return Promise.reject('message.vimeoUploadNotDone');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateVideo = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('update_tutorial', payload);
                    const formattedData = parseVideoData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateVideo');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateVideo');
                    devLog(res);
                    switch (res.data) {
                        case 'please upload a video':
                            return Promise.reject('message.vimeoUploadNotDone');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.DeleteVideo = async function (id) {
                try {
                    const payload = {
                        id: id,
                        active: false
                    }

                    const data = await Vue.prototype.$XHR.api('update_tutorial', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteVideo');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteVideo');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetVideos = async function (filters = {}) {
                try {
                    const joinCategoryData = filters['join_category_data'] || false;
                    if (filters['join_category_data'] !== undefined) delete filters['join_category_data'];

                    const payload = {
                        data_type: 'tutorial_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        let categoryData = [];
                        if (joinCategoryData) {
                            const idList = mapIds(data['data'], 'category');
                            categoryData = await GetVideoCategoriesByIdList(idList);
                        }

                        const formattedData = data['data'].map(el => parseVideoData(el, categoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetVideos');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVideos');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetVideoById = async function (id) {
                try {
                    const payload = {
                        data_type: 'tutorial_data',
                        id: id
                    };

                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseVideoData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetVideoById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVideoById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }

            /**
             * ==== Required ====
             * @param {String} access_token
             * @param {String} refresh_token
             * ==== Optional ====
             * @param {String} custom_video_title
             */
            this.CreateVimeoVideo = async function (file, payload) {
                try {
                    const uploaded = {
                        ...payload
                    }
                    const data = await Vue.prototype.$XHR.post({
                        'cms_create_vimeo_video_link': JSON.stringify(uploaded),
                        file: file
                    });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: CreateVimeoVideo');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CreateVimeoVideo');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteUnusedVimeoVideo = async function (video_id_list, access_token, refresh_token) {
                try {
                    const payload = {
                        video_id_list,
                        access_token,
                        refresh_token
                    }

                    const data = await Vue.prototype.$XHR.api('cms_delete_vimeo_video_list', payload);
                    devLog('----------> XHR [SUCCESS]: DeleteUnusedVimeoVideo');
                    devLog(data)
                    return Promise.resolve(data);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteUnusedVimeoVideo');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetVimeoVideos = async function (filters = {}) {
                const payload = {
                    ...filters
                };

                try {
                    const data = await Vue.prototype.$XHR.api('get_vimeo_progress_video_list', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetVimeoVideos');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetVimeoVideos');
                    devLog(res);
                    switch (res.data) {
                        case 'refresh token expired':
                        case 'invalid refresh token':
                        case 'invalid refresh token payload':
                        case 'not a refresh token':
                        case 'invalid access token payload':
                        case 'not a access token':
                        case 'access token and refresh token is not a pair':
                            return Promise.reject('message.loginExpired');
                        default:
                            return Promise.reject(null);
                    }
                }
            }





            /**
             * 線上課程分類
             * ==== Required ====
             * @param {String} name
             */
            this.NewOnlineCourseCategory = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const data = await Vue.prototype.$XHR.api('new_online_course_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewOnlineCourseCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOnlineCourseCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateOnlineCourseCategory = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const data = await Vue.prototype.$XHR.api('edit_online_course_category', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOnlineCourseCategory');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOnlineCourseCategory');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteOnlineCourseCategory = async function (id) {
                try {
                    const data = await Vue.prototype.$XHR.api('remove_online_course_category', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteOnlineCourseCategory');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteOnlineCourseCategory');
                    devLog(res);
                    switch (res.data) {
                        case 'online course category has been used':
                            return Promise.reject('message.categoryDeleteNotAllowed');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.GetOnlineCourseCategories = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'online_course_category_data',
                        sort_dir: 'asc',
                        order_by: 'sort_order',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetOnlineCourseCategories');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOnlineCourseCategories');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            const GetOnlineCourseCategoriesByIdList = async function (id_list, filters = {}) {
                try {
                    if (DataValid(id_list, true)) {
                        const payload = {
                            data_type: 'online_course_category_data',
                            id_list: id_list,
                            ...filters
                        };
                        const data = await Vue.prototype.$XHR.api('get_data_by_id_list', payload);
                        if (DataValid(data, true)) {
                            devLog('----------> XHR [SUCCESS]: GetOnlineCourseCategoriesByIdList');
                            devLog(data)
                            return Promise.resolve(data);
                        }
                    }
                    throw [];
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOnlineCourseCategoriesByIdList');
                    devLog(res);
                    return Promise.resolve([]);
                }
            }
            this.GetOnlineCourseCategoryById = async function (id) {
                try {
                    const payload = {
                        data_type: 'online_course_category_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetOnlineCourseCategoryById');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOnlineCourseCategoryById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateOnlineCourseCategorySort = async function (id_list) {
                try {
                    const data = await Vue.prototype.$XHR.api('update_online_course_category_order', { id_list });
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOnlineCourseCategorySort');
                        devLog(data)
                        return Promise.resolve(true);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOnlineCourseCategorySort');
                    devLog(res);
                    if (res.data === 'nothing needs to be updated') {
                        return Promise.resolve(true);
                    } else {
                        return Promise.reject(displayError(res));
                    }
                }
            }





            /**
             * 線上課程
             * ==== Required ====
             * @param {String} name
             * @param {Number} category_id
             * ==== Optional ====
             * @param {String} status - active | inactive
             * @param {String} short_description
             * @param {String} thumbnail
             * @param {String} description_content
             * @param {Number} price
             * @param {Number} discount_price
             * @param {Array<{title: '', chapter_id_list: []}>} chapter_category_list - new course 時 chapter_id_list比empty array
             * @param {Array<{name: '', description: '', icon: ''}>} tutor_information
             * @param {Array<{question: '', answer: ''}>} faq_list
             */
            this.NewOnlineCourse = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ONLINE_COURSE_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }
                    const data = await Vue.prototype.$XHR.api('new_online_course', uploaded);
                    const formattedData = parseOnlineCourseData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewOnlineCourse');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOnlineCourse');
                    devLog(res);
                    switch (res.data) {
                        case 'online course category not found':
                            return Promise.reject('message.onlineCourseCategoryNotFound');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateOnlineCourse = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, ONLINE_COURSE_MODEL);
                    const data = await Vue.prototype.$XHR.api('edit_online_course', formattedPayload);
                    const formattedData = parseOnlineCourseData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOnlineCourse');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOnlineCourse');
                    devLog(res);
                    switch (res.data) {
                        case 'online course category not found':
                            return Promise.reject('message.onlineCourseCategoryNotFound');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.DeleteOnlineCourse = async function (id) {
                try {
                    const data = await Vue.prototype.$XHR.api('remove_online_course', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteOnlineCourse');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteOnlineCourse');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetOnlineCourses = async function (filters = {}) {
                try {
                    const joinCategoryData = filters['join_category_data'] || false;
                    if (filters['join_category_data'] !== undefined) delete filters['join_category_data'];

                    const payload = {
                        data_type: 'online_course_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }

                    const data = await Vue.prototype.$XHR.api('get_online_course_list', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        let categoryData = [];
                        if (joinCategoryData) {
                            const idList = mapIds(data['data'], ONLINE_COURSE_MODEL.category_id);
                            categoryData = await GetOnlineCourseCategoriesByIdList(idList);
                        }

                        const formattedData = data['data'].map(el => parseOnlineCourseData(el, categoryData));
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetOnlineCourses');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOnlineCourses');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            /**
             * ==== Required ====
             * @param {String} access_token
             * @param {String} refresh_token
             * ==== Optional ====
             * @param {Boolean} get_chapter_data
             */
            this.GetOnlineCourseById = async function (id, payload) {
                try {
                    const uploaded = {
                        id,
                        ...payload
                    };

                    const data = await Vue.prototype.$XHR.api('get_online_course_by_id', uploaded);
                    const formattedData = parseOnlineCourseData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: GetOnlineCourseById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOnlineCourseById');
                    devLog(res);
                    switch (res.data) {
                        case 'refresh token expired':
                        case 'invalid refresh token':
                        case 'invalid refresh token payload':
                        case 'not a refresh token':
                        case 'invalid access token payload':
                        case 'not a access token':
                        case 'access token and refresh token is not a pair':
                            return Promise.reject('message.loginExpired');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }

            /**
             * 線上課程 - 影片
             * ==== Required ====
             * @param {String} title
             * @param {Number} online_course_id
             * @param {Number} duration
             * @param {String} video_id
             * ==== Optional ====
             * @param {String} description_content
             * @param {String} thumbnail
             * @param {Array<{title: '', file: ''}>} homework
             */
            this.NewOnlineCourseVideo = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, ONLINE_COURSE_VIDEO_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_online_course_chapter', uploaded);
                    const formattedData = parseOnlineCourseVideoData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewOnlineCourseVideo');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewOnlineCourseVideo');
                    devLog(res);
                    switch (res.data) {
                        case 'please upload a video':
                            return Promise.reject('message.vimeoUploadNotDone');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateOnlineCourseVideo = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, ONLINE_COURSE_VIDEO_MODEL);
                    const data = await Vue.prototype.$XHR.api('edit_online_course_chapter', formattedPayload);
                    const formattedData = parseOnlineCourseVideoData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateOnlineCourseVideo');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateOnlineCourseVideo');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 月票管理
             */
            this.NewMonthPass = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, MONTH_PASS_MODEL);
                    const uploaded = {
                        ...formattedPayload,
                    }
                    const data = await Vue.prototype.$XHR.api('new_monthly', uploaded);
                    const formattedData = parseMonthPassData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewMonthPass');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewMonthPass');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateMonthPass = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }

                    const formattedPayload = convertCMSKeyToBackendKey(payload, MONTH_PASS_MODEL);
                    const data = await Vue.prototype.$XHR.api('edit_monthly', formattedPayload);
                    const formattedData = parseMonthPassData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateMonthPass');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateMonthPass');
                    devLog(res);
                    switch (res.data) {
                        case 'monthly missing':
                            return Promise.reject('message.monthPassNotFound');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.DeleteMonthPass = async function (id) {
                try {
                    const data = await Vue.prototype.$XHR.api('remove_monthly', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteMonthPass');
                    devLog(data)
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteMonthPass');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetMonthPasses = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'monthly_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(parseMonthPassData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetMonthPasses');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetMonthPasses');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetMonthPassById = async function (id) {
                try {
                    const payload = {
                        data_type: 'monthly_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseMonthPassData(data);

                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetMonthPassById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetMonthPassById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * 組別管理
             */
            this.NewGrade = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const uploaded = {
                        ...payload,
                    }
                    const data = await Vue.prototype.$XHR.api('new_grade', uploaded);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: NewGrade');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewGrade');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateGrade = async function (id, update) {
                try {
                    let payload = {
                        id: id,
                        ...update
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    if (Object.prototype.hasOwnProperty.call(payload, 'sort_order')) {
                        delete payload['sort_order'];
                    }

                    const data = await Vue.prototype.$XHR.api('edit_grade', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: UpdateGrade');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateGrade');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.UpdateGradeSorting = async function (from, to) {
                try {
                    let payload = {
                        from,
                        to
                    }
                    await Vue.prototype.$XHR.api('swap_grade_order', payload);
                    devLog('----------> XHR [SUCCESS]: UpdateGradeSorting');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateGradeSorting');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            const GetGradeById = async function (id) {
                try {
                    const payload = {
                        data_type: 'grade_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetGradeById');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetGradeById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.DeleteGrade = async function (id) {
                let pass = true;
                try {
                    const data = await GetGradeById(id);
                    const { data: lessons } = await vm.GetLessons({
                        filter_page: 0,
                        filter_limit: 1,
                        filter_item: [{ key: 'grade', value: data.grade_key }],
                    })
                    if (lessons.length > 0) {
                        pass = false;
                    }
                } catch { }


                try {
                    if (!pass) throw 'message.gradeDeleteNotAllowed';

                    await Vue.prototype.$XHR.api('remove_grade', { id });
                    devLog('----------> XHR [SUCCESS]: DeleteGrade');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteGrade');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetGrades = async function () {
                try {
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', {
                        data_type: 'grade_data',
                        order_by: 'sort_order',
                        sort_dir: 'asc'
                    });
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetGrades');
                        devLog(data['data'])
                        return Promise.resolve(data['data']);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetGrades');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }





            /**
             * Log Record
             */
            const GetLogs = async function (id, data_type, filters = {}) {
                try {
                    const payload = {
                        id,
                        data_type
                    };

                    const data = await Vue.prototype.$XHR.api('get_edit_log', payload);
                    if (DataValid(data, true)) {
                        const _allData = [];
                        for (let i = 0; i < data.length; i++) {
                            if (DataValid(data[i]) && DataValid(data[i].data) && DataValid(data[i].data.id)) {
                                _allData.push(data[i].data);
                            } else if (DataValid(data[i]) && DataValid(data[i].id)) {
                                _allData.push(data[i]);
                            }
                        }
                        _allData.sort((a, b) => Formatter.sortDate(a.create_date, b.create_date));
                        const allData = [];
                        for (let i = _allData.length - 1; i >= 0; i--) {
                            allData.push(_allData[i]);
                        }

                        let list = [];
                        if (DataValid(filters.page) && DataValid(filters.limit)) {
                            for (let i = (filters.page * filters.limit); i < (filters.page * filters.limit + filters.limit); i++) {
                                if (DataValid(allData[i])) {
                                    list.push(allData[i]);
                                } else {
                                    break;
                                }
                            }
                        } else {
                            list = allData;
                        }

                        const studentIds = [];
                        const staffIds = [];
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].account_type === 'student') {
                                studentIds.push(list[i]['account_id']);
                            } else {
                                staffIds.push(list[i]['account_id']);
                            }
                        }
                        let students = [];
                        let staffs = [];
                        if (studentIds.length) {
                            students = await vm.GetStudentsByIdList(studentIds);
                        }
                        if (staffIds.length) {
                            staffs = await vm.GetStaffsByIdList(staffIds);
                        }

                        const formattedData = [];
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].account_type === 'student') {
                                const found = students.find(el => el.id === list[i]['account_id']);
                                const d = parseLogData(list[i], found ? { name: found.username, user_type: 'student' } : null);
                                formattedData.push(d);
                            } else {
                                const found = staffs.find(el => el.id === list[i]['account_id']);
                                const d = parseLogData(list[i], found ? { name: found.username, user_type: found.user_type } : null);
                                formattedData.push(d);
                            }
                        }

                        devLog('----------> XHR [SUCCESS]: GetLogs');
                        devLog(formattedData)
                        return Promise.resolve({
                            total: data.length,
                            data: formattedData
                        });
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLogs');
                    devLog(res);
                    if (res && (DataValid(res.data) && res.data === 'abort' || res === 'abort')) {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetStudentLogs = async function (student_id, filters = {}) {
                try {
                    const data = await GetLogs(student_id, 'student_data', filters);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetStudentLogs');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetStudentLogs');
                    devLog(res);
                    if (res && (DataValid(res.data) && res.data === 'abort' || res === 'abort')) {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetLessonLogs = async function (lesson_id, filters = {}) {
                try {
                    const data = await GetLogs(lesson_id, 'lesson_data', filters);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetLessonLogs');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetLessonLogs');
                    devLog(res);
                    if (res && (DataValid(res.data) && res.data === 'abort' || res === 'abort')) {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetOrderLogs = async function (order_id, filters = {}) {
                try {
                    const data = await GetLogs(order_id, 'order_data', filters);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetOrderLogs');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetOrderLogs');
                    devLog(res);
                    if (res && (DataValid(res.data) && res.data === 'abort' || res === 'abort')) {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }

            this.GetActionLogs = async function (filter) {
                try {
                    const payload = filter;
                    const data = await Vue.prototype.$XHR.api('get_action_logs', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'])) {
                        const formattedData = data['data'];
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };
                        devLog('----------> XHR [SUCCESS]: GetActionLogs');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetActionLogs');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }



            /**
             * 優惠券
             * ======= Required ======
             * @param {String} code
             */
            this.NewCoupon = async function (payload) {
                try {
                    if (Object.prototype.hasOwnProperty.call(payload, 'active')) {
                        delete payload['active'];
                    }
                    const formattedPayload = convertCMSKeyToBackendKey(payload, COUPON_MODEL);
                    const uploaded = {
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('new_coupon', uploaded);
                    const formattedData = parseCouponData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: NewCoupon');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: NewCoupon');
                    devLog(res);
                    switch (res.data) {
                        case 'code already exists':
                            return Promise.reject('message.couponCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.UpdateCoupon = async function (id, update) {
                try {
                    const formattedPayload = convertCMSKeyToBackendKey(update, COUPON_MODEL);
                    const payload = {
                        id: id,
                        ...formattedPayload
                    }

                    const data = await Vue.prototype.$XHR.api('edit_coupon', payload);
                    const formattedData = parseCouponData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: UpdateCoupon');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }

                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: UpdateCoupon');
                    devLog(res);
                    switch (res.data) {
                        case 'code already exists':
                            return Promise.reject('message.couponCodeExist');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }
            this.DeleteCoupon = async function (id) {
                try {
                    await Vue.prototype.$XHR.api('edit_coupon', {
                        id,
                        active: false
                    });
                    devLog('----------> XHR [SUCCESS]: DeleteCoupon');
                    return Promise.resolve(true);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: DeleteCoupon');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetCoupons = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'coupon_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        const formattedData = data['data'].map(parseCouponData);
                        const returnedData = {
                            data: formattedData,
                            total: data.total,
                        };

                        devLog('----------> XHR [SUCCESS]: GetCoupons');
                        devLog(returnedData)
                        return Promise.resolve(returnedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCoupons');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }
            this.GetCouponById = async function (id) {
                try {
                    const payload = {
                        data_type: 'coupon_data',
                        id: id
                    };
                    const data = await Vue.prototype.$XHR.api('get_data_by_id', payload);
                    const formattedData = parseCouponData(data);
                    if (DataValid(data)) {
                        devLog('----------> XHR [SUCCESS]: GetCouponById');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCouponById');
                    devLog(res);
                    return Promise.reject(displayError(res));
                }
            }
            this.GetCouponsByUser = async function (student_id) {
                try {
                    const data = await Vue.prototype.$XHR.api('available_coupon', { student_id, center_id: -1 });
                    if (DataValid(data, true)) {
                        const formattedData = data.map(parseCouponData);
                        devLog('----------> XHR [SUCCESS]: GetCouponsByUser');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCouponsByUser');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject([]);
                    }
                }
            }
            /**
             * ======= Required ======
             * @param {String} code
             * @param {Number} student_id
             * @param {Number} center_id
             */
            this.CheckCoupon = async function (payload) {
                try {
                    const data = await Vue.prototype.$XHR.api('check_coupon', payload);
                    const formattedData = parseCouponData(data);
                    if (DataValid(formattedData)) {
                        devLog('----------> XHR [SUCCESS]: CheckCoupon');
                        devLog(formattedData)
                        return Promise.resolve(formattedData);
                    }
                    throw 'message.errorOccur';
                } catch (res) {
                    devLog('----------> XHR [FAIL]: CheckCoupon');
                    devLog(res);
                    switch (res.data) {
                        case 'invalid coupon':
                            return Promise.reject('message.couponNotFound');
                        case 'user not eligible for this coupon':
                            return Promise.reject('message.noCouponPermission');
                        case 'coupon not valid for this center':
                            return Promise.reject('message.noCouponCenter');
                        case 'usage limit reached for user':
                            return Promise.reject('message.couponReachUserLimit');
                        case 'usage limit reached':
                            return Promise.reject('message.couponUseLimit');
                        default:
                            return Promise.reject(displayError(res));
                    }
                }
            }





            /**
             * 查詢
             */
            this.GetEnquiries = async function (filters = {}) {
                try {
                    const payload = {
                        data_type: 'enquiry_data',
                        ...filters
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_all_data_by_datatype', payload);
                    if (data['total'] && data['total'] > 0 && DataValid(data['data'], true)) {
                        devLog('----------> XHR [SUCCESS]: GetEnquiries');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    throw null;
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetEnquiries');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject({ data: [], total: 0 });
                    }
                }
            }

            /**
             * 取得課程學生
             */
            this.GetCourseStudents = async function (course_code) {
                try {
                    const payload = {
                        course_code:course_code
                    };
                    if (payload['filter_item'] && payload['filter_item'].length < 1) {
                        delete payload['filter_item'];
                    }
                    const data = await Vue.prototype.$XHR.api('get_course_students', payload);
                    if (DataValid(data, true)) {
                        devLog('----------> XHR [SUCCESS]: GetCourseStudents');
                        devLog(data)
                        return Promise.resolve(data);
                    }
                    return Promise.resolve([]);
                } catch (res) {
                    devLog('----------> XHR [FAIL]: GetCourseStudents');
                    devLog(res);
                    if (res && DataValid(res.data) && res.data === 'abort') {
                        return Promise.reject('abort');
                    } else {
                        return Promise.reject([]);
                    }
                }
            }
        })()
    }
}